export const de = {
  // Generic UI
  'common.signOut': 'Abmelden',
  'profile.menu': 'Mein Profil',
  'profile.title': 'Mein Profil',
  'profile.subtitle': 'Deine persönlichen Angaben: Adresse, IBAN, Foto und mehr.',
  'profile.address': 'Adresse',
  'profile.zip': 'PLZ',
  'profile.city': 'Wohnort',
  'profile.nationality': 'Nationalität',
  'profile.iban': 'IBAN',
  'profile.birthDate': 'Geburtsdatum',
  'profile.phone': 'Telefonnummer',
  'profile.uploadPhoto': 'Foto hochladen',
  'profile.removePhoto': 'Foto entfernen',
  'profile.noPhoto': 'Kein Foto',
  'profile.photoError': 'Das Bild konnte nicht verarbeitet werden.',
  'profile.saved': 'Profil gespeichert',
  'common.signIn': 'Anmelden',
  'common.email': 'E-Mail',
  'common.password': 'Passwort',
  'common.search': 'Suchen',
  'common.cancel': 'Abbrechen',
  'common.save': 'Speichern',
  'common.create': 'Erstellen',
  'common.new': 'Neu',
  'pdf.preview': 'Vorschau',
  'common.edit': 'Bearbeiten',
  'common.back': 'Zurück',
  'picker.product.placeholder': 'Produkt suchen (Artikel-Nr. oder Name)…',
  'picker.product.empty': 'Kein Produkt gefunden',
  'picker.product.create': 'Neues Produkt anlegen',
  'picker.product.required': 'Bitte für jede Position ein Produkt wählen.',
  'common.delete': 'Löschen',

  // Invoice print / PDF
  'invoice.print.viewPdf': 'Ansehen / PDF',
  'invoice.print.printOrSave': 'Drucken / Als PDF speichern',
  'invoice.print.downloadPdf': 'PDF herunterladen',
  'email.title': 'Per E-Mail senden',
  'email.intro': 'Das Dokument wird als PDF angehängt und über deinen konfigurierten SMTP-Server versendet.',
  'email.to': 'Empfänger',
  'email.subject': 'Betreff',
  'email.send': 'Per E-Mail senden',
  'email.message': 'Nachricht',
  'email.body': 'Guten Tag\n\nim Anhang finden Sie das Dokument.\n\nFreundliche Grüsse',
  'attachments.title': 'Anhänge',
  'attachments.upload': 'Datei hochladen',
  'attachments.hint': 'PDF, Bilder oder Office-Dateien bis 10 MB.',
  'attachments.empty': 'Noch keine Anhänge.',
  'attachments.delete': 'Löschen',
  'invoice.print.sendMail': 'Per E-Mail senden',
  'invoice.print.heading': 'Rechnung',
  'order.pdf.heading': 'Auftragsbestätigung',
  'quote.pdf.heading': 'Offerte',
  'quote.pdf.to': 'Offerte an',
  'quote.pdf.intro': 'Wir danken Ihnen für Ihre Anfrage und offerieren Ihnen wie folgt:',
  'quote.pdf.vatNote': 'Alle Preise in {currency}, exkl. MwSt.',
  'quote.pdf.validity': 'Diese Offerte ist gültig bis {date}.',
  'quote.pdf.closing': 'Freundliche Grüsse',
  'quote.email.title': 'Offerte an Kunde senden',
  'quote.email.subject': 'Offerte {number}',
  'quote.email.body': 'Guten Tag\n\nGerne unterbreiten wir Ihnen unsere Offerte {number}, gültig bis {validUntil}. Sie finden das Dokument im Anhang.\n\nBei Fragen stehen wir Ihnen gerne zur Verfügung.\n\nFreundliche Grüsse',
  'quote.email.markOnly': 'Nur als versendet markieren',
  'order.email.title': 'Auftragsbestätigung an Kunde senden',
  'order.email.subject': 'Auftragsbestätigung {number}',
  'order.email.body': 'Guten Tag\n\nbesten Dank für Ihren Auftrag. Im Anhang finden Sie die Auftragsbestätigung {number}.\n\nBei Fragen stehen wir Ihnen gerne zur Verfügung.\n\nFreundliche Grüsse',
  'delivery.email.title': 'Lieferschein an Kunde senden',
  'delivery.email.subject': 'Lieferschein {number}',
  'delivery.email.body': 'Guten Tag\n\nIhre Lieferung ist unterwegs. Im Anhang finden Sie den Lieferschein {number}.\n\nBei Fragen stehen wir Ihnen gerne zur Verfügung.\n\nFreundliche Grüsse',
  'delivery.email.tracking': 'Sendungsverfolgung: {tracking}',
  'invoice.email.title': 'Rechnung an Kunde senden',
  'invoice.email.subject': 'Rechnung {number}',
  'invoice.email.body': 'Guten Tag\n\nim Anhang finden Sie unsere Rechnung {number} über {amount}, zahlbar bis {dueDate}.\n\nBesten Dank für die angenehme Zusammenarbeit.\n\nFreundliche Grüsse',
  'po.pdf.heading': 'Bestellung',
  'po.pdf.to': 'Lieferant',
  'po.pdf.intro': 'Gerne bestellen wir die folgenden Positionen:',
  'po.email.title': 'Bestellung an Lieferant senden',
  'po.email.subject': 'Bestellung {number}',
  'po.email.body': 'Guten Tag\n\nim Anhang finden Sie unsere Bestellung {number}. Bitte bestätigen Sie uns den Erhalt.\n\nBesten Dank.\n\nFreundliche Grüsse',
  'po.email.expected': 'Gewünschter Liefertermin: {date}',
  'inv.po.action.email': 'An Lieferant senden',
  'hr.payslips.title': 'Lohnabrechnungen',
  'hr.payslips.action': 'Abrechnungen',
  'hr.payslips.employee': 'Mitarbeiter',
  'hr.payslips.empty': 'Keine Lohnabrechnungen in diesem Lauf.',
  'payslip.pdf.heading': 'Lohnabrechnung',
  'payslip.pdf.employee': 'Mitarbeiter',
  'payslip.pdf.employeeNumber': 'Personalnummer',
  'payslip.pdf.period': 'Abrechnungsperiode',
  'payslip.pdf.baseSalary': 'Grundgehalt',
  'payslip.pdf.allowances': 'Zulagen',
  'payslip.pdf.gross': 'Bruttolohn',
  'payslip.pdf.tax': 'Quellensteuer',
  'payslip.pdf.deductions': 'Weitere Abzüge',
  'payslip.pdf.net': 'Nettolohn',
  'payslip.pdf.confidential': 'Vertraulich - nur für den Empfänger bestimmt.',
  'projects.billing.title': 'Abrechnung',
  'projects.billing.rate': 'Stundensatz',
  'projects.billing.unbilledTime': 'Unverrechnete Stunden',
  'projects.billing.expenses': 'Verrechenbare Spesen',
  'projects.billing.total': 'Offen zur Abrechnung',
  'projects.billing.action': 'Rechnung erstellen',
  'projects.billing.empty': 'Nichts offen - alle genehmigten Positionen sind abgerechnet.',
  'projects.billing.noCustomer': 'Dem Projekt ist kein Kunde zugeordnet - für die Abrechnung im Projekt hinterlegen.',
  'projects.billing.noRevenueAccount': 'Kein Ertragskonto gefunden.',
  'projects.billing.lineTime': 'Projektleistungen {code} - {hours} h',
  'projects.billing.lineExpenses': 'Projektspesen {code}',
  'projects.billing.done': 'Rechnung {number} erstellt',
  'projects.billing.markFailed': 'Rechnung {number} erstellt, aber die Positions-Markierung schlug fehl - Projekt NICHT erneut abrechnen!',
  'inv.products.modal.skuHint': 'z. B. ART-0001',
  'inv.products.modal.skuHintService': 'z. B. SRV-0001',
  'inv.products.modal.editTitle': 'Produkt bearbeiten',
  'inv.products.modal.active': 'Aktiv',
  'inv.products.modal.type': 'Produkttyp',
  'inv.products.modal.typeGood': 'Artikel (lagergeführt)',
  'inv.products.modal.typeService': 'Dienstleistung (ohne Lagerführung)',
  'inv.products.modal.serviceHint': 'Dienstleistungen werden ohne Lagerführung geführt - Mindestbestand, Rückverfolgung und Warenbewegungen entfallen.',
  'product.type.GOOD': 'Artikel',
  'product.type.SERVICE': 'Dienstleistung',
  'uom.short.EACH': 'Stk.',
  'uom.short.BOX': 'Box',
  'uom.short.KG': 'kg',
  'uom.short.L': 'l',
  'uom.short.M': 'm',
  'uom.short.HOUR': 'Std.',
  'uom.short.DAY': 'Tage',
  'uom.short.FLAT': 'pauschal',
  'uom.unit.EACH': 'Stück',
  'uom.unit.BOX': 'Schachtel',
  'uom.unit.KG': 'Kilogramm',
  'uom.unit.L': 'Liter',
  'uom.unit.M': 'Meter',
  'uom.unit.HOUR': 'Stunde',
  'uom.unit.DAY': 'Tag',
  'uom.unit.FLAT': 'Pauschale',
  'order.pdf.to': 'Kunde',
  'pdf.draftMark': 'Entwurf - nicht verbindlich',
  'invoice.print.billTo': 'Rechnung an',
  'invoice.print.total': 'Gesamtbetrag',
  'invoice.print.mailSubject': 'Rechnung',
  'invoice.print.mailGreeting': 'Guten Tag,',
  'invoice.print.mailBody': 'anbei erhalten Sie unsere Rechnung',
  'invoice.print.qrMissing': 'Für den QR-Code bitte zuerst Firmenname und IBAN unter Einstellungen → Firma & Bankverbindung hinterlegen.',
  'invoice.print.qrError': 'QR-Code konnte nicht erstellt werden. Bitte IBAN in den Einstellungen prüfen.',

  // Settings → company / bank
  'settings.company.title': 'Firma & Bankverbindung',
  'settings.company.intro': 'Diese Angaben erscheinen auf Rechnungen und im Swiss-QR-Code.',
  'settings.company.name': 'Firmenname',
  'settings.company.address': 'Adresse',
  'settings.company.zip': 'PLZ',
  'settings.company.city': 'Ort',
  'settings.company.email': 'E-Mail',
  'settings.company.phone': 'Telefon',
  'settings.company.bank': 'Bankverbindung',
  'settings.company.iban': 'IBAN',
  'settings.company.bankName': 'Bank',
  'settings.company.vat': 'MwSt-Nummer',
  'settings.company.saved': 'Gespeichert.',
  'settings.smtp.title': 'E-Mail-Versand (SMTP)',
  'settings.smtp.intro': 'Mailserver für den automatischen Versand von Rechnungen/Mahnungen. Das Passwort wird verschlüsselt gespeichert und nie angezeigt.',
  'settings.smtp.host': 'SMTP-Server',
  'settings.smtp.port': 'Port',
  'settings.smtp.user': 'Benutzer',
  'settings.smtp.password': 'Passwort',
  'settings.smtp.passwordKeep': '•••••• (gesetzt - leer lassen zum Beibehalten)',
  'settings.smtp.from': 'Absender-Adresse',
  'settings.smtp.secure': 'SSL/TLS verwenden (Port 465)',

  // CSV import/export
  'csv.export': 'CSV exportieren',
  'csv.import': 'CSV importieren',
  'csv.import.intro': 'Lade eine CSV-Datei hoch. Die Spalten werden automatisch zugeordnet (Semikolon oder Komma als Trennzeichen).',
  'csv.import.expectedColumns': 'Erwartete Spalten',
  'csv.import.file': 'CSV-Datei',
  'csv.import.preview': 'Vorschau',
  'csv.import.rows': 'Zeilen',
  'csv.import.start': 'Importieren',
  'csv.import.running': 'Importiere',
  'csv.import.done': 'Fertig',
  'csv.import.imported': 'importiert',
  'csv.import.failedCount': 'fehlgeschlagen',
  'csv.import.line': 'Zeile',
  'csv.import.empty': 'Die Datei enthält keine Datenzeilen.',
  'csv.import.parseError': 'Die Datei konnte nicht gelesen werden.',
  'csv.import.missingColumns': 'Pflichtspalten fehlen',
  'common.confirm': 'Bestätigen',
  'common.actions': 'Aktionen',
  'common.all': 'Alle',
  'common.searchPlaceholder': 'Suchen…',
  'common.loadError': 'Daten konnten nicht geladen werden',

  // Shared column labels
  'col.code': 'Code',
  'col.number': 'Nummer',
  'col.name': 'Name',
  'col.type': 'Typ',
  'col.email': 'E-Mail',
  'col.date': 'Datum',
  'col.due': 'Fällig',
  'col.total': 'Total',
  'col.paid': 'Bezahlt',
  'col.status': 'Status',
  'col.balance': 'Saldo',
  'col.unit': 'Einheit',
  'col.product': 'Produkt',
  'col.warehouse': 'Lager',
  'col.amount': 'Betrag',
  'col.actions': '',

  // Generic empty states
  'aria.hauptnavigation': 'Hauptnavigation',
  'aria.menueOeffnen': 'Menü öffnen',
  'aria.menueSchliessen': 'Menü schliessen',
  'aria.laedt': 'Lädt',
  'aria.schliessen': 'Schliessen',
  'empty.default': 'Keine Daten vorhanden',
  'empty.invoices': 'Noch keine Rechnungen',
  'empty.accounts': 'Noch keine Konten',
  'empty.employees': 'Noch keine Mitarbeiter',
  'empty.leave':    'Keine Abwesenheitsanträge',
  'empty.payroll':  'Noch keine Lohnabrechnungen',
  'empty.products': 'Noch keine Produkte',
  'empty.lowStock': 'Alle Bestände gesund - keine Warnungen.',
  'empty.po':       'Noch keine Bestellungen',
  'empty.customers':'Noch keine Kunden',
  'empty.orders':   'Noch keine Verkaufsaufträge',
  'empty.opps':     'Keine Opportunities',

  // Status badges
  'status.PROCESSED': 'Verarbeitet',
  'status.EXPIRED': 'Abgelaufen',
  'status.CREDIT_HOLD': 'Kreditsperre',
  'status.SUBMITTED': 'Eingereicht',
  'status.REQUESTED': 'Angefordert',
  'status.PROPOSED': 'Vorgeschlagen',
  'status.UNMATCHED': 'Nicht zugeordnet',
  'status.IN_STOCK': 'Am Lager',
  'status.ACTIVE': 'Aktiv',
  'status.INACTIVE': 'Inaktiv',
  'status.BLOCKED': 'Gesperrt',
  'status.DRAFT': 'Entwurf',
  'status.POSTED': 'Gebucht',
  'status.PAID': 'Bezahlt',
  'status.CANCELLED': 'Storniert',
  'status.CONFIRMED': 'Bestätigt',
  'status.FULFILLED': 'Erfüllt',
  'status.INVOICED': 'Berechnet',
  'status.PARTIAL': 'Teilweise',
  'status.PENDING': 'Ausstehend',
  'nav.myTime': 'Meine Zeit',
  'weekday.mon': 'Montag',
  'weekday.tue': 'Dienstag',
  'weekday.wed': 'Mittwoch',
  'weekday.thu': 'Donnerstag',
  'weekday.fri': 'Freitag',
  'weekday.sat': 'Samstag',
  'weekday.sun': 'Sonntag',
  'time.my.title': 'Meine Zeit',
  'time.my.subtitle': 'Kommen und Gehen erfassen oder Stunden nachtragen. Fehlende Tage fallen auf.',
  'time.week.loading': 'Woche wird geladen…',
  'time.week.prev': 'Vorige Woche',
  'time.week.next': 'Nächste Woche',
  'time.week.thisWeek': 'Diese Woche',
  'time.week.of': 'von {target} h',
  'time.week.off': 'frei',
  'time.week.holiday': 'Feiertag',
  'time.week.missing': 'fehlt',
  'time.week.add': 'Eintragen',
  'time.balance.target': 'Soll',
  'time.balance.actual': 'Ist',
  'time.balance.balance': 'Saldo',
  'time.add.cta': 'Zeit erfassen',
  'time.add.title': 'Zeit erfassen',
  'time.add.date': 'Tag',
  'time.add.modeClock': 'Kommen und Gehen',
  'time.add.modeHours': 'Stunden nachtragen',
  'time.add.start': 'Kommen',
  'time.add.end': 'Gehen',
  'time.add.break': 'Pause (Min.)',
  'time.add.hours': 'Stunden',
  'time.add.overnight': 'Die Schicht geht über Mitternacht',
  'time.add.submit': 'Eintragen',
  'time.add.saving': 'Wird eingetragen…',
  'time.add.failed': 'Eintragen nicht möglich',
  'nav.section.self': 'Meine Daten',
  'nav.myLeave': 'Meine Ferien',
  'roles.employee': 'Mitarbeitende',
  'self.title': 'Meine Ferien',
  'self.subtitle': 'Angemeldet als {name}. Hier steht nur, was Sie selbst betrifft.',
  'self.loading': 'Wird geladen…',
  'self.noLink': 'Zu Ihrem Konto gehört noch keine Personalakte. Die Personalabteilung muss die Verknüpfung herstellen, danach sehen Sie hier Ihren Ferienstand.',
  'self.balances.title': 'Mein Stand',
  'self.balances.of': 'von {granted} Tagen, {used} genommen',
  'self.balances.empty': 'Für dieses Jahr ist noch kein Anspruch hinterlegt.',
  'self.requests.title': 'Meine Anträge',
  'self.requests.empty': 'Sie haben noch keine Anträge gestellt.',
  'self.requests.col.period': 'Zeitraum',
  'self.requests.col.days': 'Tage',
  'self.requests.col.status': 'Zustand',
  'self.requests.col.reason': 'Grund',
  'self.requests.col.note': 'Rückmeldung',
  'self.leave.request': 'Ferien beantragen',
  'self.leave.type': 'Art',
  'self.leave.typePlaceholder': 'Bitte wählen',
  'self.leave.from': 'Von',
  'self.leave.to': 'Bis',
  'self.leave.reason': 'Grund (freiwillig)',
  'self.leave.submit': 'Antrag stellen',
  'self.leave.submitting': 'Wird gestellt…',
  'self.leave.submit.failed': 'Antrag konnte nicht gestellt werden',
  'self.leave.withdraw': 'Zurückziehen',
  'self.leave.withdraw.failed': 'Zurückziehen nicht möglich',
  'self.leave.orderHint': 'Das Enddatum liegt vor dem Startdatum.',
  'self.leave.workdayHint': 'Gezählt werden nur Arbeitstage. Wochenenden und Feiertage werden nicht abgezogen.',
  'status.PENDING_APPROVAL': 'Freigabe ausstehend',
  'status.APPROVED': 'Genehmigt',
  'status.REJECTED': 'Abgelehnt',
  'status.RECEIVED': 'Erhalten',
  'status.OPEN': 'Offen',
  'status.PAUSED': 'Pausiert',
  'status.CLOSED': 'Geschlossen',
  'status.ON_LEAVE': 'In Urlaub',
  'status.TERMINATED': 'Beendet',
  'status.SUSPENDED': 'Suspendiert',
  'status.SENT': 'Versandt',
  'status.ACCEPTED': 'Angenommen',
  'status.CONVERTED': 'Konvertiert',
  'status.OVERDUE': 'Überfällig',
  'status.HIRED': 'Eingestellt',

  // Account types
  'accountType.ASSET': 'Aktiv',
  'accountType.LIABILITY': 'Passiv',
  'accountType.EQUITY': 'Eigenkapital',
  'accountType.REVENUE': 'Ertrag',
  'accountType.EXPENSE': 'Aufwand',

  // Invoice types
  'invoiceType.SALES': 'Verkauf',
  'invoiceType.PURCHASE': 'Einkauf',

  // Finance - accounts
  'finance.accounts.title': 'Kontenrahmen',
  'finance.accounts.subtitle': 'Alle GL-Konten mit laufendem Saldo.',

  // Finance - invoices
  'finance.invoices.title': 'Rechnungen',
  'finance.invoices.subtitle': 'AR + AP. Entwürfe buchen erzeugt automatisch das GL-Journal.',
  'finance.invoices.insight.status': 'Status',
  'finance.invoices.insight.open': 'Offene Rechnungen',
  'finance.invoices.insight.outstanding': 'Offener Betrag',
  'finance.invoices.insight.overdue': 'Überfällig',
  'finance.invoices.insight.balance': 'Saldo (Einnahmen − Ausgaben)',
  'finance.invoices.cat.income': 'Einnahmen (Verkauf)',
  'finance.invoices.cat.expense': 'Ausgaben (Einkauf)',
  'finance.invoices.filterType.all': 'Alle Typen',
  'finance.invoices.filterType.sales': 'Ausgang (AR)',
  'finance.invoices.filterType.purchase': 'Eingang (AP)',
  'finance.invoices.filterStatus.all': 'Alle Status',
  'finance.invoices.action.post': 'Buchen',
  'finance.invoices.action.delete': 'Löschen',
  'finance.invoices.action.cancel': 'Stornieren',
  'finance.invoices.confirmDelete': 'Diesen Rechnungsentwurf wirklich löschen?',
  'finance.invoices.confirmCancel': 'Diese Rechnung wirklich stornieren? Es wird eine Gegenbuchung erstellt.',

  // Finance - reports
  'finance.reports.title': 'Berichte',
  'finance.reports.subtitle': 'Saldenbilanz, Erfolgsrechnung, Bilanz.',
  'finance.reports.trialBalance': 'Saldenbilanz',
  'finance.reports.income': 'Erfolgsrechnung',
  'finance.reports.balanceSheet': 'Bilanz',
  'finance.reports.totals.debits': 'Soll',
  'finance.reports.totals.credits': 'Haben',
  'finance.reports.totals.balanced': '✓ ausgeglichen',
  'finance.reports.totals.unbalanced': '⚠ nicht ausgeglichen',
  'finance.reports.totals.assetsEquation': '✓ Aktiv = Passiv + Eigenkapital',
  'finance.reports.col.debit': 'Soll',
  'finance.reports.col.credit': 'Haben',
  'finance.reports.metric.revenue': 'Ertrag',
  'finance.reports.metric.expenses': 'Aufwand',
  'finance.reports.metric.netIncome': 'Reingewinn',
  'finance.reports.metric.assets': 'Aktiven',
  'finance.reports.metric.liabilities': 'Passiven',
  'finance.reports.metric.equity': 'Eigenkapital',

  // Finance - MwSt-Abrechnung
  'vat.title': 'MwSt-Abrechnung',
  'vat.subtitle': 'Quartalsabrechnung nach vereinbarten Entgelten (effektive Methode).',
  'vat.quarter': 'Quartal',
  'vat.year': 'Jahr',
  'vat.col.code': 'Ziffer',
  'vat.col.label': 'Bezeichnung',
  'vat.col.base': 'Umsatz (CHF)',
  'vat.col.tax': 'Steuer (CHF)',
  'vat.row.total': 'Total vereinbarte Entgelte',
  'vat.row.exempt': 'Davon steuerbefreit (0 %)',
  'vat.row.rate': 'Leistungen zu',
  'vat.row.outputTax': 'Total geschuldete Steuer',
  'vat.row.inputTax': 'Vorsteuer',
  'vat.row.payable': 'Zu bezahlender Betrag',
  'vat.row.credit': 'Guthaben',
  'vat.counts': '{sales} Verkaufsrechnungen · {purchases} Einkaufsrechnungen · {credits} Gutschriften',
  'vat.net': 'Netto',
  'vat.tax': 'MwSt',
  'vat.rateCol': 'MwSt %',

  // HR
  'hr.employees.title': 'Mitarbeiter',
  'hr.employees.subtitle': 'Alle Mitarbeiter mit aktuellem Status und Lohnband.',
  'hr.employees.col.hired': 'Eintritt',
  'hr.employees.col.salary': 'Grundlohn',
  'hr.leave.title': 'Abwesenheitsanträge',
  'hr.leave.subtitle': 'Pending-Anträge genehmigen oder ablehnen; Saldi aktualisieren sich automatisch.',
  'hr.leave.tab.requests': 'Anträge',
  'hr.leave.tab.balances': 'Saldo',
  'hr.leave.tab.calendar': 'Kalender',
  'hr.leave.col.employee': 'Mitarbeiter',
  'hr.leave.col.type': 'Typ',
  'hr.leave.col.start': 'Start',
  'hr.leave.col.end': 'Ende',
  'hr.leave.col.days': 'Tage',
  'hr.leave.col.reason': 'Grund',
  'hr.leave.action.approve': 'Genehmigen',
  'hr.leave.action.reject': 'Ablehnen',
  'hr.leave.entitlement.action': 'Anspruch festlegen',
  'hr.leave.entitlement.title': 'Urlaubsanspruch festlegen',
  'hr.leave.entitlement.year': 'Jahr',
  'hr.leave.entitlement.days': 'Anspruch (Tage)',
  'hr.leave.entitlement.allTypes': 'Alle Typen',
  'hr.leave.balance.entitled': 'Anspruch',
  'hr.leave.balance.used': 'Bezogen',
  'hr.leave.balance.remaining': 'Verbleibend',
  'hr.leave.balance.empty': 'Keine Salden für dieses Jahr',
  'hr.leave.calendar.absences': 'Abwesenheiten',
  'hr.leave.calendar.empty': 'Keine genehmigten Abwesenheiten',
  'hr.leave.calendar.holidays': 'Feiertage',
  'hr.leave.calendar.noHolidays': 'Keine Feiertage erfasst',
  'hr.payroll.title': 'Lohnabrechnungen',
  'hr.payroll.subtitle': 'Monatliche Lohnabrechnungen mit Brutto/Steuer/Netto.',
  'hr.payroll.col.period': 'Periode',
  'hr.payroll.col.gross': 'Brutto',
  'hr.payroll.col.tax': 'Steuer',
  'hr.payroll.col.deductions': 'Abzüge',
  'hr.payroll.col.net': 'Netto',

  // Inventory
  'inv.products.title': 'Produkte',
  'inv.products.subtitle': 'Stammkatalog mit Preisen und Mindestbeständen.',
  'inv.products.action.new': 'Neues Produkt',
  'inv.products.search': 'SKU oder Name suchen…',
  'inv.products.col.sku': 'Artikel-Nr.',
  'inv.products.col.price': 'Listenpreis',
  'inv.products.col.reorder': 'Mindestbestand',
  'inv.products.modal.title': 'Neues Produkt',
  'inv.products.modal.listPrice': 'Listenpreis',
  'inv.products.modal.reorderPoint': 'Mindestbestand',
  'inv.lowStock.title': 'Niedrige Bestände',
  'inv.lowStock.subtitle': 'Artikel auf oder unter Mindestbestand. Auffüllen oder PO erstellen.',
  'inv.lowStock.col.onHand': 'Bestand',
  'inv.lowStock.col.severity': 'Dringlichkeit',
  'inv.lowStock.sev.out': 'Ausverkauft',
  'inv.lowStock.sev.critical': 'Kritisch',
  'inv.lowStock.sev.low': 'Niedrig',
  'inv.po.title': 'Bestellungen',
  'inv.po.subtitle': 'Entwürfe bestätigen, dann Wareneingang erfassen - AP-Rechnung wird automatisch erzeugt.',
  'inv.po.insight.dist': 'Bestellungen nach Status',
  'inv.po.insight.open': 'Offene Bestellungen',
  'inv.po.insight.openValue': 'Offener Wert',
  'inv.po.insight.awaiting': 'Wartet auf Wareneingang',
  'inv.po.insight.received': 'Empfangen',
  'inv.po.col.date': 'Bestelldatum',
  'inv.po.col.expected': 'Erwartet',
  'inv.po.action.confirm': 'Bestätigen',
  'inv.po.action.approve': 'Genehmigen',
  'inv.po.action.reject': 'Ablehnen',
  'inv.po.approval.title': 'Genehmigung',
  'inv.po.approval.submitted': 'Zur Genehmigung eingereicht - ein Admin muss freigeben.',
  'inv.po.approval.confirmReject': 'Diese Bestellung wirklich ablehnen?',
  'inv.po.approval.requestedBy': 'Angefragt von',
  'inv.po.approval.decidedBy': 'Entschieden von',
  'inv.po.approval.decidedAt': 'Entschieden am',
  'inv.po.approval.note': 'Ablehnungsnotiz',

  // Sales
  'sales.customers.title': 'Kunden',
  'sales.customers.subtitle': 'Kundenstammdaten mit Kreditlimiten.',
  'sales.customers.insight.revenue': 'Umsatzverteilung',
  'sales.customers.insight.others': 'Übrige',
  'sales.customers.insight.total': 'Kunden gesamt',
  'sales.customers.insight.active': 'Aktiv',
  'sales.customers.insight.withOpenOrders': 'Mit offenen Aufträgen',
  'sales.customers.insight.avgRevenue': 'Ø Umsatz/Kunde',
  'sales.customers.action.new': 'Neuer Kunde',
  'sales.customers.search': 'Name oder Code suchen…',
  'sales.customers.col.creditLimit': 'Kreditlimit',
  'sales.customers.modal.title': 'Neuer Kunde',
  'sales.customers.modal.currency': 'Währung',
  'sales.customers.modal.creditLimit': 'Kreditlimit (0 = unbegrenzt)',
  'sales.orders.title': 'Verkaufsaufträge',
  'sales.orders.subtitle': 'Bestätigen löst automatisch Stock-Issue → Erfüllung → AR-Rechnung via Events aus.',
  'sales.orders.insight.dist': 'Aufträge nach Status',
  'sales.orders.insight.open': 'Offene Aufträge',
  'sales.orders.insight.openValue': 'Offener Wert',
  'sales.orders.insight.toFulfill': 'Zu erfüllen',
  'sales.orders.insight.booked': 'Auftragswert',
  'sales.orders.col.fulfillment': 'Erfüllung',
  'sales.orders.action.confirm': 'Bestätigen',
  'sales.orders.action.cancel': 'Stornieren',
  'sales.pipeline.title': 'Pipeline',
  'sales.pipeline.subtitle': 'Stage-Übergänge per Dropdown auf jeder Karte.',
  'sales.pipeline.action.new': 'Neue Opportunity',
  'sales.pipeline.stage.LEAD': 'Lead',
  'sales.pipeline.stage.QUALIFY': 'Qualify',
  'sales.pipeline.stage.PROPOSAL': 'Offerte',
  'sales.pipeline.stage.NEGOTIATE': 'Verhandlung',
  'sales.pipeline.stage.CLOSED_WON': 'Gewonnen',
  'sales.pipeline.stage.CLOSED_LOST': 'Verloren',
  'sales.pipeline.modal.title': 'Neue Opportunity',
  'sales.pipeline.modal.titleField': 'Titel',
  'sales.pipeline.modal.amount': 'Betrag',
  'sales.pipeline.modal.stage': 'Stage',
  'sales.pipeline.modal.customer': 'Kunde',
  'sales.pipeline.modal.customer.none': '- Keiner -',
  'sales.pipeline.modal.close': 'Voraussichtlicher Abschluss',
  'sales.reports.title': 'Vertriebsberichte',
  'sales.reports.subtitle': 'Gebuchter Umsatz nach Kunde / Produkt und Pipeline-Funnel.',
  'sales.reports.funnel': 'Pipeline-Funnel',
  'sales.reports.byCustomer': 'Umsatz nach Kunde',
  'sales.reports.byProduct': 'Umsatz nach Produkt',
  'sales.reports.col.stage': 'Stage',
  'sales.reports.col.count': 'Anzahl',
  'sales.reports.col.pipeline': 'Pipeline',
  'sales.reports.col.weighted': 'Gewichtet',
  'sales.reports.col.orders': 'Aufträge',
  'sales.reports.col.revenue': 'Umsatz',
  'sales.reports.col.units': 'Einheiten',

  // Login
  'login.title': 'Anmelden',
  'login.hint': 'Verwende deine geschäftliche E-Mail und dein Passwort.',
  'login.cta': 'Anmelden',
  'login.cta.loading': 'Anmelden…',
  'login.failed': 'Anmeldung fehlgeschlagen',
  'login.askAdmin': 'Du brauchst einen Account? Frag deinen Administrator.',

  // Nav sections
  'nav.section.overview': 'Übersicht',
  'nav.section.finance':  'Finanzen',
  'nav.section.hr':       'Personal',
  'nav.section.inventory':'Lager',
  'nav.section.sales':    'Vertrieb',
  'nav.section.account':  'Konto',
  'nav.section.automation': 'Automatisierung',
  'nav.rules': 'Regeln',
  'nav.alerts': 'Alerts',

  // Automatisierung / Regel-Engine
  'auto.title': 'Automatisierungsregeln',
  'auto.subtitle': 'Wenn ein Event eintritt und die Bedingung passt, wird ein Alert ausgelöst.',
  'auto.empty': 'Keine Regeln definiert.',
  'auto.col.name': 'Regel',
  'auto.col.trigger': 'Auslöser',
  'auto.col.condition': 'Bedingung',
  'auto.col.severity': 'Stufe',
  'auto.col.fired': 'Ausgelöst',
  'auto.col.enabled': 'Aktiv',
  'auto.col.message': 'Meldung',
  'auto.col.time': 'Zeit',
  'auto.always': 'immer',
  'auto.on': 'An',
  'auto.off': 'Aus',
  'auto.severity.INFO': 'Info',
  'auto.severity.WARNING': 'Warnung',
  'auto.severity.CRITICAL': 'Kritisch',
  'auto.action.new': 'Neue Regel',
  'auto.action.delete': 'Löschen',
  'auto.action.markRead': 'Gelesen',
  'auto.action.markAll': 'Alle gelesen',
  'auto.metric.rules': 'Regeln',
  'auto.metric.active': 'Aktiv',
  'auto.metric.alerts': 'Offene Alerts',
  'auto.field.name': 'Name',
  'auto.field.trigger': 'Auslöser-Event',
  'auto.field.condition': 'Bedingung (optional)',
  'auto.field.noCondition': 'Ohne Bedingung (immer)',
  'auto.field.value': 'Wert',
  'auto.field.severity': 'Stufe',
  'auto.field.message': 'Meldung',
  'auto.field.messageHint': 'Variablen in {…} verfügbar:',
  'auto.op.lt': 'kleiner',
  'auto.op.lte': 'kleiner gleich',
  'auto.op.gt': 'grösser',
  'auto.op.gte': 'grösser gleich',
  'auto.op.eq': 'gleich',
  'auto.op.neq': 'ungleich',
  'auto.op.contains': 'enthält',
  'auto.op.exists': 'existiert',
  'auto.modal.title': 'Neue Automatisierungsregel',
  'auto.error.required': 'Name, Auslöser und Meldung erforderlich.',
  'auto.alerts.title': 'Alerts',
  'auto.alerts.subtitle': 'Von Regeln ausgelöste Benachrichtigungen.',
  'auto.alerts.empty': 'Keine Alerts.',

  // Nav items
  'nav.dashboard':        'Dashboard',
  'nav.inbox':            'Inbox',
  'nav.calendar':         'Kalender',

  // Kalender-Ansicht
  'cal.title': 'Kalender',
  'cal.subtitle': 'Fällige Termine über alle Module: Rechnungen, Wartung, Aufträge, Abwesenheiten.',
  'cal.today': 'Heute',
  'cal.type.invoice': 'Rechnung fällig',
  'cal.type.maintenance': 'Wartung',
  'cal.type.order': 'Auftrag',
  'cal.type.leave': 'Abwesenheit',
  'cal.type.event': 'Termin',
  'event.order.confirmed': 'Auftrag bestätigt',
  'event.order.credit_hold': 'Auftrag in Kreditsperre',
  'event.order.fulfilled': 'Auftrag erfüllt',
  'event.order.invoiced': 'Auftrag fakturiert',
  'event.return.received': 'Retoure eingegangen',
  'event.stock.low': 'Bestand unter Meldebestand',
  'event.po.received': 'Wareneingang zur Bestellung',
  'event.po.confirmed': 'Bestellung bestätigt',
  'event.po.approval.requested': 'Bestellung zur Freigabe',
  'event.po.approval.decided': 'Bestell-Freigabe entschieden',
  'event.invoice.posted': 'Rechnung gebucht',
  'event.payment.received': 'Zahlungseingang',
  'event.work_order.completed': 'Fertigungsauftrag abgeschlossen',
  'event.work_order.confirmed': 'Fertigungsauftrag rückgemeldet',
  'event.payroll.processed': 'Lohnlauf verarbeitet',
  'event.leave.requested': 'Abwesenheit beantragt',
  'event.leave.decided': 'Abwesenheit entschieden',
  'event.expense.requested': 'Spesen eingereicht',
  'event.expense.decided': 'Spesen entschieden',
  'event.employee.created': 'Mitarbeiter angelegt',
  'event.employee.terminated': 'Mitarbeiter ausgetreten',
  'field.orderNumber': 'Auftragsnummer',
  'field.orderId': 'Auftrags-ID',
  'field.returnNumber': 'Retourennummer',
  'field.returnId': 'Retouren-ID',
  'field.productId': 'Produkt-ID',
  'field.sku': 'Artikel-Nr.',
  'field.productSku': 'Artikel-Nr.',
  'field.quantity': 'Menge',
  'field.confirmedQuantity': 'Rückgemeldete Menge',
  'field.reorderPoint': 'Mindestbestand',
  'field.poNumber': 'Bestellnummer',
  'field.totalAmount': 'Betrag',
  'field.amount': 'Betrag',
  'field.approved': 'Genehmigt (ja/nein)',
  'field.invoiceNumber': 'Rechnungsnummer',
  'field.type': 'Typ',
  'field.periodYear': 'Jahr',
  'field.periodMonth': 'Monat',
  'field.payslipCount': 'Anzahl Abrechnungen',
  'field.employeeId': 'Mitarbeiter-ID',
  'field.employeeName': 'Mitarbeiter',
  'field.days': 'Tage',
  'field.status': 'Status',
  'field.terminationDate': 'Austrittsdatum',
  'cal.day.empty': 'Keine Einträge an diesem Tag.',
  'cal.day.open': 'Öffnen',
  'cal.event.add': 'Eintrag hinzufügen',
  'cal.event.new': 'Neuer Eintrag (für alle sichtbar)',
  'cal.event.title': 'Titel',
  'cal.event.date': 'Datum',
  'cal.event.endDate': 'Bis (optional)',
  'cal.event.description': 'Beschreibung',
  'cal.event.createdBy': 'Eingetragen von {name}',

  // Zentrale Aktions-Inbox
  'inbox.title': 'Aktions-Inbox',
  'inbox.subtitle': 'Alle offenen Genehmigungen und Alerts an einem Ort.',
  'inbox.empty': 'Nichts zu tun - alles erledigt. 🎉',
  'inbox.metric.total': 'Offen gesamt',
  'inbox.days': 'Tage',
  'inbox.viewAll': 'Alle anzeigen',
  'inbox.action.approve': 'Genehmigen',
  'inbox.action.reject': 'Ablehnen',
  'inbox.action.read': 'Gelesen',
  'inbox.kind.po': 'Bestellung',
  'inbox.kind.req': 'BANF',
  'inbox.kind.leave': 'Urlaub',
  'inbox.kind.expense': 'Spese',
  'inbox.kind.alert': 'Alert',
  'inbox.section.po': 'Bestellungen zur Genehmigung',
  'inbox.section.req': 'Bestellanforderungen',
  'inbox.section.leave': 'Urlaubsanträge',
  'inbox.section.expense': 'Spesen zur Genehmigung',
  'inbox.section.alert': 'Automatisierungs-Alerts',
  'nav.accounts':         'Kontenrahmen',
  'nav.invoices':         'Rechnungen',
  'nav.dunning':          'Mahnwesen',
  'nav.creditNotes': 'Gutschriften',
  'nav.recurring':        'Abos',
  'nav.costCenters':      'Kostenstellen',
  'nav.controlling':      'Controlling',
  'nav.profitCenters':    'Profitcenter',
  'nav.downPayments':     'Anzahlungen',
  'nav.intercompany':     'Intercompany',
  'nav.budgets':          'Budget',
  'nav.cashJournal':      'Kassenbuch',
  'nav.recurringJournals': 'Wiederk. Buchungen',
  'nav.paymentTerms':     'Zahlungsbedingungen',
  'nav.collectiveInvoice': 'Sammelrechnung',

  // Sammelrechnung
  'ci.title': 'Sammelrechnung',
  'ci.subtitle': 'Mehrere offene Entwurfs-Verkaufsrechnungen eines Kunden zu einer Rechnung zusammenfassen.',
  'ci.empty': 'Keine offenen Entwurfs-Verkaufsrechnungen.',
  'ci.draftsWord': 'Entwürfe',
  'ci.metric.drafts': 'Entwürfe',
  'ci.metric.customers': 'Kunden',
  'ci.metric.selected': 'Ausgewählt',
  'ci.col.number': 'Nr.',
  'ci.col.date': 'Datum',
  'ci.col.total': 'Total',
  'ci.combineTitle': '{n} Rechnungen zusammenfassen',
  'ci.invoiceDate': 'Rechnungsdatum',
  'ci.dueDate': 'Fällig am',
  'ci.action.combine': 'Zusammenfassen',
  'ci.error.min': 'Mindestens zwei Rechnungen wählen.',
  'ci.error.dates': 'Rechnungs- und Fälligkeitsdatum erforderlich.',

  // Zahlungsbedingungen / Skonto
  'pt.title': 'Zahlungsbedingungen',
  'pt.subtitle': 'Nettofrist + Skonto; der Rechner ermittelt Skontobetrag und Zahlbetrag je Zahlungsdatum.',
  'pt.empty': 'Keine Zahlungsbedingungen.',
  'pt.days': 'Tage',
  'pt.col.code': 'Code',
  'pt.col.name': 'Bezeichnung',
  'pt.col.net': 'Nettofrist',
  'pt.col.discount': 'Skonto',
  'pt.action.new': 'Neue Bedingung',
  'pt.action.calc': 'Skonto-Rechner',
  'pt.modal.title': 'Neue Zahlungsbedingung',
  'pt.field.netDays': 'Nettofrist (Tage)',
  'pt.field.discountDays': 'Skontofrist (Tage)',
  'pt.field.discountPercent': 'Skonto %',
  'pt.error.required': 'Code, Bezeichnung und Nettofrist erforderlich.',
  'pt.calc.title': 'Skonto-Rechner',
  'pt.calc.term': 'Bedingung',
  'pt.calc.base': 'Rechnungsbetrag',
  'pt.calc.invoiceDate': 'Rechnungsdatum',
  'pt.calc.paymentDate': 'Zahlungsdatum',
  'pt.calc.due': 'Fällig am',
  'pt.calc.deadline': 'Skontofrist bis',
  'pt.calc.discount': 'Skonto',
  'pt.calc.payable': 'Zahlbetrag',
  'pt.calc.within': 'Skonto gewährt',
  'pt.calc.outside': 'Kein Skonto (Frist verpasst)',
  'pt.error.calcRequired': 'Bedingung, Betrag und beide Daten erforderlich.',

  // Wiederkehrende Buchungen
  'rj.title': 'Wiederkehrende Buchungen',
  'rj.subtitle': 'Buchungsvorlagen (Soll=Haben); ein Lauf erzeugt ein echtes Journal und terminiert neu.',
  'rj.empty': 'Keine Vorlagen.',
  'rj.active': 'Aktiv',
  'rj.inactive': 'Inaktiv',
  'rj.col.description': 'Beschreibung',
  'rj.col.frequency': 'Frequenz',
  'rj.col.next': 'Nächster Lauf',
  'rj.col.last': 'Letzter Lauf',
  'rj.freq.MONTHLY': 'Monatlich',
  'rj.freq.QUARTERLY': 'Quartalsweise',
  'rj.freq.YEARLY': 'Jährlich',
  'rj.action.new': 'Neue Vorlage',
  'rj.action.run': 'Buchen',
  'rj.action.runDue': 'Fällige buchen',
  'rj.action.activate': 'Aktivieren',
  'rj.action.deactivate': 'Deaktivieren',
  'rj.metric.active': 'Aktiv',
  'rj.metric.total': 'Vorlagen',
  'rj.modal.title': 'Neue Buchungsvorlage',
  'rj.field.nextRun': 'Erster Lauf',
  'rj.field.lines': 'Buchungszeilen',
  'rj.field.addLine': '+ Zeile',
  'rj.debit': 'Soll',
  'rj.credit': 'Haben',
  'rj.error.required': 'Beschreibung und Termin erforderlich.',
  'rj.error.unbalanced': 'Soll muss gleich Haben sein (und > 0).',

  // Kassenbuch (FBCJ)
  'cb.title': 'Kassenbuch',
  'cb.subtitle': 'Bargeldkassen mit Einnahmen/Ausgaben und laufendem Saldo (keine negative Kasse).',
  'cb.empty': 'Keine Buchungen.',
  'cb.col.number': 'Nr.',
  'cb.col.date': 'Datum',
  'cb.col.type': 'Art',
  'cb.col.description': 'Text',
  'cb.col.amount': 'Betrag',
  'cb.col.balance': 'Saldo',
  'cb.type.RECEIPT': 'Einnahme',
  'cb.type.PAYMENT': 'Ausgabe',
  'cb.action.newJournal': 'Neue Kasse',
  'cb.action.post': 'Buchung',
  'cb.metric.balance': 'Kassenbestand',
  'cb.metric.entries': 'Buchungen',
  'cb.metric.currency': 'Währung',
  'cb.journal.title': 'Neue Kasse',
  'cb.field.code': 'Code',
  'cb.field.name': 'Name',
  'cb.field.currency': 'Währung',
  'cb.field.category': 'Kategorie',
  'cb.field.reference': 'Referenz',
  'cb.error.journalRequired': 'Code und Name erforderlich.',
  'cb.post.title': 'Kassenbuchung',
  'cb.error.entryRequired': 'Text und Betrag erforderlich.',

  // Budget & Verfügbarkeitskontrolle
  'bud.title': 'Budget',
  'bud.subtitle': 'Budgets je Konto/Periode mit Ist und Verfügbarkeit; manuelle Buchungen über Budget werden gesperrt.',
  'bud.empty': 'Keine Budgets für dieses Jahr.',
  'bud.over': 'Überschritten',
  'bud.within': 'Im Budget',
  'bud.col.account': 'Konto',
  'bud.col.period': 'Periode',
  'bud.col.budgeted': 'Budget',
  'bud.col.actual': 'Ist',
  'bud.col.available': 'Verfügbar',
  'bud.action.set': 'Budget setzen',
  'bud.action.check': 'Verfügbarkeit prüfen',
  'bud.metric.budgeted': 'Budget gesamt',
  'bud.metric.actual': 'Ist gesamt',
  'bud.metric.over': 'Überschritten',
  'bud.modal.title': 'Budget setzen',
  'bud.field.year': 'Jahr',
  'bud.field.month': 'Monat',
  'bud.field.amount': 'Budgetbetrag',
  'bud.error.required': 'Konto und Betrag erforderlich.',
  'bud.check.title': 'Verfügbarkeitskontrolle',
  'bud.check.amount': 'Buchungsbetrag',
  'bud.check.exceed': 'Würde das Budget überschreiten',
  'bud.check.ok': 'Innerhalb des Budgets',
  'bud.check.uncontrolled': 'Kein Budget gesetzt - keine Kontrolle.',
  'bud.error.checkRequired': 'Konto und Betrag erforderlich.',

  // Intercompany-Buchungen
  'ic.title': 'Intercompany-Buchungen',
  'ic.subtitle': 'Buchungskreise und Buchungen zwischen ihnen; Forderung/Verbindlichkeit gespiegelt (Gruppensaldo 0).',
  'ic.col.company': 'Buchungskreis',
  'ic.col.receivable': 'Forderung',
  'ic.col.payable': 'Verbindlichkeit',
  'ic.col.net': 'Netto',
  'ic.col.doc': 'Beleg',
  'ic.col.date': 'Datum',
  'ic.col.flow': 'Von → Nach',
  'ic.col.description': 'Beschreibung',
  'ic.col.amount': 'Betrag',
  'ic.action.newCompany': 'Neuer Buchungskreis',
  'ic.action.newPosting': 'Neue Buchung',
  'ic.metric.companies': 'Buchungskreise',
  'ic.metric.receivable': 'Forderungen',
  'ic.metric.payable': 'Verbindlichkeiten',
  'ic.metric.net': 'Gruppensaldo',
  'ic.reconciliation': 'Abstimmung je Buchungskreis',
  'ic.postings': 'Buchungen',
  'ic.noCompanies': 'Keine Buchungskreise.',
  'ic.noPostings': 'Keine Buchungen.',
  'ic.company.title': 'Neuer Buchungskreis',
  'ic.field.name': 'Name',
  'ic.field.currency': 'Währung',
  'ic.error.companyRequired': 'Code und Name erforderlich.',
  'ic.posting.title': 'Neue Intercompany-Buchung',
  'ic.posting.from': 'Von Buchungskreis',
  'ic.posting.to': 'Nach Buchungskreis',
  'ic.posting.needTwo': 'Mindestens zwei Buchungskreise nötig.',
  'ic.error.postingRequired': 'Beide Buchungskreise und Betrag erforderlich.',
  'ic.error.distinct': 'Quell- und Zielkreis müssen verschieden sein.',

  // Anzahlungen (down payments)
  'dp.title': 'Anzahlungen',
  'dp.subtitle': 'Anzahlungen anfordern, als Eingang erfassen und mit der Schlussrechnung verrechnen.',
  'dp.empty': 'Keine Anzahlungen.',
  'dp.col.number': 'Nr.',
  'dp.col.party': 'Partei',
  'dp.col.amount': 'Betrag',
  'dp.partyType.CUSTOMER': 'Kunde',
  'dp.partyType.VENDOR': 'Lieferant',
  'dp.status.REQUESTED': 'Angefordert',
  'dp.status.RECEIVED': 'Eingegangen',
  'dp.status.APPLIED': 'Verrechnet',
  'dp.action.new': 'Neue Anzahlung',
  'dp.action.receive': 'Eingang erfassen',
  'dp.action.apply': 'Verrechnen',
  'dp.field.partyType': 'Art',
  'dp.field.party': 'Name',
  'dp.field.description': 'Beschreibung',
  'dp.modal.title': 'Neue Anzahlung',
  'dp.error.required': 'Name und Betrag erforderlich.',
  'dp.apply.title': 'Anzahlung verrechnen',
  'dp.apply.hint': 'Anzahlung {amount} von {party} auf eine offene Rechnung verrechnen.',
  'dp.apply.invoice': 'Schlussrechnung',
  'dp.apply.open': 'offen',
  'dp.apply.noInvoices': 'Keine offenen gebuchten Rechnungen vorhanden.',
  'dp.error.invoiceRequired': 'Bitte eine Rechnung wählen.',

  // Profitcenter-Rechnung (CO)
  'pc.title': 'Profitcenter',
  'pc.subtitle': 'Profitcenter-Stammdaten mit Ertrags-/Aufwandsbuchungen und Ergebnis je Profitcenter.',
  'pc.empty': 'Keine Profitcenter.',
  'pc.inactive': 'Inaktiv',
  'pc.col.code': 'Code',
  'pc.col.name': 'Bezeichnung',
  'pc.col.revenue': 'Ertrag',
  'pc.col.expense': 'Aufwand',
  'pc.col.result': 'Ergebnis',
  'pc.action.new': 'Neues Profitcenter',
  'pc.action.post': 'Buchung',
  'pc.metric.revenue': 'Ertrag gesamt',
  'pc.metric.expense': 'Aufwand gesamt',
  'pc.metric.result': 'Ergebnis gesamt',
  'pc.modal.title': 'Neues Profitcenter',
  'pc.field.description': 'Beschreibung',
  'pc.error.required': 'Code und Bezeichnung erforderlich.',
  'pc.post.title': 'Profitcenter-Buchung',
  'pc.post.type': 'Art',
  'pc.error.postRequired': 'Profitcenter und Betrag erforderlich.',
  'pc.type.REVENUE': 'Ertrag',
  'pc.type.EXPENSE': 'Aufwand',
  'nav.reportBuilder':    'Report-Builder',

  // Report-Builder
  'rb.title': 'Report-Builder',
  'rb.subtitle': 'Eigene Auswertungen zusammenstellen, speichern und als CSV exportieren.',
  'rb.source': 'Datenquelle',
  'rb.groupBy': 'Gruppieren nach',
  'rb.noGroup': '- keine Gruppierung -',
  'rb.limit': 'Limit',
  'rb.fields': 'Felder',
  'rb.filters': 'Filter',
  'rb.value': 'Wert',
  'rb.addFilter': '+ Filter',
  'rb.run': 'Ausführen',
  'rb.save': 'Speichern',
  'rb.savePrompt': 'Name des Berichts:',
  'rb.exportCsv': 'CSV exportieren',
  'rb.noRows': 'Keine Datensätze.',
  'rb.saved': 'Gespeicherte Berichte',
  'rb.load': 'Laden',
  'rb.delete': 'Löschen',
  'rb.src.invoices': 'Rechnungen',
  'rb.src.cost_center_postings': 'CO-Buchungen',
  'rb.op.eq': 'gleich',
  'rb.op.neq': 'ungleich',
  'rb.op.gt': 'grösser',
  'rb.op.gte': 'grösser gleich',
  'rb.op.lt': 'kleiner',
  'rb.op.lte': 'kleiner gleich',
  'rb.op.contains': 'enthält',

  // Controlling (CO) - Plan/Ist/Abweichung
  'co.title': 'Controlling',
  'co.subtitle': 'Kostenstellen-Plan vs. Ist mit Abweichung je Geschäftsjahr.',
  'co.empty': 'Keine Kostenstellen.',
  'co.col.code': 'Kostenstelle',
  'co.col.name': 'Bezeichnung',
  'co.col.plan': 'Plan',
  'co.col.actual': 'Ist',
  'co.col.variance': 'Abweichung',
  'co.metric.plan': 'Plan gesamt',
  'co.metric.actual': 'Ist gesamt',
  'co.metric.variance': 'Abweichung',
  'co.action.setPlan': 'Plan setzen',
  'co.action.postCost': 'Kosten buchen',
  'co.field.costCenter': 'Kostenstelle',
  'co.field.plannedAmount': 'Planbetrag',
  'co.field.date': 'Buchungsdatum',
  'co.field.amount': 'Betrag',
  'co.field.description': 'Beschreibung',
  'co.field.reference': 'Beleg/Referenz',
  'co.plan.title': 'Jahresplan',
  'co.post.title': 'Kostenbuchung',
  'co.error.required': 'Kostenstelle und Planbetrag erforderlich.',
  'co.error.postRequired': 'Kostenstelle, Datum und positiver Betrag erforderlich.',
  'nav.bank':             'Bankabgleich',
  'nav.paymentRuns':      'Zahlungslauf',

  // Zahlungslauf (F110)
  'pr.title': 'Zahlungslauf',
  'pr.subtitle': 'Offene Kreditorenrechnungen sammeln und per Zahllauf begleichen.',
  'pr.empty': 'Keine Zahlläufe.',
  'pr.col.number': 'Nr.',
  'pr.col.paymentDate': 'Zahldatum',
  'pr.col.dueBy': 'Fällig bis',
  'pr.col.count': 'Posten',
  'pr.col.total': 'Summe',
  'pr.status.PROPOSED': 'Vorschlag',
  'pr.status.EXECUTED': 'Ausgeführt',
  'pr.status.CANCELLED': 'Storniert',
  'pr.action.new': 'Neuer Zahllauf',
  'pr.action.view': 'Öffnen',
  'pr.action.execute': 'Ausführen',
  'pr.action.cancel': 'Stornieren',
  'pr.metric.proposed': 'Vorschläge',
  'pr.metric.executed': 'Ausgeführt',
  'pr.field.dueBy': 'Fällig bis',
  'pr.modal.title': 'Zahlungsvorschlag erstellen',
  'pr.modal.hint': 'Es werden offene CHF-Kreditorenrechnungen vorgeschlagen, die bis zum gewählten Datum fällig sind.',
  'pr.modal.propose': 'Vorschlag erstellen',
  'pr.modal.creating': 'Erstelle',
  'pr.error.required': 'Zahldatum und Fälligkeitsdatum erforderlich.',
  'pr.detail.executed': '{n} Rechnung(en) bezahlt.',
  'pr.detail.noItems': 'Keine fälligen Rechnungen.',
  'pr.item.invoice': 'Rechnung',
  'pr.item.amount': 'Betrag',
  'pr.item.state': 'Status',
  'pr.item.paid': 'Bezahlt',
  'pr.item.failed': 'Fehlgeschlagen',
  'pr.item.pending': 'Vorgeschlagen',
  'nav.vat':              'MwSt-Abrechnung',
  'bank.title': 'Bankabgleich',
  'bank.subtitle': 'Kontoauszüge importieren und Zahlungen Rechnungen zuordnen',
  'bank.loading': 'Wird geladen',
  'bank.tab.unmatched': 'Offen',
  'bank.tab.matched': 'Zugeordnet',
  'bank.tab.ignored': 'Ignoriert',
  'bank.col.date': 'Datum',
  'bank.col.direction': 'Richtung',
  'bank.col.amount': 'Betrag',
  'bank.col.reference': 'Referenz',
  'bank.col.counterparty': 'Gegenpartei',
  'bank.col.suggestion': 'Vorschlag',
  'bank.dir.credit': 'Eingang',
  'bank.dir.debit': 'Ausgang',
  'bank.action.import': 'Auszug importieren',
  'bank.action.match': 'Zuordnen',
  'bank.action.ignore': 'Ignorieren',
  'bank.empty.unmatched': 'Keine offenen Buchungen',
  'bank.empty.matched': 'Noch keine zugeordneten Buchungen',
  'bank.empty.ignored': 'Keine ignorierten Buchungen',
  'bank.import.title': 'Kontoauszug importieren',
  'bank.import.fileLabel': 'Datei (CAMT.053 XML oder CSV)',
  'bank.import.formatLabel': 'Format',
  'bank.import.formatCamt': 'CAMT.053 (XML)',
  'bank.import.formatCsv': 'CSV',
  'bank.import.action': 'Importieren',
  'bank.import.success': '{count} Buchungen importiert',
  'bank.import.fileRequired': 'Bitte zuerst eine Datei auswählen',
  'bank.match.title': 'Buchung zuordnen',
  'bank.match.invoiceLabel': 'Rechnung',
  'bank.match.placeholder': 'Rechnung auswählen …',
  'bank.match.open': 'Offen',
  'bank.match.confirm': 'Zuordnen',
  'bank.match.noCandidates': 'Keine passenden offenen Rechnungen gefunden',
  'bank.match.selectRequired': 'Bitte eine Rechnung auswählen',
  'bank.ignore.title': 'Buchung ignorieren',
  'bank.ignore.message': 'Diese Buchung wird als ignoriert markiert und nicht mehr in der Liste der offenen Buchungen angezeigt.',
  'cc.title': 'Kostenstellen',
  'cc.subtitle': 'Budget vs. Ist je Kostenstelle',
  'cc.action.new': 'Neue Kostenstelle',
  'cc.action.edit': 'Bearbeiten',
  'cc.empty': 'Noch keine Kostenstellen',
  'cc.active': 'Aktiv',
  'cc.inactive': 'Inaktiv',
  'cc.metric.count': 'Kostenstellen',
  'cc.metric.budget': 'Gesamt-Budget',
  'cc.metric.actual': 'Gesamt-Ist',
  'cc.metric.utilization': 'Auslastung',
  'cc.col.code': 'Code',
  'cc.col.name': 'Name',
  'cc.col.budget': 'Budget',
  'cc.col.actual': 'Ist',
  'cc.col.remaining': 'Verbleibend',
  'cc.col.utilization': 'Auslastung',
  'cc.modal.title': 'Neue Kostenstelle',
  'cc.modal.editTitle': 'Kostenstelle bearbeiten',
  'cc.field.code': 'Code',
  'cc.field.name': 'Name',
  'cc.field.budget': 'Jahresbudget',
  'cc.field.parent': 'Übergeordnete Kostenstelle',
  'cc.field.noParent': '- keine -',
  'cc.field.currency': 'Währung',
  'cc.field.active': 'Aktiv',
  'cc.field.notes': 'Notizen',
  'dunning.title': 'Mahnwesen',
  'dunning.subtitle': 'Überfällige Rechnungen erkennen und mahnen',
  'dunning.tab.overdue': 'Überfällig',
  'dunning.tab.notices': 'Mahnungen',
  'dunning.level': 'Stufe',
  'dunning.maxReached': 'Max. Stufe erreicht',
  'dunning.action.create': 'Mahnung Stufe',
  'dunning.action.markPaid': 'Bezahlt',
  'dunning.action.view': 'Ansehen',
  'dunning.print.heading': 'Zahlungserinnerung / Mahnung',
  'dunning.print.greeting': 'Sehr geehrte Damen und Herren',
  'dunning.print.body': 'Trotz Fälligkeit ist die unten aufgeführte Rechnung noch offen. Wir bitten Sie, den ausstehenden Betrag inkl. Mahngebühr bis zum unten genannten Datum zu begleichen.',
  'dunning.print.amountDue': 'Offener Rechnungsbetrag',
  'dunning.print.total': 'Zu zahlen (inkl. Gebühr)',
  'dunning.print.payBy': 'Zahlbar bis',
  'dunning.print.closing': 'Bei Fragen stehen wir gerne zur Verfügung. Freundliche Grüsse',
  'dunning.action.cancel': 'Stornieren',
  'dunning.empty.overdue': 'Keine überfälligen Rechnungen 🎉',
  'dunning.empty.notices': 'Noch keine Mahnungen erstellt',
  'dunning.metric.overdue': 'Überfällige Rechnungen',
  'dunning.metric.outstanding': 'Offener Betrag',
  'dunning.metric.openNotices': 'Offene Mahnungen',
  'dunning.metric.totalNotices': 'Mahnungen gesamt',
  'dunning.col.invoice': 'Rechnung',
  'dunning.col.daysOverdue': 'Tage überfällig',
  'dunning.col.outstanding': 'Offen',
  'dunning.col.lastLevel': 'Letzte Stufe',
  'dunning.col.date': 'Datum',
  'dunning.col.level': 'Stufe',
  'dunning.col.fee': 'Gebühr',
  'dunning.status.OPEN': 'Offen',
  'dunning.status.PAID': 'Bezahlt',
  'dunning.status.CANCELLED': 'Storniert',
  'nav.reports':          'Berichte',
  'nav.employees':        'Mitarbeiter',
  'nav.leave':            'Abwesenheiten',
  'nav.payroll':          'Lohnabrechnung',
  'nav.products':         'Produkte',
  'nav.lowStock':         'Niedrige Bestände',
  'nav.purchaseOrders':   'Bestellungen',
  'nav.customers':        'Kunden',
  'nav.orders':           'Aufträge',
  'nav.creditManagement': 'Kreditmanagement',

  // Kreditmanagement
  'cm.title': 'Kreditmanagement',
  'cm.subtitle': 'Kreditgesperrte Aufträge freigeben/ablehnen; Kreditlimit & Exposure je Kunde.',
  'cm.empty': 'Keine gesperrten Aufträge.',
  'cm.holds': 'Kreditsperre-Warteschlange',
  'cm.lookup': 'Kreditübersicht je Kunde',
  'cm.selectCustomer': 'Kunde wählen…',
  'cm.col.order': 'Auftrag',
  'cm.col.customer': 'Kunde',
  'cm.col.amount': 'Betrag',
  'cm.col.date': 'Datum',
  'cm.action.release': 'Freigeben',
  'cm.action.reject': 'Ablehnen',
  'cm.metric.holds': 'Gesperrte Aufträge',
  'cm.metric.blocked': 'Gesperrter Wert',
  'cm.limit': 'Kreditlimit',
  'cm.exposure': 'Exposure (offen)',
  'cm.available': 'Verfügbar',
  'cm.unlimited': 'Unbegrenzt',
  'cm.within': 'Im Limit',
  'cm.exceeded': 'Limit überschritten',
  'nav.deliveries': 'Lieferscheine',
  'delivery.title': 'Lieferscheine',
  'delivery.subtitle': 'Alle Lieferungen aus erfüllten Aufträgen.',
  'delivery.empty': 'Noch keine Lieferscheine.',
  'delivery.shipping': 'Versandangaben',
  'delivery.carrier': 'Spediteur / Versandart',
  'delivery.tracking': 'Tracking-Nr.',
  'delivery.packages': 'Packstücke',
  'delivery.weight': 'Gewicht (kg)',
  'delivery.deliveryDate': 'Lieferdatum',
  'delivery.shippingDate': 'Versanddatum',
  'delivery.qtyDelivered': 'Gelieferte Menge',
  'delivery.print.heading': 'Lieferschein',
  'delivery.print.shipTo': 'Lieferadresse',
  'nav.pipeline':         'Pipeline',
  'nav.settings':         'Einstellungen',

  // Dashboard
  'dashboard.title':       'Dashboard',
  'dashboard.subtitle':    'Live-Übersicht zu Umsatz, Cash, AR/AP und Pipeline-Forecast.',
  'dashboard.config.button': 'Anpassen',
  'dashboard.config.title':  'Dashboard anpassen',
  'dashboard.config.intro':  'Wähle, welche Kennzahlen und Diagramme angezeigt werden.',
  'dashboard.config.all':    'Alle',
  'dashboard.revenue':     'Umsatz (Periode)',
  'dashboard.expenses':    'Ausgaben (Periode)',
  'dashboard.netProfit':   'Reingewinn',
  'dashboard.cash':        'Liquidität',
  'dashboard.ar':          'Forderungen',
  'dashboard.ap':          'Verbindlichkeiten',
  'dashboard.openSales':   'Offene Ausgangsrechnungen',
  'dashboard.openPurchases': 'Offene Eingangsrechnungen',
  'dashboard.overdue':       'Überfällig (Forderungen)',
  'dashboard.forecast':    'Pipeline-Forecast',
  'dashboard.chartTitle':  'Umsatz vs. Ausgaben',
  'dashboard.deltaPrevMonth': 'vs. Vormonat',

  // Dashboard: Handlungs-Zentrale + Leerzustände
  'dashboard.actions.title': 'Heute wichtig',
  'dashboard.actions.creditHolds': 'Aufträge in Kreditsperre',
  'dashboard.actions.backordersReady': 'Rückstände lieferbereit',
  'dashboard.actions.poApprovals': 'Bestellungen zur Freigabe',
  'dashboard.actions.banfPending': 'BANF zur Genehmigung',
  'dashboard.actions.overdueAr': 'Forderungen überfällig',
  'dashboard.actions.recurringDue': 'Wiederk. Buchungen fällig',
  'dashboard.actions.toInbox': 'Alle Aufgaben →',
  'dashboard.empty.trend': 'Noch keine Buchungen - lege deine erste Rechnung an.',
  'dashboard.empty.trendCta': 'Rechnung anlegen',
  'dashboard.empty.pipeline': 'Noch keine Opportunities in der Pipeline.',
  'dashboard.empty.pipelineCta': 'Erste Opportunity anlegen',
  'dashboard.empty.agingGood': 'Keine überfälligen Forderungen - alles im grünen Bereich.',

  // Insight-Leisten (generisch) + Detail-Metriken
  'insight.byStatus': 'Nach Status',
  'insight.byType': 'Nach Typ',
  'insight.bySeverity': 'Nach Dringlichkeit',
  'insight.bySource': 'Nach Quelle',
  'insight.byStage': 'Nach Phase',
  'insight.byCarrier': 'Nach Spediteur',
  'insight.byDirection': 'Nach Richtung',
  'insight.count': 'Anzahl',
  'insight.active': 'Aktiv',
  'insight.inactive': 'Inaktiv',
  'insight.total': 'Summe',
  'insight.open': 'Offen',
  'inv.products.insight.avgPrice': 'Ø Listenpreis',
  'inv.suppliers.insight.withEmail': 'Mit E-Mail',
  'inv.movements.insight.totalValue': 'Warenwert gesamt',
  'inv.movements.insight.inflow': 'Zugänge',
  'inv.movements.insight.outflow': 'Abgänge',
  'inv.lowStock.insight.affected': 'Betroffene Artikel',
  'inv.lowStock.insight.outOfStock': 'Ausverkauft',
  'inv.lowStock.insight.shortfall': 'Fehlmenge gesamt',
  'hr.employees.insight.headcount': 'Mitarbeitende',
  'hr.employees.insight.payrollSum': 'Lohnsumme',
  'hr.employees.insight.avgSalary': 'Ø Lohn',
  'hr.payroll.insight.runs': 'Lohnläufe',
  'hr.payroll.insight.gross': 'Brutto gesamt',
  'hr.payroll.insight.net': 'Netto gesamt',
  'hr.payroll.insight.deductions': 'Abzüge',
  'hr.leave.insight.requests': 'Anträge',
  'hr.leave.insight.days': 'Tage gesamt',
  'rec.candidates.insight.sources': 'Quellen',
  'rec.candidates.insight.withPhone': 'Mit Telefon',
  'rec.applications.insight.hireRate': 'Einstellungsquote',
  'projects.insight.budget': 'Budget gesamt',
  'projects.insight.spent': 'Verbraucht',
  'finance.accounts.insight.types': 'Kontotypen',
  'creditNote.insight.postedSum': 'Gebucht (Summe)',
  'delivery.insight.thisMonth': 'Diesen Monat',
  'delivery.insight.withTracking': 'Mit Tracking',
  'delivery.insight.carriers': 'Spediteure',
  'bank.insight.inflow': 'Eingänge',
  'bank.insight.outflow': 'Ausgänge',
  'bank.insight.balance': 'Saldo',
  'detail.metric.total': 'Gesamt',
  'detail.metric.paid': 'Bezahlt',
  'detail.metric.outstanding': 'Offen',
  'detail.metric.dueInDays': 'Fällig in (Tagen)',
  'detail.metric.overdueDays': 'Überfällig (Tage)',
  'detail.metric.date': 'Datum',
  'detail.metric.validUntil': 'Gültig bis',
  'detail.metric.expected': 'Erwartet am',
  'detail.metric.creditLimit': 'Kreditlimite',

  // Settings
  'settings.title':        'Einstellungen',
  'settings.subtitle':     'Persönliche Einstellungen für deinen Account.',
  'settings.nav.general':       'Allgemein',
  'settings.nav.general.desc':  'Darstellung, Sprache und Währung.',
  'settings.nav.company':       'Unternehmen',
  'settings.nav.users':         'Benutzer & Rollen',
  'settings.nav.currencies': 'Währungen & Kurse',
  'settings.nav.currencies.desc': 'Fremdwährungen aktivieren und Wechselkurse pflegen.',
  'settings.appearance':   'Erscheinungsbild',
  'settings.appearance.intro':       'Wähle, wie die Oberfläche aussehen soll.',
  'settings.appearance.active':      'Aktiv:',
  'settings.appearance.followsSystem':'(folgt deinem System)',
  'settings.theme.light':       'Hell',
  'settings.theme.light.desc':  'Helle Oberflächen, dunkler Text.',
  'settings.theme.dark':        'Dunkel',
  'settings.theme.dark.desc':   'Dunkler Hintergrund, augenschonend bei Nacht.',
  'settings.theme.system':      'System',
  'settings.theme.system.desc': 'Folgt der Systemeinstellung deines Geräts.',
  'settings.language':          'Sprache',
  'settings.language.intro':    'Sprache der Benutzeroberfläche.',
  'settings.language.de':       'Deutsch',
  'settings.language.de.desc':  'Standard.',
  'settings.language.en':       'English',
  'settings.language.en.desc':  'English interface.',
  'settings.language.fr':       'Français',
  'settings.language.fr.desc':  'Interface en français.',
  'settings.currency':          'Währung',
  'settings.currency.intro':    'Anzeigewährung für alle Beträge.',
  'settings.currency.CHF':      'Schweizer Franken (CHF)',
  'settings.currency.CHF.desc': 'Standard.',
  'settings.currency.EUR':      'Euro (EUR)',
  'settings.currency.EUR.desc': 'Beträge in Euro anzeigen.',
  'settings.currency.USD':      'US-Dollar (USD)',
  'settings.currency.USD.desc': 'Beträge in US-Dollar anzeigen.',
  'settings.currency.GBP':      'Britisches Pfund (GBP)',
  'settings.currency.GBP.desc': 'Beträge in Pfund anzeigen.',

  // Finance Workflows
  'finance.accounts.action.new': 'Neues Konto',
  'finance.accounts.modal.title': 'Neues Konto',
  'finance.accounts.modal.parent': 'Übergeordnetes Konto (optional)',
  'finance.invoices.action.new': 'Neue Rechnung',
  'finance.invoices.modal.title': 'Neue Rechnung',
  'finance.invoices.modal.customer': 'Kunde',
  'finance.invoices.modal.vendor': 'Lieferant',
  'finance.invoices.modal.invoiceDate': 'Rechnungsdatum',
  'finance.invoices.modal.dueDate': 'Fälligkeitsdatum',
  'finance.invoices.modal.notes': 'Notizen',
  'finance.invoices.modal.lines': 'Rechnungszeilen',
  'finance.invoices.modal.addLine': 'Zeile hinzufügen',
  'finance.invoices.modal.removeLine': 'Entfernen',
  'finance.invoices.modal.account': 'Konto',
  'finance.invoices.modal.lineDescription': 'Beschreibung',
  'finance.invoices.modal.quantity': 'Menge',
  'finance.invoices.modal.unitPrice': 'Einzelpreis',
  'finance.invoices.modal.lineTotal': 'Zeilensumme',
  'finance.invoices.modal.invoiceTotal': 'Rechnungssumme',
  'finance.invoices.modal.pickCounterparty': '- Bitte auswählen -',
  'finance.invoices.modal.searchCounterparty': 'Suchen (Code, Name, E-Mail)…',
  'finance.invoices.modal.noCounterparty': 'Keine Treffer',
  'finance.invoices.action.pay': 'Bezahlen',
  'finance.invoices.pay.title': 'Zahlung erfassen',
  'finance.invoices.pay.outstanding': 'Offener Betrag',
  'finance.invoices.pay.amount': 'Zahlungsbetrag',
  'finance.invoices.pay.date': 'Zahlungsdatum',

  // 3-Way-Match (Bestellung <-> Wareneingang <-> Eingangsrechnung)
  'match.title': '3-Way-Match',
  'match.status.MATCHED': 'Abgeglichen',
  'match.status.OVER_BILLED': 'Überverrechnet',
  'match.status.UNDER_BILLED': 'Unterverrechnet',
  'match.status.NO_RECEIPT': 'Kein Wareneingang',
  'match.receivedAt': 'Empfangen am',
  'match.receivedValue': 'Empfangswert',
  'match.billedNet': 'Verrechnet (netto)',
  'match.difference': 'Differenz',
  'match.unitCost': 'Einzelkosten',
  'match.lineValue': 'Wert',
  'match.poSelect': 'Bestellung (3-Way-Match)',
  'match.poNone': 'Keine',
  'match.overWarning': 'Rechnung übersteigt den Empfangswert um {diff}.',
  'match.forceLabel': 'Trotz Abweichung bezahlen (Override)',
  'match.underHint': 'Rechnung liegt unter dem Empfangswert.',
  'match.noReceiptHint': 'Kein Wareneingangs-Abgleich möglich (kein vollständiger Wareneingang erfasst).',
  'match.okHint': 'Abgeglichen mit dem Wareneingang.',
  'match.alreadyBilled': 'Zu dieser Bestellung existiert bereits Rechnung {number}.',

  // HR Workflows
  'hr.employees.action.new': 'Neuer Mitarbeiter',
  'hr.employees.action.terminate': 'Kündigen',
  'hr.employees.modal.title': 'Neuer Mitarbeiter',
  'hr.employees.modal.firstName': 'Vorname',
  'hr.employees.modal.lastName': 'Nachname',
  'hr.employees.modal.phone': 'Telefon',
  'hr.employees.modal.hireDate': 'Eintrittsdatum',
  'hr.employees.modal.department': 'Abteilung',
  'hr.employees.modal.position': 'Position',
  'hr.employees.modal.baseSalary': 'Grundgehalt',
  'hr.employees.modal.currency': 'Währung',
  'hr.employees.modal.optional': '- Keine Auswahl -',
  'hr.employees.terminate.title': 'Mitarbeiter kündigen',
  'hr.employees.terminate.date': 'Kündigungsdatum',
  'hr.employees.terminate.confirm': 'Bestätige Kündigung von',
  'hr.leave.action.new': 'Antrag stellen',
  'hr.leave.modal.title': 'Neuer Urlaubsantrag',
  'hr.leave.modal.employee': 'Mitarbeiter',
  'hr.leave.modal.leaveType': 'Abwesenheitstyp',
  'hr.leave.modal.startDate': 'Startdatum',
  'hr.leave.modal.endDate': 'Enddatum',
  'hr.leave.modal.reason': 'Grund',
  'hr.payroll.action.new': 'Neuer Lauf',
  'hr.payroll.modal.title': 'Neuer Payroll-Lauf',
  'hr.payroll.modal.year': 'Jahr',
  'hr.payroll.modal.month': 'Monat',
  'hr.payroll.modal.note': 'Der Lauf erfasst alle aktiven Mitarbeiter für die gewählte Periode.',

  // Months for HR
  'month.1': 'Januar',
  'month.2': 'Februar',
  'month.3': 'März',
  'month.4': 'April',
  'month.5': 'Mai',
  'month.6': 'Juni',
  'month.7': 'Juli',
  'month.8': 'August',
  'month.9': 'September',
  'month.10': 'Oktober',
  'month.11': 'November',
  'month.12': 'Dezember',

  // Procurement nav
  'nav.suppliers': 'Lieferanten',
  'nav.stockMovements': 'Lagerbewegungen',

  // Suppliers
  'inv.suppliers.title': 'Lieferanten',
  'inv.suppliers.subtitle': 'Stammdaten der Lieferanten für Bestellungen.',
  'inv.suppliers.action.new': 'Neuer Lieferant',
  'inv.suppliers.modal.title': 'Neuer Lieferant',
  'inv.suppliers.modal.address': 'Adresse',
  'inv.suppliers.modal.phone': 'Telefon',

  // PO Create / Receive
  'inv.po.action.new': 'Neue Bestellung',
  'inv.po.action.receive': 'Wareneingang',
  'inv.po.action.cancel': 'Stornieren',
  'inv.po.modal.title': 'Neue Bestellung',
  'inv.po.modal.supplier': 'Lieferant',
  'inv.po.modal.warehouse': 'Lager',
  'inv.po.modal.orderDate': 'Bestelldatum',
  'inv.po.modal.expectedDate': 'Erwartungsdatum',
  'inv.po.modal.notes': 'Notizen',
  'inv.po.modal.lines': 'Bestellzeilen',
  'inv.po.modal.product': 'Produkt',
  'inv.po.modal.quantity': 'Menge',
  'inv.po.modal.unitCost': 'Einkaufspreis',
  'inv.po.modal.lineTotal': 'Zeilensumme',
  'inv.po.modal.poTotal': 'Bestellsumme',
  'inv.po.modal.pickProduct': '- Produkt wählen -',
  'inv.po.receive.title': 'Wareneingang erfassen',
  'inv.po.receive.intro': 'Bestätige für jede Zeile die effektiv erhaltene Menge. Leer lassen oder 0 = nicht erhalten.',
  'inv.po.receive.ordered': 'Bestellt',
  'inv.po.receive.alreadyReceived': 'Bereits',
  'inv.po.receive.outstanding': 'Offen',
  'inv.po.receive.thisReceipt': 'Jetzt erhalten',

  // Stock Movements
  'inv.movements.title': 'Lagerbewegungen',
  'inv.movements.subtitle': 'Alle Eingänge, Ausgänge, Umlagerungen und Korrekturen.',
  'inv.movements.action.receive': 'Wareneingang',
  'inv.movements.action.issue': 'Warenausgang',
  'inv.movements.action.transfer': 'Umlagern',
  'inv.movements.action.adjust': 'Korrektur',
  'inv.movements.col.date': 'Datum',
  'inv.movements.col.product': 'Produkt',
  'inv.movements.col.warehouse': 'Lager',
  'inv.movements.col.type': 'Typ',
  'inv.movements.col.quantity': 'Menge',
  'inv.movements.col.unitCost': 'Stückkosten',
  'inv.movements.col.totalCost': 'Gesamtkosten',
  'inv.movements.col.notes': 'Notizen',
  'inv.movements.type.IN': 'Eingang',
  'inv.movements.type.OUT': 'Ausgang',
  'inv.movements.type.TRANSFER_IN': 'Umlager. Ein',
  'inv.movements.type.TRANSFER_OUT': 'Umlager. Aus',
  'inv.movements.type.ADJUSTMENT': 'Korrektur',
  'inv.movements.empty': 'Noch keine Bewegungen',
  'inv.movements.receive.title': 'Wareneingang',
  'inv.movements.issue.title': 'Warenausgang',
  'inv.movements.transfer.title': 'Umlagern',
  'inv.movements.adjust.title': 'Bestandskorrektur',
  'inv.movements.modal.product': 'Produkt',
  'inv.movements.modal.warehouse': 'Lager',
  'inv.movements.modal.fromWarehouse': 'Quell-Lager',
  'inv.movements.modal.toWarehouse': 'Ziel-Lager',
  'inv.movements.modal.quantity': 'Menge',
  'inv.movements.modal.delta': 'Veränderung (+/-)',
  'inv.movements.modal.unitCost': 'Einkaufspreis pro Einheit',
  'inv.movements.modal.notes': 'Notiz',
  'inv.movements.adjust.note': 'Positive Werte = Bestand auffüllen (Einkaufspreis nötig). Negative = Schwund / Abschreibung.',

  // Sales nav
  'nav.quotes': 'Offerten',

  // Quotes
  'sales.quotes.title': 'Offerten',
  'sales.quotes.subtitle': 'Offerten an deine Kunden: erstellen, senden, Kundenentscheid erfassen und in Aufträge konvertieren.',
  'sales.quotes.insight.dist': 'Offerten nach Status',
  'sales.quotes.insight.open': 'Offene Offerten',
  'sales.quotes.insight.openValue': 'Offener Wert',
  'sales.quotes.insight.acceptance': 'Annahmequote',
  'sales.quotes.insight.expiring': 'Läuft bald ab',
  'sales.quotes.action.new': 'Neue Offerte',
  'sales.quotes.action.send': 'An Kunde senden',
  'sales.quotes.action.accept': 'Vom Kunden angenommen',
  'sales.quotes.action.reject': 'Vom Kunden abgelehnt',
  'sales.quotes.action.convert': 'In Auftrag konvertieren',
  'sales.quotes.col.validUntil': 'Gültig bis',
  'sales.quotes.empty': 'Noch keine Offerten',
  'sales.quotes.modal.title': 'Neue Offerte',
  'sales.quotes.modal.editTitle': 'Offerte bearbeiten',
  'sales.quotes.modal.customer': 'Kunde',
  'sales.quotes.modal.quoteDate': 'Offertdatum',
  'sales.quotes.modal.validUntil': 'Gültig bis',
  'sales.quotes.modal.notes': 'Notizen',
  'sales.quotes.modal.lines': 'Offertpositionen',
  'sales.quotes.modal.product': 'Produkt',
  'sales.quotes.modal.description': 'Beschreibung',
  'sales.quotes.modal.quantity': 'Menge',
  'sales.quotes.modal.unitPrice': 'Verkaufspreis',
  'sales.quotes.modal.lineTotal': 'Zeilensumme',
  'sales.quotes.modal.quoteTotal': 'Offertsumme',
  'sales.quotes.convert.title': 'Offerte in Auftrag konvertieren',
  'sales.quotes.convert.intro': 'Der Auftrag wird auf Basis dieser Offerte erstellt. Du kannst Bestelldatum und Liefertermin anpassen.',
  'sales.quotes.convert.orderDate': 'Auftragsdatum',
  'sales.quotes.convert.requiredDate': 'Liefertermin',

  // Orders Workflows
  'sales.orders.action.new': 'Neuer Auftrag',
  'sales.orders.action.fulfill': 'Erfüllen',
  'sales.orders.action.email': 'Bestätigung senden',
  'sales.orders.modal.title': 'Neuer Verkaufsauftrag',
  'sales.orders.modal.customer': 'Kunde',
  'sales.orders.modal.orderDate': 'Auftragsdatum',
  'sales.orders.modal.requiredDate': 'Liefertermin',
  'sales.orders.modal.notes': 'Notizen',
  'sales.orders.modal.lines': 'Auftragszeilen',
  'sales.orders.modal.product': 'Produkt',
  'sales.orders.modal.description': 'Beschreibung',
  'sales.orders.modal.quantity': 'Menge',
  'sales.orders.modal.unitPrice': 'Verkaufspreis',
  'sales.orders.modal.lineTotal': 'Zeilensumme',
  'sales.orders.modal.orderTotal': 'Auftragssumme',
  'sales.orders.fulfill.title': 'Auftragserfüllung erfassen',
  'sales.orders.fulfill.intro': 'Trage pro Zeile die ausgelieferte Menge ein. Wenn alle Zeilen erfüllt sind, flippt der Auftrag auf FULFILLED und die AR-Rechnung wird automatisch generiert.',
  'sales.orders.fulfill.ordered': 'Bestellt',
  'sales.orders.fulfill.already': 'Bereits',
  'sales.orders.fulfill.outstanding': 'Offen',
  'sales.orders.fulfill.now': 'Jetzt erfüllt',

  // Detail pages
  'detail.back': 'Zurück',
  'detail.header': 'Kopfdaten',
  'detail.lines': 'Positionen',
  'detail.related': 'Zusammenhängend',
  'flow.title': 'Belegfluss',
  'flow.quote': 'Offerte',
  'flow.order': 'Auftrag',
  'flow.delivery': 'Lieferung',
  'flow.invoice': 'Rechnung',
  'flow.creditNote': 'Gutschrift',
  'flow.return': 'Retoure',
  'flow.none': '-',
  'detail.actions': 'Aktionen',
  'detail.created': 'Erstellt',
  'detail.updated': 'Aktualisiert',
  'detail.postedAt': 'Gebucht',
  'detail.fulfilledAt': 'Erfüllt',
  'detail.confirmedAt': 'Bestätigt',
  'detail.receivedAt': 'Eingegangen',
  'detail.invoicedAt': 'Berechnet',
  'detail.closedAt': 'Abgeschlossen',
  'detail.subtotal': 'Zwischensumme',
  'detail.outstanding': 'Offen',
  'detail.notes': 'Notizen',
  'detail.fromQuote': 'Aus Offerte',
  'detail.toInvoice': 'Rechnung',
  'detail.fromOrder': 'Aus Auftrag',
  'detail.fromPO': 'Aus Bestellung',
  'detail.linkedInvoice': 'Verknüpfte Rechnung',
  'detail.lineDescription': 'Beschreibung',
  'detail.lineQty': 'Menge',
  'detail.lineFulfilled': 'Erfüllt',
  'detail.lineReceived': 'Erhalten',
  'detail.lineUnitPrice': 'Einzelpreis',
  'detail.lineUnitCost': 'Stückkosten',
  'detail.lineTotal': 'Summe',
  'detail.lineAccount': 'Konto',
  'detail.lineProduct': 'Produkt',

  'nav.section.recruitment': 'Recruiting',
  'nav.jobPostings': 'Stellen',
  'nav.candidates': 'Kandidaten',
  'nav.applications': 'Bewerbungen',

  'stage.APPLIED': 'Beworben',
  'stage.SCREEN': 'Screening',
  'stage.INTERVIEW': 'Interview',
  'stage.OFFER': 'Offerte',
  'stage.HIRED': 'Eingestellt',
  'stage.REJECTED': 'Abgelehnt',

  'rec.postings.title': 'Stellenausschreibungen',
  'rec.postings.subtitle': 'Offene und geschlossene Stellen.',
  'rec.postings.action.new': 'Neue Stelle',
  'rec.postings.col.title': 'Titel',
  'rec.postings.col.opens': 'Veröffentlicht',
  'rec.postings.col.closes': 'Schliesst',
  'rec.postings.empty': 'Noch keine Stellen',
  'rec.postings.action.pause': 'Pausieren',
  'rec.postings.action.reopen': 'Wieder öffnen',
  'rec.postings.action.close': 'Schliessen',
  'rec.postings.modal.title': 'Neue Stellenausschreibung',
  'rec.postings.modal.titleField': 'Titel',
  'rec.postings.modal.department': 'Abteilung',
  'rec.postings.modal.position': 'Position',
  'rec.postings.modal.description': 'Beschreibung',
  'rec.postings.modal.opensAt': 'Veröffentlichung',
  'rec.postings.modal.closesAt': 'Schliessdatum',

  'rec.candidates.title': 'Kandidaten',
  'rec.candidates.subtitle': 'Bewerber-Pool über alle Stellen.',
  'rec.candidates.action.new': 'Neuer Kandidat',
  'rec.candidates.col.source': 'Quelle',
  'rec.candidates.col.phone': 'Telefon',
  'rec.candidates.empty': 'Noch keine Kandidaten',
  'rec.candidates.modal.title': 'Neuer Kandidat',
  'rec.candidates.modal.firstName': 'Vorname',
  'rec.candidates.modal.lastName': 'Nachname',
  'rec.candidates.modal.phone': 'Telefon',
  'rec.candidates.modal.source': 'Quelle',
  'rec.candidates.modal.resumeUrl': 'Lebenslauf-URL',
  'rec.candidates.modal.notes': 'Notizen',

  'rec.applications.title': 'Bewerbungen',
  'rec.applications.subtitle': 'Bewerbungen mit Pipeline-Stage je Stelle.',
  'rec.applications.action.new': 'Neue Bewerbung',
  'rec.applications.col.candidate': 'Kandidat',
  'rec.applications.col.posting': 'Stelle',
  'rec.applications.col.stage': 'Stage',
  'rec.applications.empty': 'Noch keine Bewerbungen',
  'rec.applications.filterStage.all': 'Alle Stages',
  'rec.applications.modal.title': 'Neue Bewerbung',
  'rec.applications.modal.posting': 'Stellenausschreibung',
  'rec.applications.modal.candidate': 'Kandidat',
  'rec.applications.modal.notes': 'Notizen',
  'nav.financeDashboard': 'Übersicht',
  'common.noData': 'Keine Daten für diesen Zeitraum',
  'finance.dashboard.title': 'Finanzübersicht',
  'finance.dashboard.subtitle': 'Kennzahlen und Trends auf einen Blick',
  'finance.dashboard.lastMonths': 'Letzte {count} Monate',
  'finance.chart.trend': 'Umsatz, Kosten & Gewinn',
  'finance.chart.trendSub': 'Monatlicher Verlauf',
  'finance.chart.aging': 'Offene Forderungen (Fälligkeit)',
  'finance.chart.openAr': 'Offene Forderungen',
  'finance.chart.expenseBreakdown': 'Kostenaufschlüsselung',
  'finance.chart.invoiceStatus': 'Rechnungen nach Status',
  'finance.chart.invoiceCount': 'Anzahl Rechnungen',
  'nav.salesDashboard': 'Übersicht',
  'sales.dashboard.title': 'Verkaufsübersicht',
  'sales.dashboard.subtitle': 'Aufträge, Pipeline und Top-Kunden auf einen Blick',
  'sales.dashboard.lastMonths': 'Letzte {count} Monate',
  'sales.metric.revenue': 'Auftragsumsatz',
  'sales.metric.orders': 'Aufträge',
  'sales.metric.openPipeline': 'Offene Pipeline',
  'sales.metric.weighted': 'Gewichtete Pipeline',
  'sales.chart.bookings': 'Auftragseingang',
  'sales.chart.bookingsSub': 'Monatlicher Umsatz',
  'sales.chart.revenue': 'Umsatz',
  'sales.chart.pipeline': 'Pipeline nach Phase',
  'sales.chart.pipelineAmount': 'Pipeline-Betrag',
  'sales.chart.orderStatus': 'Aufträge nach Status',
  'sales.chart.topCustomers': 'Top-Kunden nach Umsatz',
  'nav.inventoryDashboard': 'Übersicht',
  'inventory.dashboard.title': 'Lagerübersicht',
  'inventory.dashboard.subtitle': 'Bestandswert, Bewegungen und Bestellungen auf einen Blick',
  'inventory.dashboard.lastMonths': 'Letzte {count} Monate',
  'inventory.metric.stockValue': 'Bestandswert',
  'inventory.metric.openPo': 'Offene Bestellungen (Wert)',
  'inventory.metric.openPoCount': 'Offene Bestellungen',
  'inventory.metric.categories': 'Kategorien',
  'inventory.chart.movements': 'Lagerbewegungen',
  'inventory.chart.movementsSub': 'Zu- und Abgänge pro Monat',
  'inventory.chart.inbound': 'Zugänge',
  'inventory.chart.outbound': 'Abgänge',
  'inventory.chart.stockValue': 'Bestandswert nach Kategorie',
  'inventory.chart.poStatus': 'Bestellungen nach Status',
  'inventory.chart.poCount': 'Anzahl Bestellungen',
  'inventory.chart.topProducts': 'Top-Produkte nach Bestandswert',
  'nav.hrDashboard': 'Übersicht',
  'hr.dashboard.title': 'HR-Übersicht',
  'hr.dashboard.subtitle': 'Personalbestand, Lohnkosten und Recruiting auf einen Blick',
  'hr.dashboard.lastMonths': 'Letzte {count} Monate',
  'hr.metric.headcount': 'Mitarbeitende (aktiv)',
  'hr.metric.payroll': 'Lohnkosten (letzter Lauf)',
  'hr.metric.applications': 'Bewerbungen',
  'hr.metric.hired': 'Eingestellt',
  'hr.chart.payroll': 'Lohnkostenverlauf',
  'hr.chart.payrollSub': 'Brutto, Netto & Steuer pro Monat',
  'hr.chart.gross': 'Brutto',
  'hr.chart.net': 'Netto',
  'hr.chart.tax': 'Steuer',
  'hr.chart.headcount': 'Mitarbeitende nach Abteilung',
  'hr.chart.employeeStatus': 'Mitarbeitende nach Status',
  'hr.chart.recruitment': 'Recruiting-Funnel',
  'hr.chart.applications': 'Bewerbungen',

  // Projects
  'nav.section.projects': 'Projekte',
  'nav.projectsDashboard': 'Übersicht',
  'nav.projectsList': 'Projekte',

  // Produktion (PP)
  'nav.section.production': 'Produktion',
  'nav.productionDashboard': 'Übersicht',
  'nav.boms': 'Stücklisten',
  'nav.workCenters': 'Arbeitsplätze',
  'nav.workOrders': 'Fertigungsaufträge',
  'nav.mrp': 'MRP-Planung',
  'nav.capacity': 'Kapazität',

  // Kapazitätsplanung (PP)
  'cap.title': 'Kapazitätsplanung',
  'cap.subtitle': 'Auslastung der Arbeitsplätze: geplante Last offener Aufträge vs. Kapazität.',
  'cap.empty': 'Keine Arbeitsplätze.',
  'cap.col.code': 'Arbeitsplatz',
  'cap.col.name': 'Bezeichnung',
  'cap.col.perDay': 'Kap./Tag (h)',
  'cap.col.available': 'Verfügbar',
  'cap.col.load': 'Last (offen)',
  'cap.col.utilization': 'Auslastung',
  'cap.overloaded': 'Überlastet',
  'cap.horizon': 'Horizont: {n} Tage',
  'cap.metric.available': 'Verfügbar gesamt',
  'cap.metric.load': 'Last gesamt',
  'cap.metric.utilization': 'Auslastung',
  'cap.metric.overloaded': 'Überlastet',
  'production.mrp.title': 'Materialbedarfsplanung (MRP)',
  'production.mrp.subtitle': 'Stückliste auflösen und Bedarf gegen Bestand abgleichen',
  'production.mrp.run': 'Planung starten',
  'production.mrp.buy': 'Zukaufteile',
  'production.mrp.make': 'Zu fertigende Baugruppen',
  'production.mrp.empty': 'Keine Zukaufteile erforderlich',
  'production.mrp.onHand': 'Bestand',
  'production.mrp.shortage': 'Fehlmenge',
  'common.status': 'Status',
  'common.active': 'Aktiv',
  'common.inactive': 'Inaktiv',
  'common.select': 'Auswählen…',
  'common.error': 'Etwas ist schiefgelaufen',
  'production.dashboard.title': 'Produktionsübersicht',
  'production.dashboard.subtitle': 'Aufträge, Kapazität und Ausstoss auf einen Blick',
  'production.metric.active': 'Aktive Aufträge',
  'production.metric.draft': 'Entwürfe',
  'production.metric.completed': 'Abgeschlossene Aufträge',
  'production.metric.completedValue': 'Abgeschlossener Wert',
  'production.centers.title': 'Arbeitsplätze',
  'production.centers.subtitle': 'Wo gefertigt wird - Basis der Lohnkosten',
  'production.centers.new': 'Neuer Arbeitsplatz',
  'production.centers.empty': 'Noch keine Arbeitsplätze',
  'production.centers.code': 'Code',
  'production.centers.name': 'Name',
  'production.centers.description': 'Beschreibung',
  'production.centers.hourlyRate': 'Stundensatz',
  'production.centers.capacity': 'Kapazität / Tag',
  'production.boms.title': 'Stücklisten',
  'production.boms.subtitle': 'Woraus jedes Fertigprodukt zusammengesetzt ist',
  'production.boms.new': 'Neue Stückliste',
  'production.boms.empty': 'Noch keine Stücklisten',
  'production.boms.code': 'Code',
  'production.boms.name': 'Name',
  'production.boms.product': 'Produkt',
  'production.boms.outputQuantity': 'Ausbringungsmenge',
  'production.boms.components': 'Komponenten',
  'production.boms.explode': 'Auflösen',
  'production.boms.explodeTitle': 'Stücklisten-Auflösung',
  'production.boms.structure': 'Strukturstückliste (alle Ebenen)',
  'production.boms.requirements': 'Gesamtbedarf (Rohstoffe)',
  'production.boms.component': 'Komponente',
  'production.boms.quantity': 'Menge',
  'production.boms.material': 'Material',
  'production.boms.totalQty': 'Gesamtmenge',
  'production.boms.addComponent': 'Komponente hinzufügen',
  'production.orders.title': 'Fertigungsaufträge',
  'production.orders.subtitle': 'Fertigprodukte herstellen - verbraucht Komponenten, lagert Ausstoss ein',
  'production.orders.new': 'Neuer Fertigungsauftrag',
  'production.orders.empty': 'Noch keine Fertigungsaufträge',
  'production.orders.number': 'Nummer',
  'production.orders.bom': 'Stückliste',
  'production.orders.quantity': 'Menge',
  'production.orders.warehouse': 'Lager',
  'production.orders.workCenter': 'Arbeitsplatz',
  'production.orders.laborHours': 'Arbeitsstunden',
  'production.orders.materialPreview': 'Materialbedarf (MRP)',
  'production.orders.required': 'Benötigt',
  'production.orders.totalCost': 'Gesamtkosten',
  'production.orders.unitCost': 'Stückkosten',
  'production.orders.materialCost': 'Materialkosten',
  'production.orders.laborCost': 'Lohnkosten',
  'production.orders.componentsTitle': 'Komponenten',
  'production.orders.noComponents': 'Dieser Auftrag hat keine Komponenten',
  'production.orders.consumed': 'Verbraucht',
  'production.orders.release': 'Freigeben',
  'production.orders.start': 'Starten',
  'production.orders.complete': 'Fertigstellen',

  // Produktions-Rückmeldung (Teilrückmeldung)
  'pc2.title': 'Rückmeldung',
  'pc2.action.button': 'Rückmelden',
  'pc2.action.confirm': 'Rückmelden',
  'pc2.confirmed': 'Rückgemeldet',
  'pc2.remaining': 'Offen',
  'pc2.quantity': 'Menge',
  'pc2.scrap': 'Ausschuss',
  'pc2.labor': 'Lohnstunden',
  'pc2.history': 'Bisherige Rückmeldungen',
  'pc2.col.number': 'Nr.',
  'pc2.col.time': 'Zeit',
  'pc2.error.qty': 'Menge erforderlich.',
  'pc2.error.over': 'Über der offenen Menge ({remaining}).',
  'production.orders.cancel': 'Stornieren',
  'production.orders.completedToast': 'Auftrag abgeschlossen - Bestand aktualisiert',
  'production.status.DRAFT': 'Entwurf',
  'production.status.RELEASED': 'Freigegeben',
  'production.status.IN_PROGRESS': 'In Arbeit',
  'production.status.COMPLETED': 'Abgeschlossen',
  'production.status.CANCELLED': 'Storniert',
  'common.none': '-',
  'projects.dashboard.title': 'Projektübersicht',
  'projects.dashboard.subtitle': 'Status, Budget und Aufgaben auf einen Blick',
  'projects.metric.active': 'Aktive Projekte',
  'projects.metric.budget': 'Gesamt-Budget',
  'projects.metric.actual': 'Gesamt-Ist',
  'projects.metric.openTasks': 'Offene Aufgaben',
  'projects.chart.budget': 'Budget vs. Ist',
  'projects.chart.budgetSub': 'Je aktivem Projekt',
  'projects.chart.budgetPlanned': 'Budget',
  'projects.chart.budgetActual': 'Ist',
  'projects.chart.status': 'Projekte nach Status',
  'projects.chart.tasks': 'Aufgaben nach Status',
  'projects.chart.taskCount': 'Anzahl Aufgaben',
  'projects.list.title': 'Projekte',
  'projects.list.subtitle': 'Alle Projekte als Karten',
  'projects.list.new': 'Neues Projekt',
  'projects.list.empty': 'Noch keine Projekte',
  'projects.create.title': 'Neues Projekt',
  'projects.create.name': 'Projektname',
  'projects.create.customer': 'Kunde',
  'projects.create.owner': 'Verantwortlich',
  'projects.create.start': 'Startdatum',
  'projects.create.end': 'Enddatum',
  'projects.create.budget': 'Budget',
  'projects.detail.owner': 'Verantwortlich',
  'projects.detail.spent': 'Verbraucht',
  'projects.detail.tasksDone': 'Aufgaben erledigt',
  'projects.detail.nextMilestone': 'Nächster Meilenstein',
  'projects.detail.board': 'Aufgaben-Board',
  'projects.detail.milestones': 'Meilensteine',
  'projects.detail.notFound': 'Projekt nicht gefunden',
  'projects.detail.noTasks': 'Noch keine Aufgaben',
  'projects.detail.noMilestones': 'Noch keine Meilensteine',
  'projects.status.PLANNED': 'Geplant',
  'projects.status.ACTIVE': 'Aktiv',
  'projects.status.PAUSED': 'Pausiert',
  'projects.status.COMPLETED': 'Abgeschlossen',
  'projects.status.CANCELLED': 'Storniert',
  'task.status.TODO': 'To-do',
  'task.status.IN_PROGRESS': 'In Arbeit',
  'task.status.REVIEW': 'Review',
  'task.status.DONE': 'Fertig',
  'task.priority.LOW': 'Niedrig',
  'task.priority.MEDIUM': 'Mittel',
  'task.priority.HIGH': 'Hoch',

  // Time tracking
  'nav.projectsTime': 'Projektzeit',
  'nav.projectsExpenses': 'Spesen',
  'expense.title': 'Spesen & Reisekosten',
  'expense.subtitle': 'Belege erfassen, genehmigen und verrechnen',
  'expense.action.new': 'Spese erfassen',
  'expense.action.approve': 'Genehmigen',
  'expense.action.reject': 'Ablehnen',
  'expense.action.reimburse': 'Erstattet',
  'expense.action.delete': 'Löschen',
  'expense.empty': 'Noch keine Spesen erfasst',
  'expense.metric.total': 'Gesamtbetrag',
  'expense.metric.billable': 'Verrechenbar',
  'expense.metric.open': 'Offen',
  'expense.metric.count': 'Belege',
  'expense.col.date': 'Datum',
  'expense.col.employee': 'Mitarbeiter',
  'expense.col.category': 'Kategorie',
  'expense.col.amount': 'Betrag',
  'expense.col.billable': 'Verrechenbar',
  'expense.col.receipt': 'Beleg',
  'expense.receiptLink': 'Öffnen',
  'expense.status.OPEN': 'Offen',
  'expense.status.APPROVED': 'Genehmigt',
  'expense.status.REJECTED': 'Abgelehnt',
  'expense.status.REIMBURSED': 'Erstattet',
  'expense.modal.title': 'Spese erfassen',
  'expense.field.date': 'Datum',
  'expense.field.category': 'Kategorie',
  'expense.field.amount': 'Betrag',
  'expense.field.employee': 'Mitarbeiter',
  'expense.field.project': 'Projekt (optional)',
  'expense.field.description': 'Beschreibung',
  'expense.field.receipt': 'Beleg-Link',
  'expense.field.billable': 'Verrechenbar',
  'expense.category.TRAVEL': 'Reise',
  'expense.category.MEALS': 'Verpflegung',
  'expense.category.ACCOMMODATION': 'Übernachtung',
  'expense.category.TRANSPORT': 'Transport',
  'expense.category.SUPPLIES': 'Material',
  'expense.category.OTHER': 'Sonstiges',
  'time.title': 'Projektzeit',
  'time.subtitle': 'Arbeitszeit auf Projekte und Aufgaben buchen',
  'time.action.new': 'Zeit erfassen',
  'time.action.approve': 'Genehmigen',
  'time.action.delete': 'Löschen',
  'time.empty': 'Noch keine Zeiteinträge',
  'time.metric.total': 'Stunden gesamt',
  'time.metric.billable': 'Verrechenbar',
  'time.metric.open': 'Offen',
  'time.metric.projects': 'Projekte',
  'time.col.date': 'Datum',
  'time.col.employee': 'Mitarbeiter',
  'time.col.hours': 'Stunden',
  'time.col.billable': 'Verrechenbar',
  'time.yes': 'Ja',
  'time.no': 'Nein',
  'time.status.OPEN': 'Offen',
  'time.status.APPROVED': 'Genehmigt',
  'time.status.REJECTED': 'Abgelehnt',
  'time.modal.title': 'Zeit erfassen',
  'time.field.project': 'Projekt',
  'time.field.task': 'Aufgabe (optional)',
  'time.field.employee': 'Mitarbeiter',
  'time.field.date': 'Datum',
  'time.field.hours': 'Stunden',
  'time.field.hoursHint': 'z. B. 1.5',
  'time.field.start': 'Von',
  'time.field.end': 'Bis',
  'time.field.rate': 'Stundensatz',
  'time.field.billable': 'Verrechenbar',
  'time.field.description': 'Beschreibung',
  'dashboard.pipeline': 'Vertriebs-Pipeline',

  // RBAC
  'roles.admin':           'Administrator',
  'roles.accountant':      'Buchhaltung',
  'roles.hr':              'Personal',
  'roles.purchaser':       'Einkauf/Lager',
  'roles.sales':           'Verkauf',
  'roles.project_manager': 'Projektleitung',
  'roles.executive':       'Geschäftsführung',
  'access.denied':         'Keine Berechtigung für diese Aktion',
  'access.denied.title':   'Kein Zugriff',
  'access.denied.body':    'Du hast keine Berechtigung für diesen Bereich. Wende dich an einen Administrator.',
  'settings.users.title':      'Benutzer & Rollen',
  'settings.users.intro':      'Weise Benutzern Berufsrollen zu. Rechte gelten als Vereinigung aller Rollen.',
  'settings.users.activate':   'Aktivieren',
  'settings.users.deactivate': 'Deaktivieren',
  'settings.users.active':     'Aktiv',
  'settings.users.inactive':   'Inaktiv',
  'settings.users.count':      '{count} Benutzer',
  'settings.users.search':     'Benutzer suchen…',
  'settings.users.noRoles':    'Keine Rolle',
  'settings.users.editRoles':  'Rollen',
  'settings.users.empty':      'Keine Benutzer gefunden.',
  'settings.users.allRoles':   'Alle Rollen',
  'settings.users.countFiltered': '{shown} von {total}',
  'settings.users.new': 'Neuer Benutzer',
  'settings.users.create.title': 'Benutzer anlegen',
  'settings.users.firstName': 'Vorname',
  'settings.users.lastName': 'Nachname',
  'settings.users.email': 'E-Mail',
  'settings.users.password': 'Passwort',
  'settings.users.passwordHint': 'Mind. 10 Zeichen, Gross-/Kleinbuchstabe und Ziffer.',
  'settings.users.roles': 'Rollen',

  // Mitarbeiterbeurteilungen
  'nav.reviews': 'Beurteilungen',
  'rev.title': 'Mitarbeiterbeurteilungen',
  'rev.subtitle': 'Leistung je Periode bewerten - mit Zielen und Gesamtnote.',
  'rev.empty': 'Keine Beurteilungen.',
  'rev.col.number': 'Nr.',
  'rev.col.employee': 'Mitarbeiter',
  'rev.col.period': 'Periode',
  'rev.col.rating': 'Bewertung',
  'rev.status.DRAFT': 'Entwurf',
  'rev.status.SUBMITTED': 'Eingereicht',
  'rev.status.ACKNOWLEDGED': 'Bestätigt',
  'rev.action.new': 'Neue Beurteilung',
  'rev.action.view': 'Öffnen',
  'rev.action.submit': 'Einreichen',
  'rev.action.acknowledge': 'Bestätigen',
  'rev.metric.total': 'Beurteilungen',
  'rev.metric.draft': 'Entwürfe',
  'rev.metric.acknowledged': 'Bestätigt',
  'rev.field.employee': 'Mitarbeiter',
  'rev.field.period': 'Periode',
  'rev.field.rating': 'Gesamtnote',
  'rev.field.strengths': 'Stärken',
  'rev.field.improvements': 'Entwicklungsfelder',
  'rev.field.goals': 'Ziele',
  'rev.field.goalTitle': 'Ziel',
  'rev.field.addGoal': '+ Ziel',
  'rev.modal.title': 'Neue Beurteilung',
  'rev.detail.title': 'Beurteilung',
  'rev.error.required': 'Mitarbeiter und Periode erforderlich.',

  // Zeiterfassung
  'nav.time': 'Arbeitszeit',
  'nav.travel': 'Reisekosten',

  // Reisekostenabrechnung
  'tr.title': 'Reisekostenabrechnung',
  'tr.subtitle': 'Reisekosten erfassen, einreichen, genehmigen und erstatten.',
  'tr.empty': 'Keine Abrechnungen.',
  'tr.col.number': 'Nr.',
  'tr.col.employee': 'Mitarbeiter',
  'tr.col.purpose': 'Zweck',
  'tr.col.period': 'Zeitraum',
  'tr.col.total': 'Summe',
  'tr.col.category': 'Kategorie',
  'tr.status.DRAFT': 'Entwurf',
  'tr.status.SUBMITTED': 'Eingereicht',
  'tr.status.APPROVED': 'Genehmigt',
  'tr.status.REJECTED': 'Abgelehnt',
  'tr.status.REIMBURSED': 'Erstattet',
  'tr.action.new': 'Neue Abrechnung',
  'tr.action.view': 'Öffnen',
  'tr.action.submit': 'Einreichen',
  'tr.action.approve': 'Genehmigen',
  'tr.action.reject': 'Ablehnen',
  'tr.action.reimburse': 'Erstatten',
  'tr.metric.submitted': 'Eingereicht',
  'tr.metric.approved': 'Genehmigt',
  'tr.metric.reimbursed': 'Erstattet',
  'tr.field.employee': 'Mitarbeiter',
  'tr.field.from': 'Von',
  'tr.field.to': 'Bis',
  'tr.field.purpose': 'Reisezweck',
  'tr.field.items': 'Positionen',
  'tr.field.description': 'Beschreibung',
  'tr.field.amount': 'Betrag',
  'tr.field.addItem': '+ Position',
  'tr.cat.MEALS': 'Verpflegung',
  'tr.cat.LODGING': 'Übernachtung',
  'tr.cat.TRANSPORT': 'Fahrt',
  'tr.cat.MILEAGE': 'Kilometergeld',
  'tr.cat.OTHER': 'Sonstiges',
  'tr.modal.title': 'Neue Reisekostenabrechnung',
  'tr.detail.title': 'Reisekostenabrechnung',
  'tr.error.required': 'Mitarbeiter und Reisezweck erforderlich.',
  'hrtime.title': 'Arbeitszeit der Mitarbeitenden',
  'hrtime.subtitle': 'Arbeitszeit je Mitarbeiter erfassen und je Periode auswerten.',
  'hrtime.empty': 'Keine Zeiteinträge.',
  'hrtime.col.date': 'Datum',
  'hrtime.col.employee': 'Mitarbeiter',
  'hrtime.col.type': 'Art',
  'hrtime.col.hours': 'Stunden',
  'hrtime.col.note': 'Notiz',
  'hrtime.type.REGULAR': 'Regulär',
  'hrtime.type.OVERTIME': 'Überstunden',
  'hrtime.type.SICK': 'Krankheit',
  'hrtime.type.HOLIDAY': 'Feiertag',
  'hrtime.type.TRAINING': 'Weiterbildung',
  'hrtime.action.add': 'Erfassen',
  'hrtime.action.delete': 'Löschen',
  'hrtime.field.employee': 'Mitarbeiter',
  'hrtime.field.date': 'Datum',
  'hrtime.field.hours': 'Stunden',
  'hrtime.field.type': 'Art',
  'hrtime.field.note': 'Notiz',
  'hrtime.field.from': 'Von',
  'hrtime.field.to': 'Bis',
  'hrtime.filter.employee': 'Mitarbeiter',
  'hrtime.filter.all': 'Alle Mitarbeiter',
  'hrtime.metric.total': 'Summe',
  'hrtime.error.required': 'Mitarbeiter, Datum und Stunden erforderlich.',

  'settings.nav.ebics':        'EBICS-Bankanbindung',
  'ebics.intro':               'Automatischer Abruf von Kontoauszügen (camt.053) über das EBICS-Bankprotokoll.',
  'ebics.experimental':        'Experimentell - erfordert einen aktiven EBICS-Vertrag mit deiner Bank und eine manuelle Freischaltung (INI-Brief). Schlüsselerzeugung und INI-Brief funktionieren lokal; das Senden an die Bank und der Auszugsabruf funktionieren erst nach der Freischaltung durch die Bank.',
  'ebics.statusLabel':         'Status:',
  'ebics.status.NEW':          'Neu',
  'ebics.status.INI_SENT':     'INI gesendet',
  'ebics.status.HIA_SENT':     'HIA gesendet',
  'ebics.status.READY':        'Bereit',
  'ebics.status.ERROR':        'Fehler',
  'ebics.masterKeyMissing':    'EBICS_MASTER_KEY ist nicht konfiguriert. Setze einen 32-Byte-Schlüssel (64 Hex-Zeichen) als Umgebungsvariable, bevor Schlüssel erzeugt werden.',
  'ebics.bankName':            'Bankname',
  'ebics.hostId':              'Host-ID',
  'ebics.partnerId':           'Partner-ID (Kunden-ID)',
  'ebics.userId':              'User-ID (Teilnehmer-ID)',
  'ebics.version':             'EBICS-Version',
  'ebics.url':                 'EBICS-URL',
  'ebics.accountIban':         'Konto-IBAN',
  'ebics.saved':               'Verbindungsdaten gespeichert.',
  'ebics.workflow':            'Einrichtungs-Ablauf',
  'ebics.workflow.intro':      'Reihenfolge: Daten speichern → Schlüssel erzeugen → INI-Brief drucken, unterschreiben und an die Bank senden → INI & HIA senden → auf Freischaltung der Bank warten → Bankschlüssel abrufen (HPB) → Kontoauszug abrufen.',
  'ebics.btn.initKeys':        'Schlüssel erzeugen',
  'ebics.btn.letter':          'INI-Brief herunterladen',
  'ebics.btn.ini':             'INI senden',
  'ebics.btn.hia':             'HIA senden',
  'ebics.btn.hpb':             'Bankschlüssel abrufen (HPB)',
  'ebics.btn.download':        'Kontoauszug abrufen',
  'ebics.letterHint':          'Schlüssel sind erzeugt. Lade den INI-Brief herunter (Button oben), um die Schlüssel-Hashes zu erhalten.',
  'ebics.download.title':      'Kontoauszug abrufen (camt.053)',
  'ebics.download.from':       'Von',
  'ebics.download.to':         'Bis',
  'ebics.download.imported':   '{n} Buchungen importiert.',
  'ebics.download.goToBank':   'Zum Bankabgleich',
  'ebics.letter.heading':      'EBICS-Initialisierungsbrief (INI)',
  'ebics.letter.date':         'Datum',
  'ebics.letter.a006':         'Elektronische Unterschrift (A006)',
  'ebics.letter.x002':         'Authentifikation (X002)',
  'ebics.letter.e002':         'Verschlüsselung (E002)',
  'ebics.letter.note':         'Bitte prüfen Sie die untenstehenden Hashwerte der öffentlichen Schlüssel und schalten Sie den Teilnehmer frei. Unterschrieben von:',
  'ebics.letter.signature':    'Datum, Ort, Unterschrift',

  // Credit notes / refunds
  'creditNote.title': 'Gutschriften',
  'creditNote.subtitle': 'Gutschriften zu gebuchten Rechnungen - Verkauf und Einkauf.',
  'creditNote.empty': 'Noch keine Gutschriften.',
  'creditNote.credited': 'Gutgeschrieben',
  'creditNote.col.type': 'Typ',
  'creditNote.type.SALES': 'Kunde',
  'creditNote.type.PURCHASE': 'Lieferant',
  'creditNote.typeFilter.all': 'Alle Typen',
  'creditNote.create.title': 'Gutschrift erstellen',
  'creditNote.create.intro': 'Positionen wählen und gutzuschreibende Menge erfassen.',
  'creditNote.create.creditQty': 'Gutzuschreibende Menge',
  'creditNote.create.submit': 'Gutschrift anlegen',
  'creditNote.create.pickLine': 'Mindestens eine Position mit Menge > 0 wählen.',
  'creditNote.print.heading': 'Gutschrift',
  'creditNote.print.forInvoice': 'Zu Rechnung',
  'creditNote.print.total': 'Gutschrift-Summe',
  'creditNote.print.headingVendor': 'Lieferanten-Gutschrift',
  'invoice.refund.action': 'Erstattung auszahlen',
  'invoice.refund.amount': 'Erstattungsbetrag',
  'invoice.refund.balance': 'Guthaben / Erstattung fällig',
  'invoice.refund.receiveAction': 'Erstattung erfassen',
  'invoice.refund.receiveBalance': 'Guthaben beim Lieferanten',

  // Multi-currency
  'currency.col.code': 'Code',
  'currency.col.name': 'Name',
  'currency.col.active': 'Aktiv',
  'currency.add': 'Währung hinzufügen',
  'currency.baseNote': 'CHF ist die Basiswährung.',
  'currency.rates.title': 'Wechselkurse',
  'currency.rates.intro': 'Kurs = CHF pro 1 Einheit Fremdwährung.',
  'currency.rates.date': 'Datum',
  'currency.rates.rate': 'Kurs',
  'currency.rates.source': 'Quelle',
  'currency.rates.add': 'Kurs erfassen',
  'currency.rates.fetch': 'Kurse abrufen (EZB)',
  'currency.rates.fetched': '{count} Kurse aktualisiert.',
  'currency.rates.fetchFailed': 'Kursabruf fehlgeschlagen: {reason}',
  'invoice.fx.currency': 'Währung',
  'invoice.fx.rate': 'Kurs',
  'invoice.fx.chfEquivalent': 'Gegenwert CHF',
  'invoice.fx.paymentRate': 'Zahlkurs',
  'invoice.fx.refundRate': 'Erstattungskurs',
  'invoice.fx.bankAmount': 'Bank (CHF)',
  'invoice.fx.diff': 'Kursdifferenz',
  'invoice.fx.noRate': 'Kein Kurs für {currency} hinterlegt - in den Einstellungen pflegen.',

  // Recurring invoices (Abos)
  'recurring.title': 'Wiederkehrende Rechnungen',
  'recurring.subtitle': 'Vorlagen, die fällige Rechnungen automatisch erzeugen - stündlich geprüft.',
  'recurring.col.name': 'Name',
  'recurring.col.customer': 'Kunde',
  'recurring.col.interval': 'Intervall',
  'recurring.col.nextRun': 'Nächste Rechnung',
  'recurring.col.amount': 'Betrag',
  'recurring.interval.MONTHLY': 'Monatlich',
  'recurring.interval.QUARTERLY': 'Vierteljährlich',
  'recurring.interval.YEARLY': 'Jährlich',
  'recurring.active': 'Aktiv',
  'recurring.paused': 'Pausiert',
  'recurring.action.new': 'Neues Abo',
  'recurring.action.generate': 'Jetzt erzeugen',
  'recurring.action.pause': 'Pausieren',
  'recurring.action.resume': 'Fortsetzen',
  'recurring.action.edit': 'Bearbeiten',
  'recurring.action.delete': 'Löschen',
  'recurring.generated': 'Rechnung erzeugt:',
  'recurring.insight.byInterval': 'Nach Intervall',
  'recurring.insight.active': 'Aktive Abos',
  'recurring.insight.monthly': 'Monatsvolumen',
  'recurring.insight.due30': 'Fällig in 30 Tagen',
  'recurring.form.startDate': 'Start',
  'recurring.form.endDate': 'Ende (optional)',
  'recurring.form.dueDays': 'Zahlungsziel (Tage)',
  'recurring.form.autoPost': 'Automatisch buchen',
  'recurring.form.invalid': 'Name, Kunde und mindestens eine gültige Zeile erforderlich.',
  'recurring.modal.editTitle': 'Abo bearbeiten',
  'recurring.confirmDelete': 'Dieses Abo wirklich löschen?',
  'recurring.empty': 'Noch keine Abos.',
  'recurring.runs.title': 'Erzeugte Rechnungen',
  'recurring.runs.empty': 'Noch keine Rechnungen erzeugt.',
  'recurring.toggleRuns': 'Erzeugte Rechnungen anzeigen',

  // Command palette (Ctrl+K)
  'palette.placeholder': 'Suchen oder springen…',
  'palette.pages': 'Seiten',
  'palette.customers': 'Kunden',
  'palette.products': 'Produkte',
  'palette.invoices': 'Rechnungen',
  'palette.projects': 'Projekte',
  'palette.orders': 'Aufträge',
  'palette.quotes': 'Offerten',
  'palette.tickets': 'Tickets',
  'palette.equipment': 'Equipment',
  'palette.suppliers': 'Lieferanten',
  'palette.employees': 'Mitarbeiter',
  'palette.purchaseOrders': 'Bestellungen',
  'palette.noResults': 'Keine Treffer',
  'palette.hint': 'Tippen, um Kunden, Rechnungen, Produkte und Projekte zu durchsuchen',
  'palette.open': 'Suche öffnen',

  // Audit log (Einstellungen → Audit-Log)
  'settings.nav.audit': 'Audit-Log',
  'audit.intro': 'Wer hat wann was geändert - jede schreibende Aktion mit Benutzer.',
  'audit.col.time': 'Zeit',
  'audit.col.user': 'Benutzer',
  'audit.col.module': 'Modul',
  'audit.col.action': 'Aktion',
  'audit.col.entity': 'Objekt',
  'audit.col.status': 'Status',
  'audit.filter.allModules': 'Alle Module',
  'audit.filter.allActions': 'Alle Aktionen',
  'audit.filter.from': 'Von',
  'audit.filter.to': 'Bis',
  'audit.toggleDetails': 'Details anzeigen',
  'audit.module.auth': 'Anmeldung',
  'audit.module.admin': 'Verwaltung',
  'audit.action.create': 'Erstellt',
  'audit.action.update': 'Geändert',
  'audit.action.delete': 'Gelöscht',
  'audit.action.login': 'Anmeldung',
  'audit.action.login_failed': 'Anmeldung fehlgeschlagen',
  'audit.action.logout': 'Abmeldung',
  'audit.action.register': 'Registrierung',
  'audit.empty': 'Noch keine Einträge.',
  'audit.pagination.of': 'von',
  'audit.prev': 'Zurück',
  'audit.next': 'Weiter',

  // Notifications (bell)
  'notif.title': 'Benachrichtigungen',
  'notif.bell': 'Benachrichtigungen öffnen',
  'notif.markAll': 'Alle gelesen',
  'notif.empty': 'Keine Benachrichtigungen.',
  'notif.stock_low': 'Niedriger Bestand: {sku} ({quantity} / Meldebestand {reorderPoint})',
  'notif.po_approval_requested': 'Bestellung {poNumber} über {totalAmount} wartet auf Freigabe',
  'notif.po_approved': 'Bestellung {poNumber} wurde genehmigt',
  'notif.po_rejected': 'Bestellung {poNumber} wurde abgelehnt',
  'notif.leave_requested': 'Urlaubsantrag von {employeeName}: {days} Tage ab {startDate}',
  'notif.leave_approved': 'Urlaubsantrag für {employeeName} wurde genehmigt',
  'notif.leave_rejected': 'Urlaubsantrag für {employeeName} wurde abgelehnt',
  'notif.expense_requested': 'Neue Spesen von {employeeName}: {amount}',
  'notif.expense_approved': 'Spesen von {employeeName} ({amount}) wurden genehmigt',
  'notif.expense_rejected': 'Spesen von {employeeName} ({amount}) wurden abgelehnt',
  'notif.expense_reimbursed': 'Spesen von {employeeName} ({amount}) wurden erstattet',
  'notif.demo_requested': 'Neue Demo-Anfrage von {name} ({company})',

  // Preislisten & Rabattstaffeln
  'nav.priceLists': 'Preislisten',
  'priceList.title': 'Preislisten',
  'priceList.subtitle': 'Kundenspezifische Preise mit Mengenstaffeln - automatisch in Offerte und Auftrag.',
  'priceList.col.products': 'Produkte',
  'priceList.col.tiers': 'Staffel-Zeilen',
  'priceList.col.customers': 'Kunden',
  'priceList.action.new': 'Neue Preisliste',
  'priceList.action.edit': 'Bearbeiten',
  'priceList.action.activate': 'Aktivieren',
  'priceList.action.deactivate': 'Deaktivieren',
  'priceList.action.delete': 'Löschen',
  'priceList.confirmDelete': 'Diese Preisliste löschen? {count} Kunde(n) fallen auf den Listenpreis zurück.',
  'priceList.empty': 'Noch keine Preislisten.',
  'priceList.modal.editTitle': 'Preisliste bearbeiten',
  'priceList.items': 'Staffelpreise',
  'priceList.form.active': 'Aktiv',
  'priceList.form.product': 'Produkt',
  'priceList.form.minQuantity': 'Mindestmenge',
  'priceList.form.unitPrice': 'Stückpreis',
  'priceList.form.invalid': 'Name ist erforderlich.',
  'priceList.tierHint': 'Mehrere Zeilen pro Produkt = Mengenstaffel (gilt ab Mindestmenge).',
  'priceList.applied': 'Preisliste {name} · ab {minQuantity}',
  'priceList.duplicateTier': 'Doppelte Staffel: gleiches Produkt mit gleicher Mindestmenge.',
  'priceList.assign': 'Preisliste',
  'priceList.none': 'Keine (Listenpreis)',
  'customer.priceListSaved': 'Preisliste gespeichert.',

  // Fixed assets (Anlagenbuchhaltung)
  'nav.fixedAssets': 'Anlagen',
  'nav.maintenance': 'Instandhaltung',

  // Instandhaltung (PM)
  'pm.title': 'Instandhaltung',
  'pm.subtitle': 'Equipment und Instandhaltungs-Aufträge mit Kosten und Status.',
  'pm.section.orders': 'Instandhaltungs-Aufträge',
  'pm.section.equipment': 'Equipment',
  'pm.col.number': 'Auftrag',
  'pm.col.equipment': 'Equipment',
  'pm.col.title': 'Titel',
  'pm.col.priority': 'Priorität',
  'pm.col.cost': 'Kosten',
  'pm.status.OPEN': 'Offen',
  'pm.status.IN_PROGRESS': 'In Arbeit',
  'pm.status.COMPLETED': 'Abgeschlossen',
  'pm.status.CANCELLED': 'Storniert',
  'pm.priority.LOW': 'Niedrig',
  'pm.priority.MEDIUM': 'Mittel',
  'pm.priority.HIGH': 'Hoch',
  'pm.priority.URGENT': 'Dringend',
  'pm.action.view': 'Öffnen',
  'pm.action.newEquipment': 'Equipment anlegen',
  'pm.action.newOrder': 'Auftrag anlegen',
  'pm.action.start': 'Starten',
  'pm.action.complete': 'Abschliessen',
  'pm.action.cancel': 'Stornieren',
  'pm.metric.openOrders': 'Offene Aufträge',
  'pm.metric.down': 'Ausgefallen',
  'pm.metric.equipment': 'Equipment',
  'pm.orders.empty': 'Keine Aufträge.',
  'pm.eq.number': 'Nr.',
  'pm.eq.name': 'Bezeichnung',
  'pm.eq.location': 'Standort',
  'pm.eq.asset': 'Anlage',
  'pm.eq.noAsset': '- keine -',
  'pm.eq.notes': 'Notizen',
  'pm.eq.empty': 'Kein Equipment.',
  'pm.eq.markDown': 'Als ausgefallen',
  'pm.eq.markUp': 'Betriebsbereit',
  'pm.eqStatus.OPERATIONAL': 'Betriebsbereit',
  'pm.eqStatus.DOWN': 'Ausgefallen',
  'pm.eqStatus.RETIRED': 'Stillgelegt',
  'pm.eqModal.title': 'Neues Equipment',
  'pm.orderModal.title': 'Neuer Instandhaltungs-Auftrag',
  'pm.detail.title': 'Instandhaltungs-Auftrag',
  'pm.field.description': 'Beschreibung',
  'pm.field.plannedDate': 'Plantermin',
  'pm.costs': 'Kosten',
  'pm.materialCost': 'Materialkosten',
  'pm.laborCost': 'Lohnkosten',
  'pm.error.name': 'Bezeichnung erforderlich.',
  'pm.error.order': 'Equipment und Titel erforderlich.',
  'pm.action.newPlan': 'Wartungsplan anlegen',
  'pm.action.generateDue': 'Fällige erzeugen',
  'pm.section.plans': 'Wartungspläne',
  'pm.plan.number': 'Plan',
  'pm.plan.interval': 'Intervall',
  'pm.plan.days': 'Tage',
  'pm.plan.nextDue': 'Nächste Fälligkeit',
  'pm.plan.active': 'Aktiv',
  'pm.plan.on': 'Aktiv',
  'pm.plan.off': 'Inaktiv',
  'pm.plan.empty': 'Keine Wartungspläne.',
  'pm.plan.generated': '{n} Auftrag/Aufträge erzeugt.',
  'pm.planModal.title': 'Neuer Wartungsplan',
  'pm.error.plan': 'Equipment, Titel, Intervall und Fälligkeit erforderlich.',
  'fa.title': 'Anlagenbuchhaltung',
  'fa.subtitle': 'Anlagespiegel, planmässige Abschreibung und Abgänge.',
  'fa.action.new': 'Neue Anlage',
  'fa.action.dispose': 'Abgang',
  'fa.empty': 'Noch keine Anlagen erfasst.',
  'fa.col.number': 'Nr.',
  'fa.col.name': 'Bezeichnung',
  'fa.col.category': 'Kategorie',
  'fa.col.cost': 'Anschaffung',
  'fa.col.accumulated': 'Kum. Abschreibung',
  'fa.col.nbv': 'Buchwert',
  'fa.status.ACTIVE': 'Aktiv',
  'fa.status.FULLY_DEPRECIATED': 'Abgeschrieben',
  'fa.status.DISPOSED': 'Abgegangen',
  'fa.metric.active': 'Aktive Anlagen',
  'fa.metric.cost': 'Anschaffungswert',
  'fa.metric.accumulated': 'Kum. Abschreibung',
  'fa.metric.nbv': 'Buchwert',
  'fa.run.period': 'Periode',
  'fa.run.action': 'Abschreibungslauf',
  'fa.run.done': '{count} Anlage(n) abgeschrieben, total {total}.',
  'fa.modal.title': 'Neue Anlage',
  'fa.field.name': 'Bezeichnung',
  'fa.field.category': 'Kategorie',
  'fa.field.acquisitionDate': 'Anschaffungsdatum',
  'fa.field.cost': 'Anschaffungskosten',
  'fa.field.salvage': 'Restwert',
  'fa.field.usefulLife': 'Nutzungsdauer (Monate)',
  'fa.field.method': 'Methode',
  'fa.field.decliningRate': 'Satz (% p.a.)',
  'fa.field.assetAccount': 'Anlagekonto',
  'fa.field.expenseAccount': 'Abschreibungsaufwand-Konto',
  'fa.field.accumulatedAccount': 'Konto kum. Abschreibung',
  'fa.field.fundingAccount': 'Finanzierungskonto (Anschaffungsbuchung)',
  'fa.field.fundingNone': '- keine Buchung -',
  'fa.method.LINEAR': 'Linear',
  'fa.method.DECLINING_BALANCE': 'Degressiv',
  'fa.preview.firstPeriod': 'Erste Monatsrate: {amount}',
  'fa.dispose.title': 'Abgang: {name}',
  'fa.dispose.confirm': 'Abgang buchen',
  'fa.dispose.date': 'Abgangsdatum',
  'fa.dispose.proceeds': 'Verkaufserlös',
  'fa.dispose.nbv': 'Buchwert {amount}',
  'fa.dispose.gain': 'Gewinn {amount}',
  'fa.dispose.loss': 'Verlust {amount}',

  // Perioden-/Jahresabschluss
  'nav.periodClose': 'Periodenabschluss',
  'period.title': 'Perioden- & Jahresabschluss',
  'period.subtitle': 'Geschlossene Perioden sperren jede Buchung; der Jahresabschluss saldiert die Erfolgsrechnung.',
  'period.year': 'Jahr',
  'period.empty': 'Keine Perioden.',
  'period.col.period': 'Periode',
  'period.col.status': 'Status',
  'period.status.open': 'Offen',
  'period.status.closed': 'Geschlossen',
  'period.action.close': 'Schliessen',
  'period.action.reopen': 'Öffnen',
  'period.yearClosed': 'Jahr abgeschlossen',
  'period.yearEnd.action': 'Jahresabschluss',
  'period.yearEnd.confirm': 'Geschäftsjahr {year} abschliessen? Die Erfolgsrechnung wird auf den Gewinnvortrag gebucht und alle Monate gesperrt.',
  'period.yearEnd.done': 'Jahresabschluss gebucht. Jahresergebnis: {net}.',
  'period.metric.year': 'Geschäftsjahr',
  'period.metric.closed': 'Geschlossene Monate',
  'period.metric.state': 'Jahresstatus',

  // Erweiterte MwSt (Saldosteuersatz, Bezugsteuer, eCH-0217)
  'settings.vat.title': 'Mehrwertsteuer',
  'settings.vat.method': 'Abrechnungsmethode',
  'settings.vat.effective': 'Effektiv',
  'settings.vat.saldo': 'Saldosteuersatz',
  'settings.vat.saldoRate1': 'Saldosatz 1 (%)',
  'settings.vat.saldoRate2': 'Saldosatz 2 (%)',
  'invoice.reverseCharge': 'Bezugsteuer (Reverse Charge, Dienstleistung aus dem Ausland)',
  'vat.ech0217': 'eCH-0217 XML',
  'vat.method.EFFECTIVE': 'Effektive Methode',
  'vat.method.NET_TAX_RATE': 'Saldosteuersatz-Methode',
  'vat.row.saldo': 'Saldosteuersatz',
  'vat.row.acquisitionTax': 'Bezugsteuer',

  // Inventur (Cycle counts)
  'common.close': 'Schliessen',
  'nav.cycleCounts': 'Inventur',
  'cyc.title': 'Inventur',
  'cyc.subtitle': 'Bestände zählen und Differenzen als Korrekturbuchung verbuchen.',
  'cyc.empty': 'Noch keine Inventuren.',
  'cyc.col.date': 'Datum',
  'cyc.col.warehouse': 'Lager',
  'cyc.status.OPEN': 'Offen',
  'cyc.status.POSTED': 'Verbucht',
  'cyc.status.CANCELLED': 'Storniert',
  'cyc.action.new': 'Neue Inventur',
  'cyc.action.view': 'Ansehen',
  'cyc.action.post': 'Verbuchen',
  'cyc.action.addLine': '+ Position',
  'cyc.metric.total': 'Inventuren',
  'cyc.metric.open': 'Offen',
  'cyc.metric.posted': 'Verbucht',
  'cyc.field.warehouse': 'Lager',
  'cyc.field.date': 'Zähldatum',
  'cyc.field.product': 'Produkt',
  'cyc.field.expected': 'Soll',
  'cyc.field.counted': 'Gezählt',
  'cyc.field.variance': 'Differenz',
  'cyc.modal.title': 'Neue Inventur',
  'cyc.detail.title': 'Inventur',
  'cyc.detail.willAdjust': '{count} Korrekturbuchung(en) beim Verbuchen.',
  'cyc.error.required': 'Lager und mindestens eine Position erforderlich.',

  // Bestellanforderung (BANF)
  'nav.requisitions': 'Bestellanforderungen',
  'req.title': 'Bestellanforderungen',
  'req.subtitle': 'Bedarf anfordern, genehmigen lassen und in Bestellungen umwandeln.',
  'req.empty': 'Noch keine Bestellanforderungen.',
  'req.col.number': 'Nr.',
  'req.col.neededBy': 'Benötigt bis',
  'req.status.DRAFT': 'Entwurf',
  'req.status.SUBMITTED': 'Eingereicht',
  'req.status.APPROVED': 'Genehmigt',
  'req.status.REJECTED': 'Abgelehnt',
  'req.status.CONVERTED': 'Umgewandelt',
  'req.action.new': 'Neue Anforderung',
  'req.action.view': 'Ansehen',
  'req.action.submit': 'Einreichen',
  'req.action.approve': 'Genehmigen',
  'req.action.reject': 'Ablehnen',
  'req.action.convert': 'In Bestellung umwandeln',
  'req.action.addLine': '+ Position',
  'req.metric.total': 'Anforderungen',
  'req.metric.submitted': 'Eingereicht',
  'req.metric.approved': 'Genehmigt',
  'req.field.warehouse': 'Lager',
  'req.field.neededBy': 'Benötigt bis',
  'req.field.justification': 'Begründung',
  'req.field.product': 'Produkt',
  'req.field.quantity': 'Menge',
  'req.field.estCost': 'Geschätzte Kosten',
  'req.field.supplier': 'Lieferant',
  'req.modal.title': 'Neue Bestellanforderung',
  'req.detail.title': 'Bestellanforderung',
  'req.detail.converted': 'In eine Bestellung umgewandelt.',
  'req.error.lines': 'Mindestens eine Position mit Produkt und Menge erforderlich.',
  'req.action.autoReorder': 'Auto-Nachbestellung',
  'req.autoReorder.done': '{products} Produkt(e) unter Meldebestand → {count} Anforderung(en) erzeugt.',
  'req.autoReorder.none': 'Kein Produkt unter Meldebestand.',

  // Bestandsreservierung
  'nav.reservations': 'Reservierungen',
  'res.title': 'Bestandsreservierungen',
  'res.subtitle': 'Bestand reservieren; verfügbar = Bestand minus reserviert.',
  'res.empty': 'Keine Reservierungen.',
  'res.col.date': 'Datum',
  'res.col.product': 'Produkt',
  'res.col.warehouse': 'Lager',
  'res.col.quantity': 'Menge',
  'res.status.OPEN': 'Offen',
  'res.status.RELEASED': 'Freigegeben',
  'res.action.new': 'Reservieren',
  'res.action.release': 'Freigeben',
  'res.metric.open': 'Offene Reservierungen',
  'res.metric.reserved': 'Reservierte Menge',
  'res.metric.total': 'Gesamt',
  'res.field.product': 'Produkt',
  'res.field.warehouse': 'Lager',
  'res.field.quantity': 'Menge',
  'res.field.available': 'Verfügbar: {qty}',
  'res.modal.title': 'Bestand reservieren',
  'res.error.required': 'Produkt, Lager und Menge erforderlich.',

  // Chargen / Seriennummern
  'inv.track.tracking': 'Rückverfolgung',
  'inv.track.NONE': 'Keine',
  'inv.track.BATCH': 'Chargen (mit Verfallsdatum)',
  'inv.track.SERIAL': 'Seriennummern',
  'inv.track.batchNumber': 'Chargennummer',
  'inv.track.expiryDate': 'Verfallsdatum',
  'inv.track.serialNumbers': 'Seriennummern',
  'inv.track.serialHint': 'Eine Seriennummer pro Zeile (Anzahl = Menge).',
  'nav.lots': 'Chargen',
  'lot.title': 'Chargen & Rückverfolgung',
  'lot.subtitle': 'Lagerlose nach Charge/Verfall verfolgen; FEFO bei der Ausgabe.',
  'lot.empty': 'Keine Lose gefunden.',
  'lot.col.product': 'Produkt',
  'lot.col.batch': 'Charge/Serie',
  'lot.col.warehouse': 'Lager',
  'lot.col.expiry': 'Verfall',
  'lot.col.remaining': 'Restmenge',
  'lot.action.expiring': 'Bald ablaufend',
  'lot.filter.batch': 'Charge suchen',
  'lot.filter.inStock': 'Nur mit Bestand',
  'lot.metric.expiring': 'Ablaufend (30 Tage)',
  'lot.metric.expired': 'Abgelaufen',

  // Lagerplätze (Bins)
  'nav.bins': 'Lagerplätze',
  'nav.quality': 'Qualität',
  'nav.consignment': 'Konsignation',
  'nav.purchaseContracts': 'Rahmenverträge',
  'nav.schedulingAgreements': 'Lieferpläne',
  'nav.serials': 'Seriennummern',
  'nav.vendorEvaluation': 'Lieferantenbewertung',
  'nav.uom': 'Mengeneinheiten',
  'nav.backorders': 'Rückstände',
  'nav.mrpRun': 'Bedarfsplanung',

  // MRP-Lauf (Bedarfsplanung)
  'mr.title': 'Bedarfsplanungslauf (MRP)',
  'mr.subtitle': 'Netto-Bedarf je Produkt (Meldebestand + Rückstände − Bestand − offene Bestellungen) → Beschaffungsvorschläge → BANF.',
  'mr.runs': 'Läufe',
  'mr.noRuns': 'Noch kein Lauf. Starte einen MRP-Lauf.',
  'mr.proposals': 'Beschaffungsvorschläge',
  'mr.noProposals': 'Keine Vorschläge - alle Bedarfe gedeckt.',
  'mr.warehouse': 'Ziel-Lager (BANF)',
  'mr.col.run': 'Lauf',
  'mr.col.date': 'Datum',
  'mr.col.count': 'Vorschläge',
  'mr.col.product': 'Produkt',
  'mr.col.onHand': 'Bestand',
  'mr.col.onOrder': 'Bestellt',
  'mr.col.backordered': 'Rückstand',
  'mr.col.reorder': 'Meldebestand',
  'mr.col.net': 'Netto-Bedarf',
  'mr.col.suggested': 'Vorschlag',
  'mr.status.OPEN': 'Offen',
  'mr.status.CONVERTED': 'In BANF gewandelt',
  'mr.action.run': 'MRP-Lauf starten',
  'mr.action.convert': 'In BANF umwandeln',
  'mr.metric.proposals': 'Vorschläge',

  // Rückstände (Backorders)
  'bo.title': 'Rückstände',
  'bo.subtitle': 'Bei Bestätigung nicht lieferbare Mengen; nachliefern, sobald Bestand verfügbar ist.',
  'bo.empty': 'Keine Rückstände.',
  'bo.all': 'Alle',
  'bo.col.product': 'Produkt',
  'bo.col.order': 'Auftrag',
  'bo.col.quantity': 'Rückstand',
  'bo.col.available': 'Verfügbar',
  'bo.col.date': 'Datum',
  'bo.status.OPEN': 'Offen',
  'bo.status.FULFILLED': 'Nachgeliefert',
  'bo.status.CANCELLED': 'Storniert',
  'bo.action.fulfill': 'Nachliefern',
  'bo.metric.open': 'Offene Rückstände',
  'bo.metric.ready': 'Lieferbereit',

  // Mengeneinheiten-Umrechnung
  'uom.title': 'Mengeneinheiten',
  'uom.subtitle': 'Alternative Mengeneinheiten je Produkt (z. B. 1 Karton = 12 Stück) + Umrechner.',
  'uom.empty': 'Keine Einheiten.',
  'uom.selectProduct': 'Produkt wählen…',
  'uom.base': 'Basis',
  'uom.col.unit': 'Einheit',
  'uom.col.factor': 'Faktor',
  'uom.add': 'Alternative Einheit hinzufügen',
  'uom.factorLabel': 'Faktor (× {base})',
  'uom.action.add': 'Hinzufügen',
  'uom.converter': 'Umrechner',
  'uom.quantity': 'Menge',
  'uom.from': 'Von',
  'uom.to': 'Nach',
  'uom.action.convert': 'Umrechnen',

  // Lieferantenbewertung (MM)
  've.title': 'Lieferantenbewertung',
  've.subtitle': 'Lieferanten nach Preis, Qualität, Lieferung und Service bewerten; Gesamtnote + Ranking.',
  've.empty': 'Keine Bewertungen.',
  've.noRanking': 'Noch keine Bewertungen.',
  've.col.supplier': 'Lieferant',
  've.col.avg': 'Ø-Note',
  've.col.grade': 'Note',
  've.col.latest': 'Letzte',
  've.col.count': 'Anzahl',
  've.col.date': 'Datum',
  've.col.price': 'Preis',
  've.col.quality': 'Qualität',
  've.col.delivery': 'Lieferung',
  've.col.service': 'Service',
  've.col.overall': 'Gesamt',
  've.action.new': 'Neue Bewertung',
  've.ranking': 'Ranking',
  've.evaluations': 'Bewertungen',
  've.modal.title': 'Neue Lieferantenbewertung',
  've.field.notes': 'Notiz',
  've.error.required': 'Lieferant erforderlich.',

  // Serialnummern-Historie
  'sn.title': 'Seriennummern',
  'sn.subtitle': 'Registry serial-getrackter Einheiten mit Lebenslauf (Eingang → Ausgang).',
  'sn.empty': 'Keine Seriennummern.',
  'sn.search': 'Seriennummer suchen…',
  'sn.allStatus': 'Alle Status',
  'sn.col.serial': 'Seriennummer',
  'sn.col.product': 'Produkt',
  'sn.col.updated': 'Aktualisiert',
  'sn.status.IN_STOCK': 'Am Lager',
  'sn.status.ISSUED': 'Ausgegeben',
  'sn.action.view': 'Öffnen',
  'sn.action.issue': 'Ausgeben',
  'sn.metric.inStock': 'Am Lager',
  'sn.metric.issued': 'Ausgegeben',
  'sn.metric.total': 'Gesamt',
  'sn.detail.title': 'Seriennummer',
  'sn.field.reference': 'Referenz',
  'sn.lifecycle': 'Lebenslauf',
  'sn.mv.type': 'Vorgang',
  'sn.mv.time': 'Zeit',
  'sn.mv.RECEIVED': 'Eingang',
  'sn.mv.ISSUED': 'Ausgang',

  // Lieferpläne / Scheduling Agreements (MM)
  'lp.title': 'Lieferpläne',
  'lp.subtitle': 'Lieferpläne je Lieferant/Produkt mit terminierten Einteilungen und Wareneingang je Einteilung.',
  'lp.empty': 'Keine Lieferpläne.',
  'lp.col.number': 'Nr.',
  'lp.col.supplier': 'Lieferant',
  'lp.col.product': 'Produkt',
  'lp.col.planned': 'Geplant',
  'lp.col.received': 'Eingegangen',
  'lp.status.ACTIVE': 'Aktiv',
  'lp.status.CLOSED': 'Geschlossen',
  'lp.action.new': 'Neuer Lieferplan',
  'lp.action.view': 'Öffnen',
  'lp.action.receive': 'WE',
  'lp.action.close': 'Schliessen',
  'lp.metric.active': 'Aktiv',
  'lp.metric.total': 'Lieferpläne',
  'lp.field.price': 'Preis',
  'lp.field.from': 'Gültig von',
  'lp.field.to': 'Gültig bis',
  'lp.field.lines': 'Einteilungen',
  'lp.field.qty': 'Menge',
  'lp.field.addLine': '+ Einteilung',
  'lp.modal.title': 'Neuer Lieferplan',
  'lp.error.required': 'Lieferant und Produkt erforderlich.',
  'lp.error.lines': 'Mindestens eine Einteilung mit Termin und Menge.',
  'lp.line.date': 'Liefertermin',
  'lp.line.planned': 'Planmenge',
  'lp.line.received': 'Eingegangen',
  'lp.line.OPEN': 'Offen',
  'lp.line.PARTIAL': 'Teilweise',
  'lp.line.COMPLETED': 'Vollständig',
  'nav.atp': 'Verfügbarkeit',

  // Verfügbarkeitsprüfung (ATP)
  'atp.title': 'Verfügbarkeitsprüfung',
  'atp.subtitle': 'Prüft, ob eine Menge über alle Lager lieferbar ist (verfügbar = Bestand − reserviert − gesperrt).',
  'atp.field.product': 'Produkt',
  'atp.field.quantity': 'Menge',
  'atp.action.check': 'Prüfen',
  'atp.metric.requested': 'Angefragt',
  'atp.metric.available': 'Verfügbar gesamt',
  'atp.metric.result': 'Ergebnis',
  'atp.metric.shortfall': 'Fehlmenge',
  'atp.deliverable': 'Lieferbar',
  'atp.notDeliverable': 'Nicht lieferbar',
  'atp.byWarehouse': 'Verfügbarkeit je Lager',
  'atp.col.warehouse': 'Lager',
  'atp.col.name': 'Bezeichnung',
  'atp.col.available': 'Verfügbar',
  'atp.noStock': 'Kein Bestand.',
  'atp.error.required': 'Produkt und Menge erforderlich.',

  // Rahmenverträge / Kontrakte (MM)
  'ct.title': 'Rahmenverträge',
  'ct.subtitle': 'Mengenkontrakte je Lieferant/Produkt; Abrufe ziehen gegen die Zielmenge.',
  'ct.empty': 'Keine Kontrakte.',
  'ct.col.number': 'Nr.',
  'ct.col.supplier': 'Lieferant',
  'ct.col.product': 'Produkt',
  'ct.col.target': 'Zielmenge',
  'ct.col.released': 'Abgerufen',
  'ct.col.remaining': 'Rest',
  'ct.col.time': 'Zeit',
  'ct.status.ACTIVE': 'Aktiv',
  'ct.status.CLOSED': 'Geschlossen',
  'ct.action.new': 'Neuer Kontrakt',
  'ct.action.view': 'Öffnen',
  'ct.action.release': 'Abruf buchen',
  'ct.action.close': 'Schliessen',
  'ct.metric.active': 'Aktiv',
  'ct.metric.total': 'Kontrakte',
  'ct.field.target': 'Zielmenge',
  'ct.field.price': 'Preis',
  'ct.field.from': 'Gültig von',
  'ct.field.to': 'Gültig bis',
  'ct.field.callOffQty': 'Abrufmenge',
  'ct.field.reference': 'Referenz',
  'ct.modal.title': 'Neuer Rahmenvertrag',
  'ct.releases': 'Abrufe',
  'ct.noReleases': 'Noch keine Abrufe.',
  'ct.error.required': 'Lieferant, Produkt und Zielmenge erforderlich.',

  // Konsignationslager
  'cons.title': 'Konsignationslager',
  'cons.subtitle': 'Lieferanten-eigener Bestand bei uns; Entnahme erzeugt eine Verbindlichkeit.',
  'cons.empty': 'Kein Konsignationsbestand.',
  'cons.col.product': 'Produkt',
  'cons.col.supplier': 'Lieferant',
  'cons.col.warehouse': 'Lager',
  'cons.col.quantity': 'Menge',
  'cons.col.price': 'Preis',
  'cons.col.value': 'Wert',
  'cons.action.book': 'Buchung',
  'cons.action.view': 'Öffnen',
  'cons.metric.lines': 'Positionen',
  'cons.metric.suppliers': 'Lieferanten',
  'cons.metric.value': 'Bestandswert',
  'cons.op.title': 'Konsignations-Buchung',
  'cons.op.type': 'Vorgang',
  'cons.op.receive': 'Eingang (Lieferant liefert)',
  'cons.op.withdraw': 'Entnahme (Verbrauch)',
  'cons.field.note': 'Notiz',
  'cons.error.required': 'Produkt, Lieferant, Lager und Menge erforderlich.',
  'cons.detail.title': 'Konsignationsbestand',
  'cons.movements': 'Bewegungen',
  'cons.noMovements': 'Keine Bewegungen.',
  'cons.mv.type': 'Art',
  'cons.mv.time': 'Zeit',
  'cons.mv.RECEIPT': 'Eingang',
  'cons.mv.WITHDRAWAL': 'Entnahme',

  // Qualitätsmanagement (QM)
  'qm.title': 'Qualitätsmanagement',
  'qm.subtitle': 'Prüflose mit Verwendungsentscheid - Sperren blockiert verfügbaren Bestand.',
  'qm.empty': 'Keine Prüflose.',
  'qm.col.number': 'Prüflos',
  'qm.col.product': 'Produkt',
  'qm.col.quantity': 'Menge',
  'qm.col.source': 'Herkunft',
  'qm.status.OPEN': 'Offen',
  'qm.status.ACCEPTED': 'Angenommen',
  'qm.status.REJECTED': 'Gesperrt',
  'qm.source.MANUAL': 'Manuell',
  'qm.source.GOODS_RECEIPT': 'Wareneingang',
  'qm.source.PRODUCTION': 'Produktion',
  'qm.action.new': 'Neues Prüflos',
  'qm.action.view': 'Öffnen',
  'qm.action.accept': 'Annehmen',
  'qm.action.reject': 'Sperren',
  'qm.metric.open': 'Offen',
  'qm.metric.accepted': 'Angenommen',
  'qm.metric.rejected': 'Gesperrt',
  'qm.field.product': 'Produkt',
  'qm.field.warehouse': 'Lager',
  'qm.field.quantity': 'Menge',
  'qm.field.source': 'Herkunft',
  'qm.field.characteristics': 'Prüfmerkmale',
  'qm.field.charName': 'Merkmal',
  'qm.field.addChar': '+ Merkmal',
  'qm.result.OK': 'i.O.',
  'qm.result.NOK': 'n.i.O.',
  'qm.modal.title': 'Neues Prüflos',
  'qm.detail.title': 'Prüflos',
  'qm.detail.blocked': '{qty} Stück gesperrt - verfügbarer Bestand reduziert.',
  'qm.noChars': 'Noch keine Merkmale.',
  'qm.error.required': 'Produkt, Lager und Menge erforderlich.',
  'bin.title': 'Lagerplätze',
  'bin.subtitle': 'Bestände auf Lagerplätze einlagern, kommissionieren und umlagern.',
  'bin.empty': 'Keine Lagerplatz-Bestände.',
  'bin.col.bin': 'Platz',
  'bin.col.product': 'Produkt',
  'bin.col.quantity': 'Menge',
  'bin.action.newBin': 'Platz anlegen',
  'bin.action.book': 'Buchung',
  'bin.field.warehouse': 'Lager',
  'bin.field.product': 'Produkt',
  'bin.field.bin': 'Lagerplatz',
  'bin.field.fromBin': 'Von Platz',
  'bin.field.toBin': 'Nach Platz',
  'bin.field.quantity': 'Menge',
  'bin.metric.bins': 'Lagerplätze',
  'bin.metric.occupied': 'Belegt',
  'bin.metric.lines': 'Positionen',
  'bin.op.title': 'Lagerplatz-Buchung',
  'bin.op.type': 'Vorgang',
  'bin.op.putaway': 'Einlagern',
  'bin.op.pick': 'Kommissionieren',
  'bin.op.move': 'Umlagern',
  'bin.create.title': 'Lagerplatz anlegen',
  'bin.create.code': 'Code',
  'bin.create.label': 'Bezeichnung',
  'bin.error.required': 'Produkt, Platz und Menge erforderlich.',
  'bin.error.code': 'Code erforderlich.',

  // Retouren / Warenrückgabe
  'nav.returns': 'Retouren',
  'ret.title': 'Retouren',
  'ret.subtitle': 'Warenrückgaben zum Auftrag erfassen; bei Wareneingang fliesst der Bestand zurück.',
  'ret.empty': 'Keine Retouren.',
  'ret.col.number': 'Nr.',
  'ret.col.date': 'Datum',
  'ret.col.reason': 'Grund',
  'ret.status.REQUESTED': 'Angefragt',
  'ret.status.APPROVED': 'Genehmigt',
  'ret.status.RECEIVED': 'Eingegangen',
  'ret.status.REJECTED': 'Abgelehnt',
  'ret.action.new': 'Neue Retoure',
  'ret.action.view': 'Ansehen',
  'ret.action.approve': 'Genehmigen',
  'ret.action.reject': 'Ablehnen',
  'ret.action.receive': 'Wareneingang',
  'ret.metric.requested': 'Angefragt',
  'ret.metric.approved': 'Genehmigt',
  'ret.metric.received': 'Eingegangen',
  'ret.field.order': 'Auftrag',
  'ret.field.reason': 'Grund',
  'ret.field.product': 'Produkt',
  'ret.field.ordered': 'Bestellt',
  'ret.field.returnQty': 'Rückgabe',
  'ret.field.lineReason': 'Grund',
  'ret.modal.title': 'Neue Retoure',
  'ret.detail.title': 'Retoure',
  'ret.detail.received': 'Ware eingegangen; Bestand zurückgebucht.',
  'ret.error.lines': 'Auftrag und mindestens eine Rückgabemenge erforderlich.',

  // Serviceverträge
  'nav.contracts': 'Serviceverträge',
  'sc.title': 'Serviceverträge',
  'sc.subtitle': 'Service- und Wartungsverträge je Kunde.',
  'sc.empty': 'Keine Verträge.',
  'sc.col.number': 'Nr.',
  'sc.col.customer': 'Kunde',
  'sc.col.title': 'Titel',
  'sc.col.period': 'Laufzeit',
  'sc.status.ACTIVE': 'Aktiv',
  'sc.status.CANCELLED': 'Storniert',
  'sc.status.EXPIRED': 'Abgelaufen',
  'sc.action.new': 'Neuer Vertrag',
  'sc.action.cancel': 'Stornieren',
  'sc.metric.total': 'Verträge',
  'sc.metric.active': 'Aktiv',
  'sc.field.customer': 'Kunde',
  'sc.field.title': 'Titel',
  'sc.field.start': 'Beginn',
  'sc.field.end': 'Ende',
  'sc.modal.title': 'Neuer Servicevertrag',
  'sc.error.required': 'Kunde und Titel erforderlich.',

  // Support-Tickets (After-Sales)
  'nav.tickets': 'Tickets',
  'tk.title': 'Support-Tickets',
  'tk.subtitle': 'Kundenanfragen erfassen, priorisieren und bearbeiten.',
  'tk.empty': 'Keine Tickets.',
  'tk.col.number': 'Nr.',
  'tk.col.customer': 'Kunde',
  'tk.col.subject': 'Betreff',
  'tk.col.priority': 'Priorität',
  'tk.status.OPEN': 'Offen',
  'tk.status.IN_PROGRESS': 'In Arbeit',
  'tk.status.RESOLVED': 'Gelöst',
  'tk.status.CLOSED': 'Geschlossen',
  'tk.priority.LOW': 'Niedrig',
  'tk.priority.MEDIUM': 'Mittel',
  'tk.priority.HIGH': 'Hoch',
  'tk.priority.URGENT': 'Dringend',
  'tk.action.new': 'Neues Ticket',
  'tk.action.view': 'Öffnen',
  'tk.filter.all': 'Alle Status',
  'tk.metric.total': 'Tickets',
  'tk.metric.open': 'Offen/In Arbeit',
  'tk.metric.urgent': 'Dringend',
  'tk.field.customer': 'Kunde',
  'tk.field.priority': 'Priorität',
  'tk.field.contract': 'Vertrag',
  'tk.field.noContract': 'Kein Vertrag',
  'tk.field.subject': 'Betreff',
  'tk.field.description': 'Beschreibung',
  'tk.modal.title': 'Neues Ticket',
  'tk.error.required': 'Kunde und Betreff erforderlich.',
  'tk.detail.title': 'Ticket',
  'tk.move.OPEN': 'Wieder öffnen',
  'tk.move.IN_PROGRESS': 'In Arbeit',
  'tk.move.RESOLVED': 'Lösen',
  'tk.move.CLOSED': 'Schliessen',
  'tk.comments': 'Verlauf',
  'tk.noComments': 'Noch keine Kommentare.',
  'tk.addComment': 'Kommentar hinzufügen…',
  'tk.send': 'Senden',

  // Öffentliche Landingpage
  'landing.nav.login': 'Anmelden',
  'landing.hero.line1': 'Klarheit für',
  'landing.hero.line2': 'Ihr ganzes Geschäft.',
  'landing.hero.sub':
    'Finanzen, Personal, Lager und Verkauf in einem System. Bereit in Tagen, nicht Monaten.',
  'landing.hero.cta': 'Demo buchen',
  'landing.hero.more': 'Mehr erfahren',
  'landing.value1.title': 'Alles in einem System',
  'landing.value1.text':
    'Rechnungen, Lohnläufe, Bestände und Aufträge greifen ineinander, ohne Schnittstellen und ohne doppelte Erfassung.',
  'landing.value2.title': 'Schweizer Präzision',
  'landing.value2.text':
    'Mehrwertsteuer, QR-Rechnung, Mahnwesen und Lohnabrechnung nach Schweizer Standard, auf den Rappen genau.',
  'landing.value3.title': 'In Tagen startklar',
  'landing.value3.text':
    'Keine monatelange Einführung: Demo buchen, Zugang erhalten, arbeiten.',
  'landing.stat1.label': 'Module',
  'landing.stat2.label': 'Sprachen',
  'landing.stat3.label': 'System',
  'landing.form.title': 'Demo buchen',
  'landing.form.sub':
    'Erzählen Sie uns kurz, wer Sie sind. Wir melden uns innerhalb eines Arbeitstages.',
  'landing.form.point1': 'Antwort innerhalb eines Arbeitstages',
  'landing.form.point2': 'Auf Ihr Unternehmen zugeschnitten',
  'landing.form.point3': 'Kein Verkaufsdruck, keine Verpflichtung',
  'landing.form.name.label': 'Wie heissen Sie?',
  'landing.form.name.placeholder': 'Vor- und Nachname',
  'landing.form.company.label': 'Für welches Unternehmen arbeiten Sie?',
  'landing.form.company.placeholder': 'Firmenname',
  'landing.form.email.label': 'Wie erreichen wir Sie?',
  'landing.form.email.placeholder': 'name@firma.ch',
  'landing.form.message.label': 'Möchten Sie uns etwas mitgeben?',
  'landing.form.message.placeholder': 'Optional: Was sollen wir für Sie vorbereiten?',
  'landing.form.next': 'Weiter',
  'landing.form.back': 'Zurück',
  'landing.form.skip': 'Überspringen',
  'landing.form.enter': 'oder Enter drücken',
  'landing.form.review.title': 'Alles bereit.',
  'landing.form.review.name': 'Name',
  'landing.form.review.company': 'Unternehmen',
  'landing.form.review.email': 'E-Mail',
  'landing.form.review.message': 'Nachricht',
  'landing.form.submit': 'Anfrage senden',
  'landing.form.sending': 'Wird gesendet…',
  'landing.form.error.required': 'Bitte füllen Sie dieses Feld aus.',
  'landing.form.error.email': 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  'landing.form.error.submit': 'Das hat leider nicht geklappt. Bitte versuchen Sie es erneut.',
  'landing.form.done.title': 'Vielen Dank!',
  'landing.form.done.text':
    'Ihre Anfrage ist bei uns eingegangen. Wir melden uns innerhalb eines Arbeitstages bei Ihnen.',
  'landing.footer.copyright': '© {year} Recica Solutions',
  'landing.claim': 'Weniger Werkzeuge, weniger Doppelarbeit, mehr Übersicht.',
  'landing.modules.title': 'Alles drin, was ein ERP können muss',
  'landing.modules.sub':
    'Sieben Module auf einem gemeinsamen Datenbestand. Jede Zahl wird genau einmal erfasst und stimmt überall.',
  'landing.module.finance.name': 'Finanzen',
  'landing.module.finance.text':
    'Doppelte Buchhaltung, Rechnungen mit QR-Zahlteil, Mehrwertsteuer, Mahnwesen, Anlagen und Periodenabschluss.',
  'landing.module.hr.name': 'Personal',
  'landing.module.hr.text':
    'Mitarbeiterdossiers, Lohnabrechnung, Abwesenheiten, Spesen und Rekrutierung an einem Ort.',
  'landing.module.inventory.name': 'Lager & Einkauf',
  'landing.module.inventory.text':
    'Bestände in Echtzeit, Bestellungen mit Freigaben, Inventur, Chargen und Disposition.',
  'landing.module.sales.name': 'Verkauf',
  'landing.module.sales.text':
    'Vom Angebot über Auftrag und Lieferung bis zur Rechnung, mit Preislisten und Kreditlimiten.',
  'landing.module.projects.name': 'Projekte',
  'landing.module.projects.text':
    'Projekte, Zeiterfassung und Spesen, sauber verrechenbar bis auf die Position.',
  'landing.module.production.name': 'Produktion',
  'landing.module.production.text':
    'Stücklisten, Arbeitsaufträge, Arbeitsplätze und Kapazitätsplanung für die Fertigung.',
  'landing.module.automation.name': 'Automatisierung',
  'landing.module.automation.text':
    'Regeln und Alarme erledigen Routineaufgaben, bevor sie auf Ihrem Schreibtisch landen.',
  'landing.feat1.title': 'Vom Angebot zur bezahlten Rechnung',
  'landing.feat1.text':
    'Ein Beleg führt zum nächsten: Angebot, Auftrag, Lieferung, Rechnung, Zahlung. Ohne Abtippen, ohne Medienbruch.',
  'landing.feat1.point1': 'Rechnungen mit Schweizer QR-Zahlteil',
  'landing.feat1.point2': 'Automatisches Mahnwesen in drei Stufen',
  'landing.feat1.point3': 'Wiederkehrende Rechnungen für Abos und Verträge',
  'landing.feat2.title': 'Zahlen, denen Sie vertrauen können',
  'landing.feat2.text':
    'Dashboards und Berichte direkt aus der Buchhaltung, auf den Rappen genau und immer aktuell.',
  'landing.feat2.point1': 'Erfolgsrechnung und Bilanz auf Knopfdruck',
  'landing.feat2.point2': 'Kostenstellen und Budgets im Blick',
  'landing.feat2.point3': 'Mehrwertsteuer-Abrechnung vorbereitet',
  'landing.feat3.title': 'Ein Kalender für das ganze Unternehmen',
  'landing.feat3.text':
    'Abwesenheiten, Termine und Fälligkeiten an einem Ort - jeder sieht, was ansteht.',
  'landing.feat3.point1': 'Urlaubsanträge mit Freigabe-Ablauf',
  'landing.feat3.point2': 'Lohnabrechnung mit einem Klick vorbereitet',
  'landing.feat3.point3': 'Benachrichtigungen im Posteingang und per E-Mail',
  'landing.how.title': 'In drei Schritten startklar',
  'landing.how1.title': 'Demo buchen',
  'landing.how1.text':
    'Nehmen Sie Kontakt mit uns auf - wir zeigen Ihnen das System und richten Ihren Zugang ein. Keine Installation, kein Projektteam.',
  'landing.how2.title': 'Stammdaten erfassen',
  'landing.how2.text': 'Kunden, Produkte und Konten importieren oder direkt anlegen.',
  'landing.how3.title': 'Arbeiten',
  'landing.how3.text': 'Der erste Beleg steht in Minuten. Ihr Team findet sich ohne Schulung zurecht.',
  'landing.module.finance.f1': 'Rechnungen, Gutschriften & Abos',
  'landing.module.finance.f2': 'QR-Rechnung & Mahnwesen',
  'landing.module.finance.f3': 'Hauptbuch, Bilanz & Erfolgsrechnung',
  'landing.module.finance.f4': 'Kostenstellen, Budgets & Controlling',
  'landing.module.finance.f5': 'Anlagen & Periodenabschluss',
  'landing.module.finance.f6': 'Zahlungsläufe, Bank & Mehrwertsteuer',
  'landing.module.hr.f1': 'Mitarbeiterdossiers',
  'landing.module.hr.f2': 'Zeiterfassung',
  'landing.module.hr.f3': 'Abwesenheiten & Ferien',
  'landing.module.hr.f4': 'Lohnabrechnung',
  'landing.module.hr.f5': 'Spesen & Reisekosten',
  'landing.module.hr.f6': 'Rekrutierung & Mitarbeitergespräche',
  'landing.module.inventory.f1': 'Artikel & Bestände in Echtzeit',
  'landing.module.inventory.f2': 'Bestellungen mit Freigaben',
  'landing.module.inventory.f3': 'Lieferanten & Bewertung',
  'landing.module.inventory.f4': 'Chargen, Serien & Lagerplätze',
  'landing.module.inventory.f5': 'Inventur & Qualitätsprüfung',
  'landing.module.inventory.f6': 'Disposition & Verfügbarkeit',
  'landing.module.sales.f1': 'Kunden & Preislisten',
  'landing.module.sales.f2': 'Angebote & Aufträge',
  'landing.module.sales.f3': 'Lieferscheine & Retouren',
  'landing.module.sales.f4': 'Verkaufschancen im Blick',
  'landing.module.sales.f5': 'Serviceverträge & Tickets',
  'landing.module.sales.f6': 'Kreditlimiten & Berichte',
  'landing.module.projects.f1': 'Projekte & Aufgaben',
  'landing.module.projects.f2': 'Zeiterfassung auf Projekte',
  'landing.module.projects.f3': 'Spesen mit Freigabe',
  'landing.module.projects.f4': 'Verrechnung bis auf die Position',
  'landing.module.production.f1': 'Stücklisten',
  'landing.module.production.f2': 'Arbeitsaufträge & Rückmeldungen',
  'landing.module.production.f3': 'Arbeitsplätze',
  'landing.module.production.f4': 'Kapazitätsplanung',
  'landing.module.production.f5': 'Materialbedarfsplanung',
  'landing.module.automation.f1': 'Automatische Regeln',
  'landing.module.automation.f2': 'Alarme & Erinnerungen',
  'landing.module.automation.f3': 'Benachrichtigungen im Posteingang',
  'landing.module.automation.f4': 'E-Mail-Versand',
  'landing.extras.title': 'In jedem Modul inbegriffen',
  'landing.extras.i1': 'Persönliches Dashboard mit Kennzahlen',
  'landing.extras.i2': 'Posteingang & Benachrichtigungen',
  'landing.extras.i3': 'Firmenkalender mit Terminen & Abwesenheiten',
  'landing.extras.i4': 'Globale Suche über alles',
  'landing.extras.i5': 'Rollen & Berechtigungen',
  'landing.extras.i6': 'Lückenloses Änderungsprotokoll',
  'landing.extras.i7': 'Mehrere Währungen',
  'landing.extras.i8': 'Deutsch, Englisch, Französisch',
  'landing.nav.modules': 'Module',
  'landing.nav.features': 'Funktionen',
  'landing.nav.how': 'Ablauf',
  'landing.hero.eyebrow': 'Schweizer Unternehmenssoftware',
  'landing.hero.cue': 'Scrollen',
  'landing.hero.meta': '7 Module · 3 Sprachen · 1 Datenbestand',
  'landing.values.kicker': 'Warum RSZ ERP',
  'landing.values.title': 'Ein System statt fünf Insellösungen',
  'landing.claim.note':
    'Ein Datenbestand für Finanzen, Personal, Lager, Verkauf, Projekte und Produktion.',
  'landing.modules.kicker': 'Module',
  'landing.extras.kicker': 'Inbegriffen',
  'landing.features.kicker': 'Belegfluss',
  'landing.how.kicker': 'Ablauf',
  'landing.close.text': 'Sieben Module, ein Datenbestand, eine Oberfläche.',
  'landing.frame.debtors': 'Debitoren',
  'landing.frame.report': 'Erfolgsrechnung',
  'landing.frame.calendar': 'Firmenkalender',
  'landing.frame.week': 'KW 31',
  'landing.kpi.open': 'Offene Posten',
  'landing.kpi.overdue': 'Überfällig',
  'landing.kpi.terms': 'Zahlungsfrist',
  'landing.kpi.termsValue': '24 Tage',
  'landing.state.open': 'Offen',
  'landing.state.paid': 'Bezahlt',
  'landing.state.dunned': 'Mahnung 1',
  'landing.doc.quote': 'Angebot',
  'landing.doc.order': 'Auftrag',
  'landing.doc.invoice': 'Rechnung',
  'landing.doc.qr': 'QR-Zahlteil',

  // ----- Anbieterebene (/platform) -----
  'platform.badge': 'Anbietersicht',
  'platform.signOut': 'Abmelden',
  'platform.nav.tenants': 'Mandanten',
  'platform.nav.demoRequests': 'Demo-Anfragen',
  'platform.roles.owner': 'Vollzugriff',
  'platform.roles.support': 'Betreuung',
  'platform.login.title': 'Anbieteranmeldung',
  'platform.login.hint': 'Eigenes Konto, getrennt von Ihrer normalen Anmeldung. Beide Sitzungen können gleichzeitig offen sein.',
  'platform.login.cta': 'Anmelden',
  'platform.login.cta.loading': 'Wird angemeldet…',
  'platform.login.failed': 'Anmeldung fehlgeschlagen',
  'platform.tenants.title': 'Mandanten',
  'platform.tenants.subtitle': 'Alle Firmen, die das ERP einsetzen. Nicht zu verwechseln mit Kunden im Vertrieb, das sind Debitoren.',
  'platform.tenants.col.slug': 'Kürzel',
  'platform.tenants.col.name': 'Firma',
  'platform.tenants.col.contact': 'Ansprechpartner',
  'platform.tenants.col.phone': 'Telefon',
  'platform.tenants.col.created': 'Angelegt',
  'platform.tenants.status.all': 'Alle Status',
  'platform.tenants.status.active': 'Aktiv',
  'platform.tenants.status.provisioning': 'In Einrichtung',
  'platform.tenants.status.blocked': 'Gesperrt',
  'platform.tenants.status.failed': 'Fehlgeschlagen',
  'platform.tenants.status.deleting': 'Wird abgebaut',
  'platform.tenants.status.deleted': 'Abgebaut',
  'platform.tenants.block': 'Sperren',
  'platform.tenants.unblock': 'Entsperren',
  'platform.tenants.create.cta': 'Neue Firma',
  'platform.tenants.create.title': 'Neue Firma anlegen',
  'platform.tenants.create.hint': 'Legt die Firma an und richtet sie ein: eigene Datenbanken, Kontenrahmen und das erste Konto. Das dauert wenige Sekunden.',
  'platform.tenants.create.saving': 'Wird angelegt…',
  'platform.tenants.create.failed': 'Firma konnte nicht angelegt werden',
  'platform.tenants.delete.cta': 'Firma entfernen',
  'platform.tenants.delete.title': '{name} entfernen',
  'platform.tenants.delete.working': 'Wird entfernt…',
  'platform.tenants.delete.failed': 'Entfernen nicht möglich',
  'platform.tenants.delete.warning': 'Alle acht Datenbanken dieser Firma, ihre Datenbankrolle und alle ihre Konten werden entfernt. Das lässt sich nicht zurücknehmen.',
  'platform.tenants.delete.backupHint': 'Vorher sichern. Der Befehl legt einen Ordner mit allen acht Abzügen und einer Anleitung zur Wiederherstellung an:',
  'platform.tenants.delete.confirmLabel': 'Zum Bestätigen {slug} eintippen',
  'platform.users.title': 'Benutzer der Firma',
  'platform.users.hint': 'Anlegen, sperren und Kennwörter zurücksetzen. Ein Anmelden als Kunde gibt es nicht - dafür existiert kein Weg im Programm.',
  'platform.users.empty': 'Diese Firma hat noch keine Benutzer.',
  'platform.users.loading': 'Benutzer werden geladen…',
  'platform.users.col.name': 'Name',
  'platform.users.col.roles': 'Rollen',
  'platform.users.col.status': 'Zustand',
  'platform.users.active': 'Aktiv',
  'platform.users.blocked': 'Gesperrt',
  'platform.users.block': 'Sperren',
  'platform.users.unblock': 'Entsperren',
  'platform.users.update.failed': 'Änderung nicht möglich',
  'platform.users.create.cta': 'Benutzer anlegen',
  'platform.users.create.title': 'Neuen Benutzer anlegen',
  'platform.users.create.saving': 'Wird angelegt…',
  'platform.users.create.failed': 'Benutzer konnte nicht angelegt werden',
  'platform.users.create.passwordHint': 'Mindestens 10 Zeichen. Der Benutzer sollte es nach der ersten Anmeldung ändern.',
  'platform.users.reset.cta': 'Kennwort zurücksetzen',
  'platform.users.reset.title': 'Einmal-Link zum Setzen des Kennworts',
  'platform.users.reset.explain': 'Geben Sie diesen Link an {email} weiter. Das Kennwort wählt die Person selbst - Sie erfahren es nicht.',
  'platform.users.reset.once': 'Der Link lässt sich genau einmal benutzen und läuft nach 24 Stunden ab. Alle laufenden Sitzungen dieser Person sind bereits beendet.',
  'platform.users.reset.failed': 'Zurücksetzen nicht möglich',
  'setPassword.title': 'Kennwort setzen',
  'setPassword.hint': 'Wählen Sie ein neues Kennwort. Danach können Sie sich damit anmelden.',
  'setPassword.new': 'Neues Kennwort',
  'setPassword.repeat': 'Wiederholen',
  'setPassword.tooShort': 'Mindestens 10 Zeichen.',
  'setPassword.mismatch': 'Die beiden Eingaben stimmen nicht überein.',
  'setPassword.cta': 'Kennwort setzen',
  'setPassword.saving': 'Wird gesetzt…',
  'setPassword.failed': 'Das hat nicht geklappt.',
  'setPassword.noToken': 'Diesem Aufruf fehlt der Link. Bitte den vollständigen Link aus der Nachricht öffnen.',
  'setPassword.done': 'Fertig. Sie können sich jetzt mit {email} anmelden.',
  'setPassword.toLogin': 'Zur Anmeldung',
  'platform.tenants.section.company': 'Firma',
  'platform.tenants.section.admin': 'Erstes Konto',
  'platform.tenants.section.admin.hint': 'Damit meldet sich die Firma zum ersten Mal an. Es gibt keine öffentliche Registrierung, über die sie sich selbst eines anlegen könnte.',
  'platform.tenants.section.letterhead': 'Briefkopf',
  'platform.tenants.section.letterhead.hint': 'Erscheint auf Rechnungen, Mahnungen und Lieferscheinen der Firma. Lässt sich später in ihren Einstellungen ändern.',
  'platform.tenants.admin.email': 'Anmeldeadresse',
  'platform.tenants.admin.password': 'Kennwort',
  'platform.tenants.admin.password.hint': 'Mindestens 10 Zeichen. Der Kunde sollte es nach der ersten Anmeldung ändern.',
  'platform.tenants.admin.firstName': 'Vorname',
  'platform.tenants.admin.lastName': 'Nachname',
  'platform.tenants.company.address': 'Strasse und Nummer',
  'platform.tenants.company.zip': 'PLZ',
  'platform.tenants.company.city': 'Ort',
  'platform.tenants.company.iban': 'IBAN',
  'platform.tenants.company.vat': 'MWST-Nummer',
  'platform.provisioning.title': 'Firma wird eingerichtet',
  'platform.provisioning.starting': 'Der Auftrag wird übernommen…',
  'platform.provisioning.running': 'Läuft:',
  'platform.provisioning.done': 'Fertig. Die Firma ist freigeschaltet.',
  'platform.provisioning.failed': 'Die Einrichtung ist fehlgeschlagen.',
  'platform.provisioning.rolledBack': 'Die Einrichtung wurde zurückgenommen.',
  'platform.provisioning.rolledBack.hint': 'Es sind keine Datenbanken und keine Konten zurückgeblieben. Das Kürzel ist sofort wieder benutzbar.',
  'platform.provisioning.pleaseWait': 'Bitte warten…',
  'platform.provisioning.readyHint': 'Die Firma kann sich jetzt mit {email} anmelden.',
  'platform.provisioning.step.role': 'Datenbankrolle anlegen',
  'platform.provisioning.step.registry': 'Zuordnung eintragen',
  'platform.provisioning.step.company': 'Briefkopf hinterlegen',
  'platform.provisioning.step.admin': 'Erstes Konto anlegen',
  'platform.provisioning.step.smoke': 'Nachprüfen',
  'platform.provisioning.step.activate': 'Freischalten',
  'platform.provisioning.step.db': 'Datenbank {service}',
  'platform.provisioning.step.migrate': 'Tabellen {service}',
  'platform.provisioning.step.drop': 'Datenbank {name} entfernen',
  'platform.tenants.slug.hint': 'Kleinbuchstabe am Anfang, danach Kleinbuchstaben, Ziffern oder Unterstrich. Bildet später die Datenbanknamen und ist danach unveränderlich.',
  'platform.tenants.searchPlaceholder': 'Firma oder Kürzel suchen…',
  'platform.tenants.count': '{count} Firmen',
  'platform.tenants.empty': 'Noch keine Firma angelegt',
  'platform.tenants.provisioningNote': 'Firmen mit dem Status In Einrichtung haben noch keine eigenen Datenbanken. Ihre Benutzer können sich noch nicht anmelden. Die Einrichtung auf Knopfdruck kommt in einer späteren Etappe.',
  'platform.demo.title': 'Demo-Anfragen',
  'platform.demo.subtitle': 'Anfragen über das Formular der öffentlichen Seite. Sichtbar nur hier, nicht in einer Kundeninstallation.',
  'platform.demo.col.received': 'Eingegangen',
  'platform.demo.col.company': 'Firma',
  'platform.demo.col.name': 'Name',
  'platform.demo.col.message': 'Nachricht',
  'platform.demo.status.all': 'Alle Status',
  'platform.demo.status.new': 'Neu',
  'platform.demo.status.seen': 'Gesehen',
  'platform.demo.status.contacted': 'Kontaktiert',
  'platform.demo.status.closed': 'Erledigt',
  'platform.demo.searchPlaceholder': 'Firma, Name oder E-Mail suchen…',
  'platform.demo.count': '{count} Anfragen',
  'platform.demo.empty': 'Noch keine Anfrage eingegangen',

  // ----- Entscheidung über einen Ferienantrag -----
  'hr.leave.action.cancel': 'Stornieren',
  'hr.leave.decide.approve.title': 'Antrag genehmigen',
  'hr.leave.decide.reject.title': 'Antrag ablehnen',
  'hr.leave.decide.cancel.title': 'Abwesenheit stornieren',
  'hr.leave.decide.noteRequired': 'Begründung (erforderlich)',
  'hr.leave.decide.noteOptional': 'Bemerkung (optional)',

  // ----- Mandantenakte und Anbieterprotokoll -----
  'platform.tenants.masterData': 'Stammdaten',
  'platform.tenants.col.plan': 'Vertrag',
  'platform.tenants.col.contractStart': 'Vertragsbeginn',
  'platform.tenants.col.contractEnd': 'Vertragsende',
  'platform.tenants.col.notes': 'Notizen',
  'platform.tenants.saved': 'Gespeichert.',
  'platform.tenants.save.failed': 'Speichern fehlgeschlagen',
  'platform.tenants.blockedNote': 'Diese Firma ist gesperrt. Ihre Benutzer können sich nicht anmelden, die Daten bleiben aber vollständig erhalten.',
  'platform.tenants.loading': 'Wird geladen…',
  'platform.audit.title': 'Was wir an dieser Firma getan haben',
  'platform.audit.subtitle': 'Nur Anbieteraktionen. Was innerhalb der Firma passiert, steht in deren eigenem Protokoll und ist von hier aus nicht einsehbar.',
  'platform.audit.empty': 'Noch keine Aktion protokolliert',
  'platform.audit.col.when': 'Wann',
  'platform.audit.col.who': 'Wer',
  'platform.audit.col.what': 'Was',
  'platform.audit.col.entity': 'Betrifft',
  'platform.audit.action.create': 'Angelegt',
  'platform.audit.action.update': 'Geändert',
  'platform.audit.action.delete': 'Gelöscht',
  // ---- Der Monatsabschluss und die Vorgesetztensicht (Paket 7)
  'month.name.1': 'Januar',
  'month.name.2': 'Februar',
  'month.name.3': 'März',
  'month.name.4': 'April',
  'month.name.5': 'Mai',
  'month.name.6': 'Juni',
  'month.name.7': 'Juli',
  'month.name.8': 'August',
  'month.name.9': 'September',
  'month.name.10': 'Oktober',
  'month.name.11': 'November',
  'month.name.12': 'Dezember',
  'nav.myTeam': 'Zu meiner Entscheidung',
  'month.status.DRAFT': 'In Arbeit',
  'month.status.SUBMITTED': 'Eingereicht',
  'month.status.APPROVED': 'Freigegeben',
  'month.status.REJECTED': 'Zurückgewiesen',
  'month.target': 'Soll',
  'month.actual': 'Ist',
  'month.balance': 'Saldo',
  'month.submit': 'Monat einreichen',
  'month.withdraw': 'Zurückziehen',
  'month.waiting': 'Wartet auf Freigabe',
  'month.approvedHint': 'Freigegeben - Änderungen nur nach Wiedereröffnung',
  'month.rejectedNote': 'Zurückgewiesen: {note}',
  'team.title': 'Zu meiner Entscheidung',
  'team.subtitle': 'Ferienanträge und Monatsabschlüsse der Leute, die an mich berichten.',
  'team.noReports': 'An Sie berichtet zurzeit niemand. Sobald jemand Ihnen zugeordnet ist, erscheinen dessen Anträge hier.',
  'team.col.who': 'Wer',
  'team.col.range': 'Zeitraum',
  'team.col.days': 'Tage',
  'team.col.reason': 'Grund',
  'team.col.month': 'Monat',
  'team.col.hours': 'Stunden',
  'team.col.status': 'Zustand',
  'team.check': 'Ansehen',
  'team.approve': 'Genehmigen',
  'team.approveMonth': 'Freigeben',
  'team.reject': 'Zurückweisen',
  'team.daysUnit': 'Tage',
  'team.leave.title': 'Ferienanträge',
  'team.leave.hint': 'Offene Anträge. Vor der Entscheidung sehen Sie, wer sonst noch weg ist.',
  'team.leave.empty': 'Kein offener Ferienantrag.',
  'team.leave.decide': 'Ferienantrag entscheiden',
  'team.months.title': 'Monatsabschlüsse',
  'team.months.hint': 'Eingereichte Monate. Nach der Freigabe lässt sich daran nichts mehr ändern.',
  'team.months.empty': 'Kein Monat wartet auf Freigabe.',
  'team.months.decide': 'Monat entscheiden',
  'team.months.note': 'Bemerkung',
  'team.months.notePlaceholder': 'Bei einer Zurückweisung: was fehlt?',
  'team.overlaps.title': 'Wer ist sonst noch weg?',
  'team.overlaps.none': 'Niemand sonst in diesem Zeitraum.',
  'hr.employees.modal.manager': 'Vorgesetzte Person',
  'hr.employees.modal.noManager': 'Keine',
  'hr.employees.modal.managerHint': 'Entscheidet über Ferienanträge und Monatsabschlüsse dieser Person.',
  // ---- Halbe Tage, Jahreswechsel und Übertrag (Paket 8)
  'self.leave.startHalf': 'Erster Tag nur halb',
  'self.leave.endHalf': 'Letzter Tag nur halb',
  'self.leave.preview.cost': 'Kostet dich',
  'self.leave.preview.year': '{cost} Tage - von {before} bleiben {after}',
  'self.leave.preview.short': 'Guthaben reicht nicht',
  'hr.leave.close.title': 'Jahresabschluss Ferien',
  'hr.leave.close.subtitle': 'Restferien ins neue Jahr übertragen - mit Stichtag, an dem sie verfallen.',
  'hr.leave.close.year': 'Jahr',
  'hr.leave.close.maxCarry': 'Höchstens übertragen',
  'hr.leave.close.maxCarryHint': 'Leer heisst: alles übertragen. Null heisst: nichts.',
  'hr.leave.close.expires': 'Verfällt am',
  'hr.leave.close.preview': 'Vorschau',
  'hr.leave.close.run': 'Abschluss durchführen',
  'hr.leave.close.col.carry': 'Übertrag',
  'hr.leave.close.col.forfeited': 'Verfällt',
  'hr.leave.close.col.remaining': 'Rest',
  'hr.leave.close.done': '{count} Personen abgeschlossen, {carried} Tage übertragen.',
  'hr.leave.close.skipped': 'Bereits abgeschlossen und deshalb übersprungen: {names}',
  'hr.leave.col.carriedOver': 'Übertrag',
  'hr.employees.modal.annualLeave': 'Ferientage pro Jahr',
  'hr.employees.modal.annualLeaveHint': 'Leer heisst: der Standardwert der Ferienart gilt. Bei Eintritt mitten im Jahr wird anteilig gerechnet.',
  // ---- Schweizer Abwesenheitsarten und pflegbare Feiertage (Paket 9)
  'nav.leaveTypes': 'Arten und Feiertage',
  'leave.type.ANNUAL': 'Ferien',
  'leave.type.SICK': 'Krankheit',
  'leave.type.UNFALL': 'Unfall',
  'leave.type.MILITAER': 'Militär- und Zivildienst',
  'leave.type.MUTTERSCHAFT': 'Mutterschaft',
  'leave.type.VATERSCHAFT': 'Vaterschaft',
  'leave.type.BETREUUNG': 'Betreuung Angehöriger',
  'leave.type.KURZABSENZ': 'Kurzabsenz',
  'leave.type.KOMPENSATION': 'Kompensation',
  'leave.type.UNPAID': 'Unbezahlter Urlaub',
  'leave.type.WEITERBILDUNG': 'Weiterbildung',
  'leave.type.PARENT': 'Elternzeit (alt)',
  'hr.types.title': 'Abwesenheitsarten und Feiertage',
  'hr.types.subtitle': 'Was sich beantragen lässt, unter welchen Regeln - und welche Tage kein Guthaben kosten.',
  'hr.types.tab': 'Abwesenheitsarten',
  'hr.types.new': 'Neue Art',
  'hr.types.edit': 'Art bearbeiten',
  'hr.types.empty': 'Noch keine Abwesenheitsart.',
  'hr.types.inactive': 'Stillgelegt',
  'hr.types.col.name': 'Bezeichnung',
  'hr.types.col.code': 'Kürzel',
  'hr.types.col.quota': 'Kontingent',
  'hr.types.col.rules': 'Regeln',
  'hr.types.codeHint': 'Nachträglich nicht änderbar - Guthaben und Anträge hängen daran.',
  'hr.types.color': 'Farbe',
  'hr.types.colorHint': 'Ein Name, kein Farbwert. Die Gestaltung kommt aus den Design-Tokens und kennt beide Farbschemata.',
  'hr.types.color.neutral': 'Neutral',
  'hr.types.color.info': 'Blau',
  'hr.types.color.success': 'Grün',
  'hr.types.color.warning': 'Gelb',
  'hr.types.color.danger': 'Rot',
  'hr.types.color.accent': 'Akzent',
  'hr.types.notice': 'Vorlauf in Tagen',
  'hr.types.quota': 'Tage pro Jahr',
  'hr.types.isPaid': 'Bezahlt',
  'hr.types.active': 'Zur Auswahl anbieten',
  'hr.types.activeHint': 'Stillgelegte Arten bleiben lesbar, tauchen aber in keinem Antrag mehr auf.',
  'hr.types.requiresBalance': 'Gegen ein Jahreskontingent buchen',
  'hr.types.requiresBalanceHint': 'Krankheit ist in der Schweiz kein Kontingent.',
  'hr.types.requiresApproval': 'Braucht eine Freigabe',
  'hr.types.requiresApprovalHint': 'Ohne Haken gilt der Antrag sofort - passend für eine Krankmeldung.',
  'hr.types.allowsRetroactive': 'Rückwirkend beantragbar',
  'hr.types.allowsRetroactiveHint': 'Ferien plant man, Krankheit nicht.',
  'hr.types.requiresDocument': 'Beleg nötig',
  'hr.types.requiresDocumentHint': 'Arztzeugnis, Marschbefehl, Geburtsurkunde. Ein Hinweis, keine Sperre.',
  'hr.types.flag.noApproval': 'gilt sofort',
  'hr.types.flag.noRetro': 'nicht rückwirkend',
  'hr.types.flag.document': 'Beleg',
  'hr.types.flag.notice': '{days} Tage Vorlauf',
  'hr.holidays.tab': 'Feiertage',
  'hr.holidays.new': 'Tage eintragen',
  'hr.holidays.empty': 'Keine Einträge.',
  'hr.holidays.emptyYear': 'Für {year} ist kein einziger Tag hinterlegt. Solange das so bleibt, kostet jeder Feiertag dieses Jahres einen Ferientag.',
  'hr.holidays.col.date': 'Datum',
  'hr.holidays.col.name': 'Bezeichnung',
  'hr.holidays.col.kind': 'Art',
  'hr.holidays.kind.PUBLIC': 'Gesetzlich',
  'hr.holidays.kind.BRIDGE': 'Brückentag',
  'hr.holidays.kind.COMPANY': 'Betriebsferien',
  'hr.holidays.from': 'Von',
  'hr.holidays.to': 'Bis',
  'hr.holidays.toHint': 'Leer lassen für einen einzelnen Tag.',
  'self.leave.preview.document': 'Dafür wird ein Beleg gebraucht.',
  'self.leave.preview.noApproval': 'Gilt sofort - keine Freigabe nötig.',
  // ---- Abwesenheitskalender als Monatsraster (Paket 10)
  'weekday.short.mon': 'Mo',
  'weekday.short.tue': 'Di',
  'weekday.short.wed': 'Mi',
  'weekday.short.thu': 'Do',
  'weekday.short.fri': 'Fr',
  'weekday.short.sat': 'Sa',
  'weekday.short.sun': 'So',
  'hr.leave.calendar.loading': 'Kalender wird geladen…',
  'hr.leave.calendar.thisMonth': 'Dieser Monat',
  'hr.leave.calendar.showPending': 'Offene Anträge zeigen',
  'hr.leave.calendar.legend.approved': 'Genehmigt',
  'hr.leave.calendar.legend.pending': 'Beantragt',
  // ---- Ausfuhr, Monatsrapport und Filter (Paket 11)
  'hrtime.report.open': 'Monatsrapport',
  'hrtime.report.title': 'Monatsrapport',
  'hrtime.report.employeeNumber': 'Personalnummer',
  'hrtime.report.sum': 'Summe',
  'hrtime.report.signEmployee': 'Unterschrift Mitarbeitende(r)',
  'hrtime.report.signManager': 'Unterschrift Vorgesetzte(r)',
  'hrtime.report.pickEmployee': 'Ein Rapport gehört immer zu einer Person. Bitte oben eine Mitarbeiterin oder einen Mitarbeiter auswählen.',
  'hrtime.truncated': 'Es werden {shown} von {total} Zeilen gezeigt. Für den vollständigen Bestand den Zeitraum einengen.',
  'hr.leave.filter.status': 'Zustand',
  'hr.leave.filter.all': 'Alle',
  'hr.leave.filter.count': '{shown} von {total} gezeigt',
  'hrtime.type.ABSENCE': 'Abwesenheit',
  'hrtime.report.pickRange': 'Ein Rapport braucht einen Zeitraum. Bitte auf der Zeitseite Von und Bis setzen.',
  'hrtime.report.unknownEmployee': 'Unbekannt',
  'hrtime.exportBlocked': 'Die Liste ist gekürzt. Für eine vollständige Datei den Zeitraum einengen.',
  // ---- Erinnerungen statt Einsammeln (Paket 12)
  'notif.time_submitted': 'Monat {month}/{year} von {employeeName} eingereicht - wartet auf Freigabe',
  'notif.time_approved': 'Ihr Monat {month}/{year} wurde freigegeben',
  'notif.time_rejected': 'Ihr Monat {month}/{year} wurde zurückgewiesen - bitte korrigieren',
  'notif.time_gaps': '{missingCount} Tag(e) ohne Zeiterfassung zwischen {from} und {to}',
  'notif.time_approval_due': 'Monat {month}/{year} von {employeeName} wartet seit {waitingDays} Tagen',
  'notif.leave_approval_due': 'Ferienantrag von {employeeName} wartet seit {waitingDays} Tagen',
  'platform.tenants.delete.mustBlockFirst': 'Diese Firma ist noch aktiv. Sie lässt sich erst entfernen, wenn sie gesperrt ist - das gibt eine Denkpause zwischen Entscheidung und Vollzug.',
  // ---- Das Stundenkonto (Paket 13)
  'timeAccount.title': 'Stundenkonto',
  'timeAccount.unit': 'h',
  'timeAccount.asOf': 'Stand {date}',
  'timeAccount.opening': 'Anfangsbestand',
  'timeAccount.closedOne': 'Ein freigegebener Monat',
  'timeAccount.closed': '{count} freigegebene Monate',
  'timeAccount.open': 'Laufend seit {from}',
  'timeAccount.compensated': 'Darin enthalten: {hours} h bezogene Kompensation. Sie zählt nicht als geleistete Zeit - das Guthaben ist damit verbraucht.',
  'timeAccount.gap': 'Nicht durchgehend freigegeben: {months}. Die Zahl stimmt, sie stammt nur nicht aus lauter festen Monaten.',
  'timeAccount.noStart': 'Für diese Person ist kein Beginn hinterlegt. Ohne Eintrittsdatum oder Stichtag lässt sich kein Kontostand rechnen.',
  'timeAccount.col.total': 'Konto',
  'timeAccount.col.opening': 'Anfang',
  'timeAccount.col.closed': 'Freigegeben',
  'timeAccount.col.open': 'Laufend',
  'timeAccount.team.title': 'Stundenkonten',
  'timeAccount.team.hint': 'Der Gesamtstand meiner Leute. Ein Kompensationstag zehrt ihn auf - wer darüber entscheidet, sollte ihn vorher sehen.',
  'timeAccount.team.empty': 'Noch kein Stundenkonto.',
  'timeAccount.forDecision': 'Stundenkonto: {hours} h',
  'time.week.compensated': '{hours} h kompensiert',
  'time.balance.compensated': 'Kompensiert',
  'hr.types.countsAsWorktime': 'Zählt als Arbeitszeit',
  'hr.types.countsAsWorktimeHint': 'An heisst: ein Tag dieser Art zählt wie ein gearbeiteter, das Stundenkonto bleibt unverändert. Aus heisst: er zehrt das Guthaben auf - so bei der Kompensation.',
  'hr.types.flag.consumesTime': 'zehrt Stundenkonto',
  'timeAccount.setOpening': 'Anfangsbestand setzen',
  'timeAccount.openingHint': 'Wer dieses System einführt, bringt bestehende Stunden mit. Der Stichtag sagt, ab wann das System selbst rechnet - davor gilt allein der Anfangsbestand.',
  'timeAccount.openingField': 'Anfangsbestand (h)',
  'timeAccount.startField': 'Rechnet ab',
  // ---- Belege ueber mehr als ein Blatt (Paket 1)
  'pdf.page': 'Seite {n} von {total}',
  // ---- Kennwort wechseln und zuruecksetzen (Paket 1)
  'common.saving': 'Wird gespeichert…',
  'common.copy': 'Kopieren',
  'common.copied': 'Kopiert',
  'settings.password.title': 'Kennwort ändern',
  'settings.password.hint': 'Nach dem Wechsel werden Sie auf allen Geräten abgemeldet - auch hier.',
  'settings.password.current': 'Bisheriges Kennwort',
  'settings.password.new': 'Neues Kennwort',
  'settings.password.repeat': 'Neues Kennwort wiederholen',
  'settings.password.mismatch': 'Die beiden Eingaben stimmen nicht überein.',
  'settings.password.submit': 'Kennwort ändern',
  'settings.password.done': 'Kennwort geändert. Beim nächsten Aufruf müssen Sie sich neu anmelden.',
  'settings.password.ruleLength': 'mindestens 10 Zeichen',
  'settings.password.ruleLower': 'ein Kleinbuchstabe',
  'settings.password.ruleUpper': 'ein Grossbuchstabe',
  'settings.password.ruleDigit': 'eine Ziffer',
  'settings.users.resetPassword': 'Kennwort zurücksetzen',
  'settings.users.resetTitle': 'Einmal-Link zum Setzen des Kennworts',
  'settings.users.resetDone': 'Für {email} ist ein Einmal-Link bereit. Alle laufenden Sitzungen dieser Person sind beendet.',
  'settings.users.resetLink': 'Link',
  'settings.users.resetExpires': 'Gültig für kurze Zeit, einmal verwendbar.',
  'settings.users.resetWarning': 'Der Link steht nur jetzt hier. Geben Sie ihn der Person persönlich - wer ihn liest, kann damit das Kennwort setzen.',
  // ---- Produktion: ehrlicher Zwischenzustand und Artikelsuche (Paket 3)
  'production.status.COMPLETING': 'Wird gebucht',
  'production.orders.completing': 'Der Abschluss ist angestossen. Fertig ist der Auftrag erst, wenn das Lager Material verbraucht und die Ware eingebucht hat.',
  'production.orders.stockError': 'Es wurde nichts gebucht: {reason}',
  'production.boms.search': 'Artikel suchen',
  'production.boms.searchHint': 'Nummer oder Bezeichnung',
  'production.boms.truncated': '{shown} von {total} Artikeln geladen - bitte suchen, um den Rest zu finden.',
  'production.boms.noProducts': 'Es sind keine Artikel angelegt. Ohne Artikel lässt sich keine Stückliste bauen.',
  'production.boms.productsFailed': 'Die Artikelliste konnte nicht geladen werden: {message}',

  // ----- Journal (Belegliste und Storno)
  'nav.journal': 'Journal',
  'journal.title': 'Journal',
  'journal.subtitle': 'Alle Buchungen mit ihren Zeilen - und der Weg, eine zurückzunehmen.',
  'journal.empty': 'Für diesen Zeitraum ist nichts gebucht.',
  'journal.filter.from': 'Von',
  'journal.filter.to': 'Bis',
  'journal.filter.account': 'Konto',
  'journal.filter.allAccounts': 'Alle Konten',
  'journal.col.account': 'Konto',
  'journal.col.debit': 'Soll',
  'journal.col.credit': 'Haben',
  'journal.badge.isReversal': 'Storno',
  'journal.badge.reversedBy': 'storniert mit {number}',
  'journal.action.reverse': 'Stornieren',
  'journal.reverse.title': 'Buchung {number} stornieren',
  'journal.reverse.explain': 'Es entsteht eine Gegenbuchung zum {date}, dem Tag der ursprünglichen Buchung. Beide bleiben im Journal stehen - gelöscht wird nichts.',
  'journal.reverse.reason': 'Grund',
  'journal.reverse.reasonHint': 'Warum wird storniert?',
  'journal.pager.previous': 'Zurück',
  'journal.pager.next': 'Weiter',
  'journal.pager.position': '{from}-{to} von {total}',

  // ----- Berichte: Zeitraum, Kontozeilen, Ausfuhr
  'finance.reports.empty': 'Keine Konten mit Bewegung in diesem Zeitraum.',
  'finance.reports.asOf': 'Stichtag {date}',
  'finance.reports.action.export': 'Ausfuhr',
  'finance.reports.col.amount': 'Betrag',
  'finance.reports.col.balance': 'Saldo',
  'finance.reports.section.revenue': 'Ertrag',
  'finance.reports.section.expenses': 'Aufwand',
  'finance.reports.section.assets': 'Aktiven',
  'finance.reports.section.liabilities': 'Passiven',
  'finance.reports.section.equity': 'Eigenkapital',
  'finance.reports.range.thisYear': 'Laufendes Jahr',
  'finance.reports.range.lastYear': 'Vorjahr',
  'finance.reports.range.thisQuarter': 'Laufendes Quartal',
  'finance.reports.range.thisMonth': 'Laufender Monat',
  'finance.reports.file.income': 'erfolgsrechnung',
  'finance.reports.file.balanceSheet': 'bilanz',
  'finance.reports.retainedEarnings': 'Darin enthalten: laufender Gewinn oder Verlust von {amount}. Er steht auf keinem Konto, sondern ist die Differenz aus Ertrag und Aufwand bis zum Stichtag.',

  // ----- Kassabuch: Gegenkonto und Datum
  'cb.field.counterAccount': 'Gegenkonto',
  'cb.field.counterAccountPick': 'Konto wählen',
  'cb.field.entryDate': 'Datum',
  'cb.error.counterAccountRequired': 'Bitte ein Gegenkonto wählen. Ein Kassaeintrag bucht ins Hauptbuch, und eine Buchung hat zwei Seiten.',
  'cb.hint.receipt': 'Einnahme: Soll Kasse an Haben Gegenkonto.',
  'cb.hint.payment': 'Ausgabe: Soll Gegenkonto an Haben Kasse.',
  'cb.field.account': 'Kassenkonto',
  'cb.field.accountDefault': 'Standard-Kassenkonto der Firma',

  // ----- Kontoblatt
  'journal.sheet.opening': 'Vortrag',
  'journal.sheet.closing': 'Schlusssaldo',
  'journal.sheet.openingRow': 'Saldovortrag',
  'journal.sheet.closingRow': 'Summen und Schlusssaldo',
  'journal.sheet.running': 'Saldo',
  'journal.sheet.counterAccount': 'Gegenkonto',
  'journal.sheet.split': '{count} Gegenkonten',
  'journal.sheet.truncated': 'Die Liste ist gekürzt. Der Schlusssaldo bezieht sich nur auf die gezeigten Zeilen - bitte den Zeitraum enger fassen.',

  // ----- Lohn: Arbeitgeberbeitraege
  'hr.payroll.col.employer': 'Arbeitgeberbeiträge',
  'hr.payroll.employerHint': 'Arbeitgeberbeiträge (AHV, ALV, FAK, BU, BVG) werden nicht vom Lohn abgezogen - sie sind ein zusätzlicher Aufwand der Firma.',

  // ----- Personalstamm: Quellensteuer, BVG, Kinder
  'hr.employees.modal.birthDate': 'Geburtsdatum',
  'hr.employees.modal.birthDateHint': 'Für die BVG-Altersgutschriften. Ohne rechnet das BVG mit einem festen Satz.',
  'hr.employees.modal.children': 'Kinder',
  'hr.employees.modal.workCanton': 'Arbeitskanton',
  'hr.employees.modal.workCantonHint': 'Wo gearbeitet wird, nicht wo gewohnt wird.',
  'hr.employees.modal.qstLiable': 'Quellensteuerpflichtig',
  'hr.employees.modal.qstCode': 'Tarifcode',
  'hr.employees.modal.qstCodeHint': 'ESTV-Code, etwa A0N oder B2Y.',

  // ----- Quellensteuertarife
  'nav.withholdingTax': 'Lohnstammdaten',
  'hr.qst.title': 'Kantonale Lohnstammdaten',
  'hr.qst.subtitle': 'Quellensteuertarife und Familienzulagen - beide kantonal, beide nicht mitgeliefert.',
  'hr.qst.current': 'Hinterlegte Tarife',
  'hr.qst.empty': 'Noch kein Tarif hinterlegt. Ohne Tarif lässt sich für eine quellensteuerpflichtige Person kein Lohn rechnen - das ist gewollt: ein erfundener Satz wäre schlimmer als gar keiner.',
  'hr.qst.import': 'Tarifdatei einlesen',
  'hr.qst.importIntro': 'Die Tarife werden nicht mitgeliefert. Sie sind kantonal, ändern jährlich, und ein erfundener Satz sieht amtlich aus, rechnet widerspruchsfrei und zieht jedem Betroffenen monatlich den falschen Betrag ab - bis eine Nachforderung kommt.',
  'hr.qst.format': 'Format',
  'hr.qst.format.csv': 'CSV mit Spaltennamen',
  'hr.qst.format.estv': 'ESTV-Tarifdatei',
  'hr.qst.source': 'Quelle',
  'hr.qst.sourceHint': 'z.B. ESTV Tarife 2026, Stand Januar',
  'hr.qst.csvHeader': 'Erwartete Spalten: Kanton;Tarifcode;Jahr;von;bis;Satz',
  'hr.qst.fileContent': 'Inhalt der Datei',
  'hr.qst.filePlaceholder': 'Den Inhalt der Tarifdatei hier einfügen',
  'hr.qst.action.preview': 'Lesen und zeigen',
  'hr.qst.action.import': 'Übernehmen',
  'hr.qst.action.importAnyway': 'Trotz Befunden übernehmen',
  'hr.qst.imported': '{tarife} Tarife mit {stufen} Stufen übernommen.',
  'hr.qst.preview.tariffs': 'Tarife',
  'hr.qst.preview.brackets': 'Stufen',
  'hr.qst.preview.rateRange': 'Satzspanne',
  'hr.qst.preview.samples': 'Die ersten Zeilen',
  'hr.qst.col.canton': 'Kanton',
  'hr.qst.col.code': 'Tarifcode',
  'hr.qst.col.year': 'Jahr',
  'hr.qst.col.brackets': 'Stufen',
  'hr.qst.col.rateRange': 'Sätze',
  'hr.qst.col.source': 'Quelle',
  'hr.qst.col.imported': 'Eingelesen',
  'hr.qst.col.from': 'Von',
  'hr.qst.col.to': 'Bis',
  'hr.qst.col.rate': 'Satz',

  // ----- Lohnlauf stornieren
  'hr.payroll.col.withholding': 'Quellensteuer',
  'hr.payroll.action.cancel': 'Stornieren',
  'hr.payroll.cancel.title': 'Lohnlauf {period} stornieren',
  'hr.payroll.cancel.explain': 'Der Lauf wird nicht gelöscht, sondern zurückgenommen - beide bleiben nachweisbar. Danach lässt sich der Monat neu rechnen, und die Buchhaltung storniert ihre Buchung von selbst.',
  'hr.payroll.cancel.reason': 'Grund',
  'hr.payroll.cancel.reasonHint': 'Warum wird der Lauf zurückgenommen?',
  'hr.fam.title': 'Familienzulagen',
  'hr.fam.intro': 'Auch diese Beträge sind kantonal. Der Bund schreibt ein Minimum vor, die meisten Kantone liegen darüber - ein stiller Vorgabewert würde der betroffenen Person dauerhaft zu wenig auszahlen, und niemand würde es merken.',
  'hr.fam.empty': 'Noch kein Ansatz hinterlegt. Ohne Ansatz lässt sich für eine Person mit Kindern kein Lohn rechnen.',
  'hr.fam.col.child': 'Kinderzulage',
  'hr.fam.col.education': 'Ausbildungszulage',
  'hr.fam.action.save': 'Ansatz speichern',
  'hr.fam.educationNote': 'Die Ausbildungszulage wird erfasst, aber noch nicht angewendet: dafür braucht es das Alter jedes Kindes, und der Personalstamm führt bisher nur ihre Zahl. Sie zu raten ginge in beide Richtungen falsch.',

  // --- Fehler, die der Server nicht selbst erklaeren kann ---------------
  'fehler.abgebrochen': 'Die Anfrage wurde abgebrochen.',
  'fehler.keineVerbindung': 'Keine Verbindung zum Server. Prüfe die Netzwerkverbindung und versuche es nochmal.',
  'fehler.zeitueberschreitung': 'Der Server hat zu lange nicht geantwortet. Versuche es nochmal.',
  'fehler.zuVieleAnfragen': 'Zu viele Versuche in kurzer Zeit. Warte einen Moment und versuche es nochmal.',
  'fehler.zuVieleAnfragen.warten': 'Zu viele Versuche in kurzer Zeit. In {sekunden} Sekunden geht es wieder.',
  'fehler.zuGross': 'Die Datei ist zu gross für den Versand.',
  'fehler.dienstNichtErreichbar': 'Dieser Bereich ist gerade nicht erreichbar. Versuche es in einem Moment nochmal.',
  'fehler.serverfehler': 'Im Server ist etwas schiefgegangen. Der Vorgang wurde nicht ausgeführt.',
  'fehler.unbekannt': 'Die Anfrage ist fehlgeschlagen (Status {status}).',

  // --- Fehlergrenze -----------------------------------------------------
  'fehler.grenze.titel': 'Diese Ansicht konnte nicht dargestellt werden',
  'fehler.grenze.text': 'Der Fehler betrifft nur diese Seite. Deine Daten sind unberührt, und der Rest der Anwendung läuft weiter.',
  'fehler.grenze.neuLaden': 'Seite neu laden',
  'fehler.grenze.zurueck': 'Zur Übersicht',
  'fehler.grenze.details': 'Technische Angaben',

  // --- Gekuerzte Listen -------------------------------------------------
  'insight.gekuerzt': 'Die Kennzahlen rechnen über {gezeigt} von {gesamt} Zeilen. Grenze den Zeitraum oder den Filter ein, damit sie vollständig sind.',
  'tabelle.fehler': 'Die Liste konnte nicht geladen werden',
  'tabelle.gekuerzt': '{gezeigt} von {gesamt} Zeilen. Grenze den Zeitraum oder den Filter ein, um die übrigen zu sehen.',

  // --- Was der Server an einem Formular auszusetzen hat -----------------
  // Die Regelnamen kommen von Joi und sind ein fester, kleiner Satz.

  // --- Feldnamen fuer Formularfehler ------------------------------------
  'feld.name': 'Name',
  'feld.code': 'Kürzel',
  'feld.status': 'Status',
  'feld.type': 'Art',
  'feld.notes': 'Notizen',
  'feld.note': 'Notiz',
  'feld.comment': 'Kommentar',
  'feld.description': 'Beschreibung',
  'feld.reason': 'Grund',
  'feld.title': 'Titel',
  'feld.email': 'E-Mail',
  'feld.phone': 'Telefon',
  'feld.password': 'Kennwort',
  'feld.firstName': 'Vorname',
  'feld.lastName': 'Nachname',
  'feld.amount': 'Betrag',
  'feld.unitPrice': 'Einzelpreis',
  'feld.quantity': 'Menge',
  'feld.currency': 'Währung',
  'feld.taxRate': 'Steuersatz',
  'feld.lines': 'Positionen',
  'feld.items': 'Positionen',
  'feld.hours': 'Stunden',
  'feld.months': 'Monate',
  'feld.month': 'Monat',
  'feld.year': 'Jahr',
  'feld.fiscalYear': 'Geschäftsjahr',
  'feld.canton': 'Kanton',
  'feld.breakMinutes': 'Pause in Minuten',
  'feld.position': 'Funktion',
  'feld.stage': 'Stufe',
  'feld.priority': 'Priorität',
  'feld.category': 'Kategorie',
  'feld.source': 'Herkunft',
  'feld.reference': 'Referenz',
  'feld.filename': 'Dateiname',
  'feld.probability': 'Wahrscheinlichkeit',
  'feld.limit': 'Anzahl Zeilen',
  'feld.offset': 'Startzeile',
  'feld.productId': 'Artikel',
  'feld.customerId': 'Kunde',
  'feld.supplierId': 'Lieferant',
  'feld.employeeId': 'Mitarbeiter',
  'feld.warehouseId': 'Lager',
  'feld.accountId': 'Konto',
  'feld.invoiceId': 'Rechnung',
  'feld.projectId': 'Projekt',
  'feld.leaveTypeId': 'Abwesenheitsart',
  'feld.costCenterId': 'Kostenstelle',
  'feld.departmentId': 'Abteilung',
  'feld.managerId': 'Vorgesetzte Person',
  'feld.ownerId': 'Zuständige Person',
  'feld.assigneeId': 'Zugewiesen an',
  'feld.equipmentId': 'Anlage',
  'feld.positionId': 'Stelle',
  'feld.parentId': 'Übergeordnet',

  'feldfehler.mehrere': '{anzahl} Felder sind noch nicht in Ordnung.',
  'feldfehler.unbekannt': 'Der Wert ist nicht gültig.',
  'feldfehler.any.required': '{feld} wird gebraucht.',
  'feldfehler.any.only': '{feld} hat keinen erlaubten Wert.',
  'feldfehler.any.invalid': '{feld} hat keinen erlaubten Wert.',
  'feldfehler.string.empty': '{feld} darf nicht leer sein.',
  'feldfehler.string.base': '{feld} muss Text sein.',
  'feldfehler.string.email': '{feld} ist keine gültige E-Mail-Adresse.',
  'feldfehler.string.uri': '{feld} ist keine gültige Adresse.',
  'feldfehler.string.guid': '{feld} ist keine gültige Kennung.',
  'feldfehler.string.min': '{feld} braucht mindestens {grenze} Zeichen.',
  'feldfehler.string.max': '{feld} darf höchstens {grenze} Zeichen haben.',
  'feldfehler.string.length': '{feld} muss genau {grenze} Zeichen haben.',
  'feldfehler.string.pattern.base': '{feld} hat nicht die erwartete Form.',
  'feldfehler.string.isoDate': '{feld} ist kein gültiges Datum.',
  'feldfehler.number.base': '{feld} muss eine Zahl sein.',
  'feldfehler.number.min': '{feld} muss mindestens {grenze} sein.',
  'feldfehler.number.max': '{feld} darf höchstens {grenze} sein.',
  'feldfehler.number.integer': '{feld} muss eine ganze Zahl sein.',
  'feldfehler.number.positive': '{feld} muss grösser als null sein.',
  'feldfehler.number.greater': '{feld} muss grösser als {grenze} sein.',
  'feldfehler.number.less': '{feld} muss kleiner als {grenze} sein.',
  'feldfehler.number.unsafe': '{feld} ist zu gross.',
  'feldfehler.date.base': '{feld} ist kein gültiges Datum.',
  'feldfehler.date.min': '{feld} liegt zu früh.',
  'feldfehler.date.max': '{feld} liegt zu spät.',
  'feldfehler.array.base': '{feld} muss eine Liste sein.',
  'feldfehler.array.min': '{feld} braucht mindestens {grenze} Einträge.',
  'feldfehler.array.max': '{feld} darf höchstens {grenze} Einträge haben.',
  'feldfehler.array.includesRequiredUnknowns': '{feld} ist unvollständig.',
  'feldfehler.object.base': '{feld} hat nicht die erwartete Form.',
  'feldfehler.object.unknown': '{feld} ist hier nicht vorgesehen.',
  'feldfehler.boolean.base': '{feld} muss ja oder nein sein.',
  'feldfehler.object.missing': 'Mindestens ein Feld muss ausgefüllt sein.',

  // --- "Das gibt es nicht" ----------------------------------------------
  'fehler.nichtGefunden.account': 'Dieses Konto gibt es nicht.',
  'fehler.nichtGefunden.attachment': 'Diesen Anhang gibt es nicht.',
  'fehler.nichtGefunden.backorder': 'Diesen Rückstand gibt es nicht.',
  'fehler.nichtGefunden.bankTransaction': 'Diese Bankbewegung gibt es nicht.',
  'fehler.nichtGefunden.bin': 'Diesen Lagerplatz gibt es nicht.',
  'fehler.nichtGefunden.bom': 'Diese Stückliste gibt es nicht.',
  'fehler.nichtGefunden.candidate': 'Diese Bewerbung gibt es nicht.',
  'fehler.nichtGefunden.cashJournal': 'Dieses Kassabuch gibt es nicht.',
  'fehler.nichtGefunden.company': 'Diese Firma gibt es nicht.',
  'fehler.nichtGefunden.consignment': 'Diesen Konsignationsbestand gibt es nicht.',
  'fehler.nichtGefunden.contract': 'Diesen Vertrag gibt es nicht.',
  'fehler.nichtGefunden.costCenter': 'Diese Kostenstelle gibt es nicht.',
  'fehler.nichtGefunden.creditNote': 'Diese Gutschrift gibt es nicht.',
  'fehler.nichtGefunden.currency': 'Diese Währung gibt es nicht.',
  'fehler.nichtGefunden.customer': 'Diesen Kunden gibt es nicht.',
  'fehler.nichtGefunden.cycleCount': 'Diese Inventurzählung gibt es nicht.',
  'fehler.nichtGefunden.delivery': 'Diesen Lieferschein gibt es nicht.',
  'fehler.nichtGefunden.demoRequest': 'Diese Anfrage gibt es nicht.',
  'fehler.nichtGefunden.downPayment': 'Diese Anzahlung gibt es nicht.',
  'fehler.nichtGefunden.dunningNotice': 'Diese Mahnung gibt es nicht.',
  'fehler.nichtGefunden.employee': 'Diese Person gibt es nicht im Personalstamm.',
  'fehler.nichtGefunden.equipment': 'Diese Anlage gibt es nicht.',
  'fehler.nichtGefunden.expense': 'Diese Spesenzeile gibt es nicht.',
  'fehler.nichtGefunden.fixedAsset': 'Dieses Anlagegut gibt es nicht.',
  'fehler.nichtGefunden.inspectionLot': 'Dieses Prüflos gibt es nicht.',
  'fehler.nichtGefunden.holiday': 'Diesen Feiertag gibt es nicht.',
  'fehler.nichtGefunden.companyEvent': 'Diesen Termin gibt es nicht.',
  'fehler.termin.nurUrheberDarfLoeschen': 'Nur wer den Termin angelegt hat, kann ihn wieder entfernen - oder eine Person mit Verwaltungsrecht.',
  'fehler.datenbank.schonVorhanden': 'Dieser Eintrag gibt es schon.',
  'fehler.datenbank.verweistAufNichts': 'Der Eintrag verweist auf etwas, das es nicht gibt.',
  'fehler.nichtGefunden.invoice': 'Diese Rechnung gibt es nicht.',
  'fehler.nichtGefunden.item': 'Diese Position gibt es nicht.',
  'fehler.nichtGefunden.jobPosting': 'Diese Stellenausschreibung gibt es nicht.',
  'fehler.nichtGefunden.journal': 'Diese Buchung gibt es nicht.',
  'fehler.nichtGefunden.leaveRequest': 'Diesen Antrag gibt es nicht.',
  'fehler.nichtGefunden.leaveType': 'Diese Abwesenheitsart gibt es nicht.',
  'fehler.nichtGefunden.maintenanceOrder': 'Diesen Wartungsauftrag gibt es nicht.',
  'fehler.nichtGefunden.maintenancePlan': 'Diesen Wartungsplan gibt es nicht.',
  'fehler.nichtGefunden.month': 'Diesen Monat gibt es nicht.',
  'fehler.nichtGefunden.mrpRun': 'Diesen Bedarfslauf gibt es nicht.',
  'fehler.nichtGefunden.notification': 'Diese Benachrichtigung gibt es nicht.',
  'fehler.nichtGefunden.opportunity': 'Diese Verkaufschance gibt es nicht.',
  'fehler.nichtGefunden.paymentRun': 'Diesen Zahllauf gibt es nicht.',
  'fehler.nichtGefunden.paymentTerm': 'Diese Zahlungsbedingung gibt es nicht.',
  'fehler.nichtGefunden.payrollRun': 'Diesen Lohnlauf gibt es nicht.',
  'fehler.nichtGefunden.payslip': 'Diese Lohnabrechnung gibt es nicht.',
  'fehler.nichtGefunden.priceList': 'Diese Preisliste gibt es nicht.',
  'fehler.nichtGefunden.product': 'Diesen Artikel gibt es nicht.',
  'fehler.nichtGefunden.profitCenter': 'Diesen Profitcenter gibt es nicht.',
  'fehler.nichtGefunden.project': 'Dieses Projekt gibt es nicht.',
  'fehler.nichtGefunden.provisioningJob': 'Diesen Einrichtungsauftrag gibt es nicht.',
  'fehler.nichtGefunden.purchaseOrder': 'Diese Bestellung gibt es nicht.',
  'fehler.nichtGefunden.quote': 'Diese Offerte gibt es nicht.',
  'fehler.nichtGefunden.recurringInvoice': 'Diese wiederkehrende Rechnung gibt es nicht.',
  'fehler.nichtGefunden.recurringJournal': 'Diese wiederkehrende Buchung gibt es nicht.',
  'fehler.nichtGefunden.report': 'Diese Auswertung gibt es nicht.',
  'fehler.nichtGefunden.requisition': 'Diese Bedarfsmeldung gibt es nicht.',
  'fehler.nichtGefunden.reservation': 'Diese Reservation gibt es nicht.',
  'fehler.nichtGefunden.review': 'Dieses Mitarbeitergespräch gibt es nicht.',
  'fehler.nichtGefunden.rule': 'Diese Regel gibt es nicht.',
  'fehler.nichtGefunden.run': 'Diesen Lauf gibt es nicht.',
  'fehler.nichtGefunden.salesOrder': 'Diesen Auftrag gibt es nicht.',
  'fehler.nichtGefunden.salesReturn': 'Diese Rücksendung gibt es nicht.',
  'fehler.nichtGefunden.scheduleLine': 'Diese Abrufposition gibt es nicht.',
  'fehler.nichtGefunden.schedulingAgreement': 'Diesen Lieferplan gibt es nicht.',
  'fehler.nichtGefunden.serialUnit': 'Diese Seriennummer gibt es nicht.',
  'fehler.nichtGefunden.supplier': 'Diesen Lieferanten gibt es nicht.',
  'fehler.nichtGefunden.tenant': 'Diese Firma gibt es nicht.',
  'fehler.nichtGefunden.ticket': 'Dieses Ticket gibt es nicht.',
  'fehler.nichtGefunden.timeEntry': 'Diese Zeitzeile gibt es nicht.',
  'fehler.nichtGefunden.travelReport': 'Diese Spesenabrechnung gibt es nicht.',
  'fehler.nichtGefunden.user': 'Dieses Benutzerkonto gibt es nicht.',
  'fehler.nichtGefunden.warehouse': 'Dieses Lager gibt es nicht.',
  'fehler.nichtGefunden.workCenter': 'Diesen Arbeitsplatz gibt es nicht.',
  'fehler.nichtGefunden.workOrder': 'Diesen Fertigungsauftrag gibt es nicht.',
  'fehler.nichtGefunden.workSchedule': 'Für diese Person ist kein Wochenraster hinterlegt.',

  'fehler.anmeldung.falsch': 'E-Mail oder Kennwort stimmt nicht.',
  'fehler.anmeldung.abgelaufen': 'Die Anmeldung ist abgelaufen. Bitte melde dich neu an.',
  'fehler.anmeldung.abgelaufen': 'Die Anmeldung ist abgelaufen. Bitte melde dich neu an.',
  'fehler.anmeldung.abgelaufen': 'Die Anmeldung ist abgelaufen. Bitte melde dich neu an.',
  'fehler.anmeldung.abgelaufen': 'Die Anmeldung ist abgelaufen. Bitte melde dich neu an.',
  'fehler.anmeldung.abgelaufen': 'Die Anmeldung ist abgelaufen. Bitte melde dich neu an.',
  'fehler.anmeldung.abgelaufen': 'Die Anmeldung ist abgelaufen. Bitte melde dich neu an.',
  'fehler.anmeldung.kontoGesperrt': 'Dieses Konto ist gesperrt. Wende dich an die Verwaltung deiner Firma.',
  'fehler.anmeldung.kontoGesperrt': 'Dieses Konto ist gesperrt. Wende dich an die Verwaltung deiner Firma.',
  'fehler.zugriff.fehlendeBerechtigung': 'Für diesen Bereich fehlt dir die Berechtigung.',
  'fehler.zugriff.keinAnbietertoken': 'Dieser Bereich ist dem Anbieter vorbehalten.',
  'fehler.zugriff.adresseNichtErlaubt': 'Von dieser Netzwerkadresse ist kein Zugang erlaubt.',
  'fehler.benutzer.letzteVerwaltung': 'Das ist das letzte Konto mit Verwaltungsrecht. Ohne ein solches käme niemand mehr an die Einstellungen.',
  'fehler.benutzer.adresseVergeben': 'Diese E-Mail-Adresse wird bereits verwendet.',
  'fehler.benutzer.adresseVergeben': 'Diese E-Mail-Adresse wird bereits verwendet.',
  'fehler.benutzer.adresseVergeben': 'Diese E-Mail-Adresse wird bereits verwendet.',
  'fehler.kennwort.gleichWieBisher': 'Das neue Kennwort muss sich vom bisherigen unterscheiden.',
  'fehler.kennwort.linkAbgelaufen': 'Dieser Link ist nicht mehr gültig. Lass dir einen neuen schicken.',
  'fehler.kennwort.zuruecksetzenNichtEingerichtet': 'Das Zurücksetzen des Kennworts ist in dieser Installation nicht eingerichtet.',
  'fehler.firma.kuerzelVergeben': 'Dieses Kürzel ist bereits vergeben.',
  'fehler.firma.kuerzelStimmtNicht': 'Das eingegebene Kürzel stimmt nicht mit dem der Firma überein.',
  'fehler.firma.nurAktivOderGesperrt': 'Eine Firma kann nur aktiv oder gesperrt sein.',

  'fehler.eingabe.ungueltig': 'Die Eingabe ist nicht vollständig oder nicht gültig.',
  'fehler.regel.unbekanntesEreignis': 'Dieses Ereignis gibt es nicht - eine Regel kann nicht darauf hören.',
  'fehler.regel.bedingungOhneVergleich': 'Zu einem Feld gehört auch, WIE verglichen werden soll.',
  'fehler.firma.anlageNichtVerfuegbar': 'Auf diesem Server lassen sich keine Firmen anlegen.',
  'fehler.firma.entfernenNichtVerfuegbar': 'Auf diesem Server lassen sich keine Firmen entfernen.',
  'fehler.firma.erstSperrenDannEntfernen': 'Eine Firma lässt sich nur entfernen, wenn sie gesperrt ist. Erst sperren, dann entfernen.',
  'fehler.firma.gesperrt': 'Diese Firma ist gesperrt. Wende dich an den Anbieter.',
  'fehler.firma.statusUnbekannt': 'Der Zustand dieser Firma lässt sich gerade nicht feststellen. Versuche es in einem Moment nochmal.',
  'fehler.route.gibtEsNicht': 'Diese Adresse gibt es nicht.',
  'fehler.kennwort.eigenesWirdGewechselt': 'Das eigene Kennwort wird gewechselt, nicht zurückgesetzt - dafür gibt es "Kennwort ändern".',
  'fehler.anmeldung.mehrereFirmen': 'Diese Adresse ist in mehreren Firmen hinterlegt. Bitte gib das Firmenkürzel an.',
  'fehler.datei.artNichtErlaubt': 'Diese Art von Datei lässt sich nicht anhängen.',
  'fehler.datei.leer': 'Diese Datei ist leer.',
  'fehler.datei.zuGross': 'Diese Datei ist zu gross zum Anhängen.',
  'fehler.projekt.nichtsAusgewaehlt': 'Es ist nichts ausgewählt, das sich verrechnen liesse.',
  'fehler.betrag.groesserNull': 'Der Betrag muss grösser als null sein.',
  'fehler.status.ungueltig': 'Diesen Status gibt es nicht.',
  'fehler.status.ungueltig': 'Diesen Status gibt es nicht.',
  'fehler.status.ungueltig': 'Diesen Status gibt es nicht.',
  'fehler.status.ungueltig': 'Diesen Status gibt es nicht.',
  'fehler.status.wechselNichtMoeglich': 'Von diesem Status aus lässt sich nicht dorthin wechseln.',
  'fehler.zeit.keineStunden': 'Gib Stunden an - oder Beginn und Ende, die zusammen mehr als null Stunden ergeben.',

  'fehler.beleg.nurImStatus': 'Das geht nur im Status {erlaubt} - dieser Beleg steht auf {status}.',
  'fehler.beleg.nurImStatus': 'Das geht nur im Status {erlaubt} - dieser Beleg steht auf {status}.',
  'fehler.beleg.nurImStatus': 'Das geht nur im Status {erlaubt} - dieser Beleg steht auf {status}.',
  'fehler.beleg.nurImStatus': 'Das geht nur im Status {erlaubt} - dieser Beleg steht auf {status}.',
  'fehler.beleg.falscherStatus': 'Das geht in diesem Zustand nicht - dieser Beleg steht auf {status}.',
  'fehler.beleg.nurImStatus': 'Das geht nur im Status {erlaubt} - dieser Beleg steht auf {status}.',
  'fehler.beleg.nurImStatus': 'Das geht nur im Status {erlaubt} - dieser Beleg steht auf {status}.',
  'fehler.beleg.nurImStatus': 'Das geht nur im Status {erlaubt} - dieser Beleg steht auf {status}.',
  'fehler.beleg.falscherStatus': 'Das geht in diesem Zustand nicht - dieser Beleg steht auf {status}.',
  'fehler.beleg.falscherStatus': 'Das geht in diesem Zustand nicht - dieser Beleg steht auf {status}.',
  'fehler.beleg.nurImStatus': 'Das geht nur im Status {erlaubt} - dieser Beleg steht auf {status}.',
  'fehler.beleg.nurImStatus': 'Das geht nur im Status {erlaubt} - dieser Beleg steht auf {status}.',
  'fehler.beleg.schonEntschieden': 'Über diese Rücksendung ist bereits entschieden.',
  'fehler.beleg.schonEingegangen': 'Diese Rücksendung ist bereits eingegangen.',
  'fehler.beleg.falscherStatus': 'Das geht in diesem Zustand nicht - dieser Beleg steht auf {status}.',
  'fehler.beleg.statuswechselNichtMoeglich': 'Von {von} lässt sich nicht direkt auf {nach} wechseln.',
  'fehler.kunde.falscherStatus': 'Dieser Kunde steht auf {status} - damit lässt sich nicht arbeiten.',
  'fehler.kunde.falscherStatus': 'Dieser Kunde steht auf {status} - damit lässt sich nicht arbeiten.',
  'fehler.kunde.nummerVergeben': 'Diese Kundennummer ist bereits vergeben.',
  'fehler.kunde.kreditlimitUeberschritten': 'Das Kreditlimit dieses Kunden ist erreicht: offen {offen} plus {dazu} übersteigt das Limit von {limit}.',
  'fehler.verkaufschance.unbekannteStufe': 'Diese Stufe gibt es im Verkaufstrichter nicht.',
  'fehler.verkaufschance.schonAufStufe': 'Diese Verkaufschance steht bereits auf {stufe}.',
  'fehler.kommentar.leer': 'Ein Kommentar ohne Text ist keiner.',
  'fehler.beleg.ohnePositionen': 'Dieser Beleg braucht mindestens eine Position.',
  'fehler.beleg.ohnePositionen': 'Dieser Beleg braucht mindestens eine Position.',
  'fehler.position.nichtImAuftrag': 'Dieser Artikel steht gar nicht auf dem Auftrag.',
  'fehler.position.nichtImAuftrag': 'Dieser Artikel steht gar nicht auf dem Auftrag.',
  'fehler.position.mehrAlsBestellt': 'Es lassen sich nicht {menge} zurückgeben - bestellt waren {bestellt}.',
  'fehler.menge.groesserNull': 'Die Menge muss grösser als null sein.',
  'fehler.menge.mehrAlsOffen': '{menge} ist mehr als noch offen ist ({offen}).',
  'fehler.preisliste.doppelteStaffel': 'Für denselben Artikel gibt es diese Mengenstaffel zweimal.',
  'fehler.menge.groesserNull': 'Die Menge muss grösser als null sein.',
  'fehler.menge.groesserNull': 'Die Menge muss grösser als null sein.',
  'fehler.fertigung.ohneLager': 'Ein Fertigungsauftrag braucht ein Lager - dort wird Material entnommen und das Erzeugnis eingebucht.',
  'fehler.stueckliste.nummerVergeben': 'Dieses Stücklistenkürzel ist bereits vergeben.',
  'fehler.arbeitsplatz.nummerVergeben': 'Dieses Arbeitsplatzkürzel ist bereits vergeben.',
  'fehler.stueckliste.stillgelegt': 'Diese Stückliste ist stillgelegt und lässt sich nicht mehr verwenden.',
  'fehler.fertigung.ohneArtikelOderStueckliste': 'Ohne Stückliste braucht der Auftrag wenigstens einen Artikel.',
  'fehler.beleg.statuswechselNichtMoeglich': 'Von {von} lässt sich nicht direkt auf {nach} wechseln.',
  'fehler.beleg.falscherStatus': 'Das geht in diesem Zustand nicht - dieser Beleg steht auf {status}.',
  'fehler.beleg.falscherStatus': 'Das geht in diesem Zustand nicht - dieser Beleg steht auf {status}.',
  'fehler.fertigung.teilrueckmeldungenLaufen': 'Dieser Auftrag wird in Teilmengen zurückgemeldet - schliesse ihn über die Rückmeldungen ab.',
  'fehler.menge.mehrAlsOffen': '{menge} ist mehr als noch offen ist ({offen}).',
  'fehler.fertigung.abschlussNichtAngestossen': 'Der Abschluss konnte nicht angestossen werden - es wurde nichts gebucht. Bitte später erneut versuchen.',

  'fehler.person.adresseVergeben': 'Diese E-Mail-Adresse gehört bereits zu einer anderen Person.',
  'fehler.person.adresseVergeben': 'Diese E-Mail-Adresse gehört bereits zu einer anderen Person.',
  'fehler.person.schonAusgetreten': 'Diese Person ist bereits ausgetreten.',
  'fehler.person.austrittVorEintritt': 'Der Austritt kann nicht vor dem Eintritt liegen.',
  'fehler.person.keinAntragMoeglich': 'Diese Person steht auf {status} - dafür lässt sich kein Antrag stellen.',
  'fehler.beleg.inzwischenGeaendert': 'Dieser Beleg wurde inzwischen von jemand anderem geändert. Lade ihn neu und versuche es nochmal.',
  'fehler.gespraech.ohneZeitraum': 'Ein Mitarbeitergespräch braucht einen Zeitraum, über den es geht.',
  'fehler.spesen.ohneZweck': 'Eine Spesenabrechnung braucht einen Reisezweck.',
  'fehler.stelle.geschlossen': 'Diese Stellenausschreibung ist geschlossen.',
  'fehler.lohn.laufSchonVorhanden': 'Für diesen Monat gibt es bereits einen Lohnlauf.',
  'fehler.zeit.schonStorniert': 'Diese Zeile ist bereits storniert.',
  'fehler.zeitraum.unvollstaendig': 'Beginn und Ende werden beide gebraucht.',
  'fehler.zeitraum.endeVorBeginn': 'Das Ende liegt vor dem Beginn.',
  'fehler.zeitraum.ohneJahr': 'Das Jahr wird gebraucht.',
  'fehler.zeitraum.ohneJahrUndMonat': 'Jahr und Monat werden beide gebraucht.',
  'fehler.zeit.ohnePersonUndZeitraum': 'Person und Zeitraum werden beide gebraucht.',
  'fehler.zeit.stempelungUnvollstaendig': 'Für eine Stempelung werden Kommen UND Gehen gebraucht.',
  'fehler.zeit.stundenAusserhalb': 'Die Stunden müssen zwischen 0 und 24 liegen.',
  'fehler.datum.unlesbar': 'Dieses Datum lässt sich nicht lesen.',
  'fehler.zeit.gehoertZuAbwesenheit': 'Diese Zeile gehört zu einer genehmigten Abwesenheit. Um sie zu entfernen, storniere den Ferienantrag.',
  'fehler.monat.abschlussNichtEingerichtet': 'Der Monatsabschluss ist in dieser Installation nicht eingerichtet.',
  'fehler.monat.nichtsEingereicht': 'Für diesen Monat wurde nichts eingereicht.',
  'fehler.beleg.inzwischenGeaendert': 'Dieser Beleg wurde inzwischen von jemand anderem geändert. Lade ihn neu und versuche es nochmal.',
  'fehler.lohn.soebenStorniert': 'Dieser Lohnlauf wurde soeben von jemand anderem storniert.',
  'fehler.handlung.unbekannt': 'Diese Handlung gibt es nicht.',
  'fehler.antrag.nichtUeberSichSelbst': 'Über den eigenen Antrag entscheidet man nicht. Das übernimmt die vorgesetzte Person oder die Personalabteilung.',
  'fehler.antrag.andereZustaendig': 'Für diesen Antrag ist die vorgesetzte Person zuständig, ersatzweise die Personalabteilung.',
  'fehler.antrag.nurOffeneZurueckziehen': 'Nur ein offener Antrag lässt sich zurückziehen. Für eine genehmigte Abwesenheit wende dich an die vorgesetzte Person oder die Personalabteilung.',
  'fehler.person.keinePersonalakte': 'Zu diesem Konto gehört keine Personalakte. Die Personalabteilung muss die Verknüpfung herstellen.',
  'fehler.antrag.keinArbeitstag': 'Dieser Zeitraum enthält keinen Arbeitstag - es gibt nichts zu beantragen.',
  'fehler.antrag.schonVorhanden': 'Für diesen Zeitraum gibt es bereits einen Antrag.',
  'fehler.abwesenheitsart.stillgelegt': 'Die Abwesenheitsart "{art}" wird nicht mehr verwendet. Bitte wähle eine aktuelle.',
  'fehler.abwesenheitsart.nichtRueckwirkend': '{art} lässt sich nicht rückwirkend beantragen. Der früheste mögliche Beginn ist heute.',
  'fehler.abwesenheitsart.brauchtVorlauf': '{art} braucht {tage} Tage Vorlauf. Der früheste mögliche Beginn ist der {ab}.',
  'fehler.abwesenheitsart.kuerzelVergeben': 'Diese Abwesenheitsart gibt es bereits.',

  'fehler.lohn.zulageOhneKanton': '{person} hat {kinder} Kind(er), aber keinen Arbeitskanton. Familienzulagen sind kantonal - ohne Kanton lässt sich der Ansatz nicht bestimmen.',
  'fehler.lohn.quellensteuerOhneAngaben': '{person} ist quellensteuerpflichtig, aber ohne Arbeitskanton oder Tarifcode. Beides gehört in den Personalstamm.',

  'fehler.einheit.faktorGroesserNull': 'Der Umrechnungsfaktor muss grösser als null sein.',
  'fehler.artikel.dienstleistungOhneBestand': 'Das ist eine Dienstleistung - dafür gibt es keinen Lagerbestand.',
  'fehler.artikel.nochBestandVorhanden': 'Dieser Artikel hat noch Bestand im Lager - er lässt sich nicht in eine Dienstleistung umwandeln.',
  'fehler.artikel.stillgelegt': 'Dieser Artikel ist stillgelegt und lässt sich nicht mehr bewegen.',
  'fehler.artikel.chargeGebraucht': 'Dieser Artikel wird chargengeführt - eine Chargennummer wird gebraucht.',
  'fehler.artikel.seriennummernGebraucht': 'Dieser Artikel wird seriennummerngeführt - es werden genau {anzahl} Seriennummer(n) gebraucht.',
  'fehler.bestand.zuWenig': 'Zu wenig Bestand: {vorhanden} vorhanden, {gewuenscht} gewünscht.',
  'fehler.bestand.zuWenig': 'Zu wenig Bestand: {vorhanden} vorhanden, {gewuenscht} gewünscht.',
  'fehler.bestand.zuWenig': 'Zu wenig Bestand: {vorhanden} vorhanden, {gewuenscht} gewünscht.',
  'fehler.bestand.zuWenig': 'Zu wenig Bestand: {vorhanden} vorhanden, {gewuenscht} gewünscht.',
  'fehler.bestand.zuWenigWegenReservation': 'Es lassen sich nur {frei} entnehmen - {reserviert} sind reserviert, gewünscht waren {gewuenscht}.',
  'fehler.bestand.fifoFehlbetrag': 'Der Bestand reicht nach dem Erst-ein-erst-aus-Prinzip nicht: es fehlen {fehlt}.',
  'fehler.lagerplatz.zuWenig': 'Auf diesem Lagerplatz liegen nur {vorhanden} - {gewuenscht} lassen sich nicht entnehmen.',
  'fehler.lagerplatz.zuWenig': 'Auf diesem Lagerplatz liegen nur {vorhanden} - {gewuenscht} lassen sich nicht entnehmen.',
  'fehler.lagerplatz.nichtsEinzulagern': 'Es sind nur {frei} Stück ohne Lagerplatz - mehr lässt sich nicht einlagern.',
  'fehler.lagerplatz.gleicherPlatz': 'Quelle und Ziel müssen verschiedene Lagerplätze sein.',
  'fehler.lagerplatz.verschiedeneLager': 'Beide Lagerplätze müssen zum selben Lager gehören.',
  'fehler.lager.gleichesLager': 'Quelle und Ziel müssen verschiedene Lager sein.',
  'fehler.bestand.korrekturNull': 'Eine Korrektur um null verändert nichts.',
  'fehler.bestand.korrekturOhnePreis': 'Für einen Zugang wird ein Einstandspreis gebraucht - sonst stimmt die Bestandsbewertung nicht mehr.',
  'fehler.freigabe.nichtEigene': 'Die eigene Anforderung gibt man nicht selbst frei. Das muss eine andere Person tun.',
  'fehler.freigabe.nichtEigene': 'Die eigene Anforderung gibt man nicht selbst frei. Das muss eine andere Person tun.',
  'fehler.freigabe.nichtEigene': 'Die eigene Anforderung gibt man nicht selbst frei. Das muss eine andere Person tun.',
  'fehler.freigabe.nurVerwaltung': 'Über eine Freigabe entscheidet nur, wer Verwaltungsrecht hat.',
  'fehler.freigabe.nurVerwaltung': 'Über eine Freigabe entscheidet nur, wer Verwaltungsrecht hat.',
  'fehler.position.nichtImBeleg': 'Diese Position gehört gar nicht zu diesem Beleg.',
  'fehler.bedarfsmeldung.ohneLieferant': 'Ohne Lieferant lässt sich daraus keine Bestellung machen.',
  'fehler.abrufposition.unvollstaendig': 'Jede Abrufposition braucht ein Lieferdatum und eine Menge grösser als null.',
  'fehler.abrufposition.unvollstaendig': 'Jede Abrufposition braucht ein Lieferdatum und eine Menge grösser als null.',
  'fehler.bedarfslauf.keineVorschlaege': 'Es gibt keine offenen Beschaffungsvorschläge zum Übernehmen.',
  'fehler.einheit.basiseinheitFest': 'Das ist die Basiseinheit - ihr Faktor ist immer 1.',
  'fehler.einheit.schonVorhanden': 'Diese Einheit gibt es für diesen Artikel bereits.',
  'fehler.einheit.unbekannt': 'Diese Einheit gibt es für diesen Artikel nicht.',
  'fehler.einheit.unbekannt': 'Diese Einheit gibt es für diesen Artikel nicht.',
  'fehler.bedarfsmeldung.geaendertWaehrendUebernahme': 'Die Bedarfsmeldung wurde während der Übernahme geändert. Die Bestellung {bestellung} ist entstanden, aber nicht verknüpft - bitte von Hand prüfen.',

  'fehler.betrag.nichtNegativ': 'Der Betrag darf nicht negativ sein.',
  'fehler.systemkonto.nichtHinterlegt': 'Für "{zweck}" ist kein Konto hinterlegt. Ordne es im Kontenrahmen unter Systemkonten zu.',
  'fehler.systemkonto.stillgelegt': 'Das Konto {konto} für "{zweck}" ist stillgelegt und lässt sich nicht bebuchen.',
  'fehler.konto.stillgelegtAlsSystemkonto': 'Das Konto {konto} ist stillgelegt und taugt nicht als Systemkonto.',
  'fehler.konto.stillgelegt': 'Das Konto {konto} ist stillgelegt und lässt sich nicht bebuchen.',
  'fehler.konto.nummerVergeben': 'Diese Kontonummer ist bereits vergeben.',
  'fehler.konto.nummerVergebenAn': 'Die Nummer {nummer} gehört bereits zu "{name}".',
  'fehler.konto.artWieUebergeordnet': 'Ein untergeordnetes Konto muss dieselbe Kontoart haben wie das übergeordnete.',
  'fehler.konto.artNichtMehrAenderbar': '"{name}" hat {buchungen} Buchungen. Die Kontoart lässt sich dann nicht mehr ändern - alle Salden würden sich verschieben.',
  'fehler.konto.falscheArt': 'Das Konto {konto} müsste vom Typ {erwartet} sein, ist aber {ist}.',
  'fehler.position.kontoartPasstNicht': 'Die Kontoart dieser Position passt nicht zum Beleg (sie ist {ist}).',
  'fehler.position.kontoartPasstNicht': 'Die Kontoart dieser Position passt nicht zum Beleg (sie ist {ist}).',
  'fehler.position.kontoartPasstNicht': 'Die Kontoart dieser Position passt nicht zum Beleg (sie ist {ist}).',
  'fehler.budget.nurErfolgskonten': 'Ein Budget gibt es nur auf Ertrags- und Aufwandskonten - dieses ist {ist}.',
  'fehler.budget.ueberschritten': 'Das Budget für {konto} ist mit dieser Buchung überschritten.',
  'fehler.buchung.zuWenigeZeilen': 'Eine Buchung braucht mindestens zwei Zeilen - Soll und Haben.',
  'fehler.buchung.zuWenigeZeilen': 'Eine Buchung braucht mindestens zwei Zeilen - Soll und Haben.',
  'fehler.buchung.zuWenigeZeilen': 'Eine Buchung braucht mindestens zwei Zeilen - Soll und Haben.',
  'fehler.buchung.nichtAusgeglichen': 'Soll und Haben stimmen nicht überein: {soll} gegen {haben}.',
  'fehler.buchung.nichtAusgeglichen': 'Soll und Haben stimmen nicht überein: {soll} gegen {haben}.',
  'fehler.periode.geschlossen': 'Die Periode {periode} ist abgeschlossen. Öffne sie wieder, um darin zu buchen.',
  'fehler.periode.schonGeschlossen': 'Die Periode {periode} ist bereits abgeschlossen.',
  'fehler.periode.nichtGeschlossen': 'Die Periode {periode} ist gar nicht abgeschlossen.',
  'fehler.geschaeftsjahr.schonAbgeschlossen': 'Das Geschäftsjahr {jahr} ist bereits abgeschlossen.',
  'fehler.geschaeftsjahr.nichtsAbzuschliessen': 'Für {jahr} gibt es keine Erfolgsbuchungen, die sich abschliessen liessen.',
  'fehler.buchung.soebenStorniert': 'Diese Buchung wurde soeben von jemand anderem storniert.',
  'fehler.buchung.schonStorniert': 'Die Buchung {beleg} wurde bereits mit {storno} storniert.',
  'fehler.buchung.jahresabschlussNichtStornierbar': 'Das ist der Jahresabschluss. Er lässt sich nicht einzeln stornieren - dafür wird das Geschäftsjahr wieder geöffnet.',
  'fehler.buchung.gehoertZuBeleg': 'Diese Buchung gehört zu einem Beleg. Ein Beleg wird am Beleg storniert, nicht an seiner Buchung.',
  'fehler.buchung.ohneZeilen': 'Diese Buchung hat keine Zeilen.',
  'fehler.beleg.schonVerarbeitet': 'Dieser Beleg wurde bereits verarbeitet.',
  'fehler.beleg.summePasstNicht': 'Der Gesamtbetrag {gesamt} passt nicht zur Summe der Positionen ({positionen}).',
  'fehler.rechnung.schonBeglichen': 'Diese Rechnung ist bereits vollständig beglichen.',
  'fehler.rechnung.schonBeglichen': 'Diese Rechnung ist bereits vollständig beglichen.',
  'fehler.zahlung.mehrAlsOffen': 'Der Betrag ist höher als der offene Saldo von {offen}.',
  'fehler.zahlung.mehrAlsGuthaben': 'Der Betrag ist höher als das Guthaben von {guthaben}.',
  'fehler.rechnung.keinGuthaben': 'Auf dieser Rechnung gibt es kein Guthaben zum Zurückzahlen.',
  'fehler.rechnung.hatZahlungen': 'Auf diese Rechnung wurde bereits gezahlt. Storniere zuerst die Zahlung.',
  'fehler.rechnung.hatGutschriften': 'Zu dieser Rechnung gibt es Gutschriften. Storniere zuerst die Gutschriften.',
  'fehler.rechnung.ueberWareneingang': 'Die Rechnung liegt um {differenz} über dem Wareneingang. Zum Zahlen ausdrücklich bestätigen.',
  'fehler.rechnung.keineDebitorenrechnung': 'Das ist keine Ausgangsrechnung.',
  'fehler.rechnung.andererKunde': 'Diese Rechnung gehört zu einem anderen Kunden.',
  'fehler.sammelrechnung.zuWenige': 'Zum Zusammenfassen braucht es mindestens zwei Rechnungen.',
  'fehler.sammelrechnung.verschiedeneWaehrungen': 'Alle Rechnungen müssen dieselbe Währung haben.',
  'fehler.gutschrift.mehrAlsOffen': '{menge} lässt sich nicht gutschreiben - offen sind nur {offen}.',
  'fehler.gutschrift.ueberRechnungsbetrag': '{neu} plus die bisherigen {bisher} übersteigen den Rechnungsbetrag von {gesamt}.',
  'fehler.anzahlung.ohneRechnung': 'Ohne Rechnung lässt sich eine Anzahlung nicht anrechnen.',
  'fehler.anzahlung.ohneNamen': 'Es fehlt der Name, um wen es geht.',
  'fehler.mahnung.hoechsteStufe': 'Die höchste Mahnstufe ist bereits erreicht.',
  'fehler.waehrung.kursGebraucht': 'Für eine Rechnung in {waehrung} wird ein Umrechnungskurs gebraucht.',
  'fehler.waehrung.kursGebraucht': 'Für eine Rechnung in {waehrung} wird ein Umrechnungskurs gebraucht.',
  'fehler.waehrung.kursGebraucht': 'Für eine Rechnung in {waehrung} wird ein Umrechnungskurs gebraucht.',
  'fehler.waehrung.kursNurBeiFremdwaehrung': 'Ein Umrechnungskurs gehört nur zu einer Rechnung in Fremdwährung.',
  'fehler.waehrung.kursNurBeiFremdwaehrung': 'Ein Umrechnungskurs gehört nur zu einer Rechnung in Fremdwährung.',
  'fehler.waehrung.stillgelegt': 'Die Währung {waehrung} ist stillgelegt.',
  'fehler.waehrung.unbekannt': 'Die Währung {waehrung} ist nicht hinterlegt.',
  'fehler.waehrung.schonVorhanden': 'Diese Währung gibt es bereits.',
  'fehler.waehrung.keinKurs': 'Für {waehrung} gibt es zum {datum} keinen Kurs.',
  'fehler.waehrung.chfIstBasis': 'CHF ist die Basiswährung und hat keinen Umrechnungskurs.',
  'fehler.waehrung.chfNichtStilllegbar': 'CHF ist die Basiswährung und lässt sich nicht stilllegen.',
  'fehler.waehrung.kursdienstFehler': 'Der Kursdienst hat nicht geantwortet wie erwartet. Versuche es später nochmal.',
  'fehler.waehrung.kursdienstFehler': 'Der Kursdienst hat nicht geantwortet wie erwartet. Versuche es später nochmal.',
  'fehler.bankabgleich.waehrungenVerschieden': 'Eine Bankbewegung in {bank} passt nicht zu einer Rechnung in {rechnung}.',
  'fehler.bankabgleich.keineFremdwaehrung': 'Eine Rechnung in Fremdwährung lässt sich nicht über den Bankabgleich begleichen - zahle sie direkt mit einem Umrechnungskurs.',
  'fehler.kasse.ohneKonto': 'Für die Kasse ist kein Sachkonto hinterlegt.',
  'fehler.kasse.ohneKonto': 'Für die Kasse ist kein Sachkonto hinterlegt.',
  'fehler.kasse.ohneGegenkonto': 'Ein Kassaeintrag braucht ein Gegenkonto - Material, Porto oder Privatentnahme sind verschiedene Dinge.',
  'fehler.kasse.zuWenigBargeld': 'In der Kasse liegen nur {bestand} - {betrag} lassen sich nicht auszahlen.',
  'fehler.kasse.kuerzelVergeben': 'Dieses Kassenkürzel ist bereits vergeben.',
  'fehler.kontenrahmen.umstellungNichtMoeglich': 'Der Kontenrahmen lässt sich so nicht umstellen. Sieh dir die Vorschau an - sie nennt den Grund.',
  'fehler.anlage.restwertZuHoch': 'Der Restwert muss unter dem Anschaffungswert liegen.',
  'fehler.anlage.abschreibungssatzFehlt': 'Für die degressive Abschreibung wird ein Satz grösser als null gebraucht.',
  'fehler.anlage.schonAbgegangen': 'Dieses Anlagegut ist bereits abgegangen.',
  'fehler.firma.gleicheFirma': 'Quelle und Ziel müssen verschiedene Firmen sein.',
  'fehler.zahlungsbedingung.kuerzelVergeben': 'Dieses Kürzel für die Zahlungsbedingung ist bereits vergeben.',
  'fehler.profitcenter.kuerzelVergeben': 'Dieses Profitcenter-Kürzel ist bereits vergeben.',
  'fehler.abo.hatRechnungen': 'Aus dieser Vorlage sind bereits {anzahl} Rechnung(en) entstanden. Lege sie still, statt sie zu löschen.',
  'fehler.abo.stillgelegt': 'Diese Vorlage ist stillgelegt.',
  'fehler.abo.nochNichtFaellig': 'Diese Vorlage ist erst am {faellig} fällig. Zum vorzeitigen Erzeugen ausdrücklich bestätigen.',
  'fehler.abo.laufSchonVorhanden': 'Für den {datum} gibt es aus dieser Vorlage bereits einen Lauf.',
  'fehler.abo.ohneNaechstenTermin': 'Eine wiederkehrende Rechnung braucht einen nächsten Termin.',
  'fehler.auswertung.unbekannteQuelle': 'Diese Datenquelle gibt es nicht.',
  'fehler.auswertung.unbekanntesFeld': 'Dieses Feld gibt es in dieser Auswertung nicht.',
  'fehler.auswertung.unbekanntesFeld': 'Dieses Feld gibt es in dieser Auswertung nicht.',
  'fehler.auswertung.vergleichNichtErlaubt': 'Dieser Vergleich passt nicht zu diesem Feld.',
  'fehler.auswertung.gruppierungNichtMoeglich': 'Danach lässt sich nicht gruppieren.',
  'fehler.auswertung.nichtAusfuehrbar': 'Diese Auswertung liess sich mit den gewählten Filtern nicht ausführen.',
  'fehler.mail.nichtEingerichtet': 'Der Mailversand ist nicht eingerichtet. Trage ihn unter Einstellungen → Firma ein.',
  'fehler.mail.ohneAbsender': 'Für den Mailversand fehlt die Absenderadresse.',
  'fehler.mail.versandGescheitert': 'Die Mail liess sich nicht versenden. Prüfe die Mail-Einstellungen.',
  'fehler.ebics.nichtEingerichtet': 'Die Bankanbindung ist nicht eingerichtet.',
  'fehler.ebics.ohneHauptschluessel': 'Für die Bankanbindung fehlt der Hauptschlüssel. Ohne ihn lassen sich keine Bankschlüssel sicher ablegen.',
  'fehler.ebics.ohneHauptschluessel': 'Für die Bankanbindung fehlt der Hauptschlüssel. Ohne ihn lassen sich keine Bankschlüssel sicher ablegen.',
  'fehler.ebics.ohneHauptschluessel': 'Für die Bankanbindung fehlt der Hauptschlüssel. Ohne ihn lassen sich keine Bankschlüssel sicher ablegen.',
  'fehler.ebics.hauptschluesselFalscheLaenge': 'Der Hauptschlüssel der Bankanbindung hat die falsche Länge - es müssen genau 32 Byte sein.',
  'fehler.ebics.schluesselUnlesbar': 'Der gespeicherte Bankschlüssel lässt sich nicht lesen.',
  'fehler.ebics.versionUngueltig': 'Für die Bankanbindung ist nur H004 oder H005 möglich.',
  'fehler.ebics.nochNichtBereit': 'Die Bankanbindung ist noch nicht bereit. Erst die Schlüssel einreichen, von der Bank freischalten lassen und den Bankschlüssel abholen.',
  'fehler.ebics.schluesselFehlen': 'Erzeuge zuerst die Schlüssel für die Bankanbindung.',
  'fehler.ebics.angabenUnvollstaendig': 'Die Angaben zur Bankanbindung sind unvollständig - Adresse, Host-, Partner- und Benutzerkennung werden alle gebraucht.',

  'fehler.tarifimport.keinBetrag': '{wo}: "{wert}" ist kein Betrag.',
  'fehler.tarifimport.keinSteuersatz': '{wo}: "{wert}" ist kein Steuersatz.',
  'fehler.tarifimport.satzAusserhalb': '{wo}: Der Steuersatz {wert} liegt ausserhalb von 0 bis 100.',
  'fehler.tarifimport.keinKanton': '{wo}: "{wert}" ist kein Kantonskürzel.',
  'fehler.tarifimport.keinTarifcode': '{wo}: "{wert}" ist kein Tarifcode - erwartet wird etwa A0N oder B2Y.',
  'fehler.tarifimport.keinJahr': '{wo}: "{wert}" ist kein Gültigkeitsjahr.',
  'fehler.import.keineZeilen': 'Diese Datei enthält keine Datenzeilen.',
  'fehler.import.spalteFehlt': 'Die Spalte {spalte} fehlt. Gefunden wurden: {gefunden}.',
  'fehler.tarifimport.keineSaetze': 'In dieser Datei wurden keine Tarifsätze gefunden. Stimmen die Feldgrenzen?',
  'fehler.tarifimport.mitBefunden': 'Der Tarif hat {anzahl} Befunde und wurde NICHT übernommen. Sieh dir die Vorschau an.',
  'fehler.quellensteuer.keinSatzFuerEinkommen': 'Für ein Monatseinkommen von {einkommen} ist in diesem Tarif kein Satz hinterlegt.',
  'fehler.quellensteuer.keinTarif': 'Für {kanton}/{tarif}/{jahr} ist kein Quellensteuertarif hinterlegt. Importiere ihn, bevor der Lohnlauf startet.',
  'fehler.zulage.keinAnsatz': 'Für {kanton}/{jahr} ist kein Ansatz für Familienzulagen hinterlegt. Trage ihn ein, bevor der Lohnlauf startet.',
  'fehler.abwesenheitsart.nochVerwendet': '"{art}" wird noch verwendet ({antraege} Anträge). Lege sie still, statt sie zu löschen - sonst wären die alten Anträge nicht mehr lesbar.',
  'fehler.abwesenheitsart.grundbestand': '"{art}" gehört zum Grundbestand und lässt sich nicht löschen. Stilllegen geht.',
  'fehler.antrag.schonVorhandenMitZeitraum': 'Für diesen Zeitraum gibt es bereits einen Antrag ({von} bis {bis}, {status}).',
  'fehler.ferien.guthabenReichtNicht': 'Das Guthaben {jahr} reicht nicht: {beantragt} Tage beantragt, {verfuegbar} verfügbar.',
  'fehler.farbe.unbekannt': 'Diese Farbe gibt es nicht. Erlaubt sind: {erlaubt}.',
  'fehler.lohn.schonStorniert': 'Dieser Lohnlauf ist bereits storniert.',
  'fehler.monat.geschlossen': 'Der Monat {monat}/{jahr} ist {zustand} und damit geschlossen. Zeiten lassen sich darin nicht mehr ändern.',

  'fehler.monat.falscherZustand': 'Der Monat ist {zustand} - daran lässt sich jetzt nichts mehr ändern.',

  /* ---- Stempeluhr, Verknuepfung und der Schalter der Firma ---- */

  'hr.employees.col.konto': 'Konto',
  'hr.employees.action.link': 'Konto',
  'hr.employees.link.title': 'Konto mit der Personalakte verbinden',
  'hr.employees.link.hinweis': 'Welches Anmeldekonto gehört zu {name}? Ohne diese Verbindung kann die Person ihre Zeit, ihre Ferien und ihre Abrechnung nicht selbst sehen.',
  'hr.employees.link.konto': 'Anmeldekonto',
  'hr.employees.link.keins': 'Kein Konto',
  'hr.employees.link.belegt': 'gehört schon zu jemandem',
  'hr.employees.link.loesen': 'Verbindung lösen',
  'hr.employees.link.ja': 'verbunden',
  'hr.employees.link.nein': 'offen',

  'platform.provisioning.step.adminEmployee': 'Personalakte des ersten Kontos',

  'stempel.title': 'Stempeluhr',
  'stempel.bereit': 'Bereit. Ein Klick auf Start, und die Zeit läuft.',
  'stempel.seit': 'seit {zeit}',
  'stempel.pauseGesamt': '{minuten} min Pause',
  'stempel.pausiert': 'pausiert',
  'stempel.start': 'Start',
  'stempel.pause': 'Pause',
  'stempel.weiter': 'Weiter',
  'stempel.stopp': 'Stopp',
  'stempel.vergessen': 'Diese Stempelung läuft seit mehr als {stunden} Stunden. Sie wird nicht von selbst geschlossen - beim Stopp wird nach der richtigen Endzeit gefragt.',
  'stempel.korrektur.title': 'Wann hast du aufgehört?',
  'stempel.korrektur.hinweis': 'Begonnen am {datum} um {zeit}. Eine Endzeit zu raten wäre schlechter als zu fragen - sie stünde danach dauerhaft in deiner Arbeitszeit.',
  'stempel.korrektur.ende': 'Ende',

  'settings.nav.zeit': 'Zeiterfassung',
  'settings.zeit.title': 'Wie erfasst diese Firma ihre Zeit?',
  'settings.zeit.intro': 'Du entscheidest, welche Wege deine Mitarbeitenden für die EIGENE Zeit haben. Korrigieren kann das Personalwesen in jedem Fall - sonst liesse sich ein vergessener Stempel nie mehr richtigstellen.',
  'settings.zeit.beides': 'Beides',
  'settings.zeit.beides.desc': 'Stempeluhr und Nachtragen von Hand. Passt, wenn nicht alle am Bildschirm sitzen, wenn die Arbeit beginnt.',
  'settings.zeit.nurStempel': 'Nur Stempeluhr',
  'settings.zeit.nurStempel.desc': 'Start, Pause, Stopp - sonst nichts. Wer nachträglich Stunden tippen kann, kann sie auch erfinden.',
  'settings.zeit.nurManuell': 'Nur von Hand',
  'settings.zeit.nurManuell.desc': 'Die Schicht wird eingetragen, nicht gestempelt. Passt für Aussendienst und Baustelle.',
  'settings.zeit.maxStunden': 'Ab wann gilt eine Stempelung als vergessen?',
  'settings.zeit.maxStunden.hint': 'Stunden. Danach wird sie nicht geschlossen, sondern beim Stopp nach der Endzeit gefragt.',
  'settings.zeit.gespeichert': 'Gespeichert.',

  'fehler.person.kontoSchonVerknuepft': 'Dieses Konto gehört bereits zu einer anderen Personalakte. Löse dort zuerst die Verbindung.',
  'fehler.zeit.stempeluhrAus': 'Diese Firma erfasst die Zeit von Hand. Die Stempeluhr ist abgeschaltet.',
  'fehler.zeit.handerfassungAus': 'Diese Firma erfasst die Zeit mit der Stempeluhr. Von Hand eintragen kann nur das Personalwesen.',
  'fehler.zeit.stempelungLaeuftSchon': 'Es läuft schon eine Stempelung. Vielleicht auf einem anderen Gerät.',
  'fehler.zeit.keineStempelungOffen': 'Es läuft gerade keine Stempelung.',
  'fehler.zeit.pauseLaeuftSchon': 'Die Pause läuft bereits.',
  'fehler.zeit.keinePauseOffen': 'Es läuft gerade keine Pause.',
  'fehler.zeit.stempelZuLang': 'Diese Stempelung läuft seit mehr als {stunden} Stunden. Trage die richtige Endzeit ein - geraten wird sie nicht.',
  'fehler.zeit.stempelZuKurz': 'Weniger als eine Minute ist keine Schicht.',
  'fehler.zeit.endeVorBeginn': 'Das Ende liegt vor dem Beginn.',
  'fehler.zeit.endeInDerZukunft': 'Das Ende liegt in der Zukunft.',
  'fehler.zeit.endeUnlesbar': 'Diese Endzeit ist nicht lesbar.',
  'fehler.zeit.zeitzoneUnbekannt': 'Die Zeitzone {zone} ist unbekannt.',
  'fehler.einstellung.fehlt': 'Die Einstellungen dieser Firma fehlen. Die Anlage ist nicht auf Stand.',

  /* Die Suche findet unter "Zeit" drei Seiten. Diese Halbsaetze sagen,
     welche gemeint ist - vorher stand darunter nur der englische Pfad. */
  'nav.myTime.hint': 'die eigene Arbeitszeit stempeln oder nachtragen',
  'nav.time.hint': 'die Arbeitszeit aller Mitarbeitenden ansehen und korrigieren',
  'nav.projectsTime.hint': 'Stunden auf einen Auftrag buchen, für die Verrechnung',

};
